var _style, _g, _polygon, _polygon2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path2, _path3, _g2, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g4, _path17, _path18, _path19, _defs, _g5, _g6, _g7, _g8, _rect14, _text, _g9, _g10, _path20, _path21, _path22, _path23, _circle, _g11, _path24, _text2, _rect15, _text3, _path25, _g12, _circle2, _g13, _text4, _g14, _circle3, _g15, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect16, _text5, _g16, _g17, _path35, _path36, _g18, _g19, _g20, _path37, _path38, _text6, _g21, _path39, _text7, _g22, _path40, _text8, _g23, _g24, _circle4, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g25, _g26, _path52, _g27, _g28, _polygon8, _g29, _g30, _g31, _g32, _path53, _g33, _g34, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g35, _path65, _path66, _circle5, _text9, _g36, _path67, _circle6, _text10, _circle7, _path68;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileApPdevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.45;fill:#222B45;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:#1761B0;}\r\n\t.st4{opacity:0.35;fill:url(#SVGID_3_);}\r\n\t.st5{fill:#AF0C15;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:url(#SVGID_4_);}\r\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:1.3806;stroke-miterlimit:10;}\r\n\t.st9{opacity:0.45;fill:url(#SVGID_5_);}\r\n\t.st10{fill:url(#SVGID_6_);}\r\n\t.st11{opacity:0.45;}\r\n\t.st12{fill:url(#SVGID_7_);}\r\n\t.st13{fill:url(#SVGID_8_);}\r\n\t.st14{fill:url(#SVGID_9_);}\r\n\t.st15{opacity:0.45;fill:#FFFFFF;}\r\n\t.st16{fill:url(#SVGID_10_);}\r\n\t.st17{fill:url(#SVGID_11_);}\r\n\t.st18{fill:none;stroke:#FFFFFF;stroke-width:1.2389;stroke-miterlimit:10;}\r\n\t.st19{opacity:0.45;fill:url(#SVGID_12_);}\r\n\t.st20{fill:url(#SVGID_13_);}\r\n\t.st21{fill:url(#SVGID_14_);}\r\n\t.st22{opacity:0.35;fill:#222B45;}\r\n\t.st23{opacity:0.75;}\r\n\t.st24{fill:#222B45;}\r\n\t.st25{opacity:0.75;fill:#222B45;}\r\n\t.st26{fill:url(#SVGID_15_);}\r\n\t.st27{fill:url(#SVGID_16_);}\r\n\t.st28{fill:url(#SVGID_17_);}\r\n\t.st29{fill:none;stroke:url(#SVGID_18_);stroke-width:1.812;stroke-miterlimit:10;}\r\n\t.st30{fill:url(#SVGID_19_);}\r\n\t.st31{fill:url(#SVGID_20_);}\r\n\t.st32{fill:url(#SVGID_21_);}\r\n\t.st33{fill:url(#SVGID_22_);}\r\n\t.st34{fill:url(#SVGID_23_);}\r\n\t.st35{fill:url(#SVGID_24_);}\r\n\t.st36{fill:url(#SVGID_25_);}\r\n\t.st37{fill:url(#SVGID_26_);}\r\n\t.st38{fill:url(#SVGID_27_);}\r\n\t.st39{fill:none;stroke:url(#SVGID_28_);stroke-width:1.812;stroke-miterlimit:10;}\r\n\t.st40{fill:url(#SVGID_29_);}\r\n\t.st41{fill:url(#SVGID_30_);}\r\n\t.st42{fill:url(#SVGID_31_);}\r\n\t.st43{fill:url(#SVGID_32_);}\r\n\t.st44{fill:url(#SVGID_33_);}\r\n\t.st45{fill:url(#SVGID_34_);}\r\n\t.st46{fill:url(#SVGID_35_);}\r\n\t.st47{fill:url(#SVGID_36_);}\r\n\t.st48{fill:url(#SVGID_37_);}\r\n\t.st49{fill:url(#SVGID_38_);}\r\n\t.st50{fill:url(#SVGID_39_);}\r\n\t.st51{opacity:0.6;}\r\n\t.st52{opacity:0.5;}\r\n\t.st53{fill:url(#SVGID_40_);}\r\n\t.st54{fill:url(#SVGID_41_);}\r\n\t.st55{fill:url(#SVGID_42_);}\r\n\t.st56{fill:url(#SVGID_43_);}\r\n\t.st57{fill:url(#SVGID_44_);}\r\n\t.st58{fill:url(#SVGID_45_);}\r\n\t.st59{fill:url(#SVGID_46_);}\r\n\t.st60{fill:url(#SVGID_47_);}\r\n\t.st61{fill:url(#SVGID_48_);}\r\n\t.st62{fill:url(#SVGID_49_);}\r\n\t.st63{fill:url(#SVGID_50_);}\r\n\t.st64{fill:url(#SVGID_51_);}\r\n\t.st65{fill:url(#SVGID_52_);}\r\n\t.st66{fill:#B3B3B3;}\r\n\t.st67{font-family:'Montserrat-Bold';}\r\n\t.st68{font-size:8.9796px;}\r\n\t.st69{fill:url(#SVGID_53_);}\r\n\t.st70{fill:url(#SVGID_54_);}\r\n\t.st71{fill:url(#SVGID_55_);}\r\n\t.st72{clip-path:url(#SVGID_57_);fill:url(#SVGID_58_);}\r\n\t.st73{opacity:0.57;clip-path:url(#SVGID_57_);}\r\n\t.st74{fill:none;}\r\n\t.st75{font-family:'Montserrat-SemiBold';}\r\n\t.st76{font-size:4.9488px;}\r\n\t.st77{font-size:8.1174px;}\r\n\t.st78{fill:url(#SVGID_59_);}\r\n\t.st79{fill:url(#SVGID_60_);}\r\n\t.st80{fill:url(#SVGID_61_);}\r\n\t.st81{fill:url(#SVGID_62_);}\r\n\t.st82{fill:url(#SVGID_63_);}\r\n\t.st83{fill:url(#SVGID_64_);}\r\n\t.st84{font-size:7.4801px;}\r\n\t.st85{fill:url(#SVGID_65_);}\r\n\t.st86{fill:url(#SVGID_66_);}\r\n\t.st87{font-size:8.0271px;}\r\n\t.st88{fill:url(#SVGID_67_);}\r\n\t.st89{fill:url(#SVGID_68_);}\r\n\t.st90{fill:url(#SVGID_69_);}\r\n\t.st91{fill:url(#SVGID_70_);}\r\n\t.st92{fill:url(#SVGID_71_);}\r\n\t.st93{fill:url(#SVGID_72_);}\r\n\t.st94{fill:url(#SVGID_73_);}\r\n\t.st95{fill:url(#SVGID_74_);}\r\n\t.st96{fill:url(#SVGID_75_);}\r\n\t.st97{fill:url(#SVGID_76_);}\r\n\t.st98{fill:url(#SVGID_77_);}\r\n\t.st99{fill:url(#SVGID_78_);}\r\n\t.st100{fill:url(#SVGID_79_);}\r\n\t.st101{fill:url(#SVGID_80_);}\r\n\t.st102{fill:#DBDCE0;}\r\n\t.st103{fill:url(#SVGID_81_);}\r\n\t.st104{font-family:'Montserrat-ExtraBold';}\r\n\t.st105{font-size:9.4255px;}\r\n\t.st106{fill:url(#SVGID_82_);}\r\n\t.st107{fill:url(#SVGID_83_);}\r\n\t.st108{fill:#939396;}\r\n\t.st109{fill:#00D0FF;}\r\n\t.st110{fill:url(#SVGID_84_);}\r\n\t.st111{fill:url(#SVGID_85_);}\r\n\t.st112{fill:url(#SVGID_86_);}\r\n\t.st113{fill:url(#SVGID_87_);}\r\n\t.st114{fill:url(#SVGID_88_);}\r\n\t.st115{fill:url(#SVGID_89_);}\r\n\t.st116{fill:url(#SVGID_90_);}\r\n\t.st117{fill:url(#SVGID_91_);}\r\n\t.st118{fill:url(#SVGID_92_);}\r\n\t.st119{fill:url(#SVGID_93_);}\r\n\t.st120{fill:url(#SVGID_94_);}\r\n\t.st121{fill:url(#SVGID_95_);}\r\n\t.st122{fill:url(#SVGID_96_);}\r\n\t.st123{fill:url(#SVGID_97_);}\r\n\t.st124{fill:url(#SVGID_98_);}\r\n\t.st125{fill:url(#SVGID_99_);}\r\n\t.st126{font-size:8.7719px;}\r\n\t.st127{fill:url(#SVGID_100_);}\r\n\t.st128{font-size:10.2306px;}\r\n\t.st129{fill:url(#SVGID_101_);}\r\n\t.st130{font-size:9.2181px;}\r\n\t.st131{fill:none;stroke:#B3B3B3;stroke-width:0.4184;stroke-miterlimit:10;}\r\n\t.st132{fill:url(#SVGID_102_);}\r\n\t.st133{opacity:0.34;fill:none;stroke:#282D41;stroke-width:0.4105;stroke-miterlimit:10;}\r\n\t.st134{fill:url(#SVGID_103_);}\r\n\t.st135{fill:url(#SVGID_104_);}\r\n\t.st136{fill:url(#SVGID_105_);}\r\n\t.st137{fill:url(#SVGID_106_);}\r\n\t.st138{fill:url(#SVGID_107_);}\r\n\t.st139{fill:url(#SVGID_108_);}\r\n\t.st140{fill:url(#SVGID_109_);}\r\n\t.st141{fill:url(#SVGID_110_);}\r\n\t.st142{fill:url(#SVGID_111_);}\r\n\t.st143{fill:url(#SVGID_112_);}\r\n\t.st144{fill:url(#SVGID_113_);}\r\n\t.st145{fill:url(#SVGID_114_);}\r\n\t.st146{fill:url(#SVGID_115_);}\r\n\t.st147{fill:url(#SVGID_116_);}\r\n\t.st148{font-size:12.8467px;}\r\n\t.st149{fill:url(#SVGID_117_);}\r\n\t.st150{fill:url(#SVGID_118_);}\r\n\t.st151{font-size:12.9591px;}\r\n\t.st152{fill:url(#SVGID_119_);}\r\n\t.st153{fill:#78A4EB;}\r\n\t.st154{fill:none;stroke:#78A4EB;stroke-width:0.5558;stroke-miterlimit:10;}\r\n\t.st155{fill:#171717;}\r\n\t.st156{fill:#444444;}\r\n\t.st157{fill:#0C3580;}\r\n\t.st158{fill:none;stroke:#92E8C2;stroke-width:1.197;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st159{fill:none;stroke:#8DCBFC;stroke-width:1.197;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st160{fill:#395188;}\r\n\t.st161{fill:#92E8C2;}\r\n\t.st162{fill:none;stroke:#111111;stroke-width:1.2551;stroke-miterlimit:10;}\r\n\t.st163{opacity:0.05;fill:#FFFFFF;}\r\n\t.st164{opacity:0.15;fill:#FFFFFF;}\r\n\t.st165{opacity:0.5;fill:#FFFFFF;}\r\n\t.st166{fill:url(#SVGID_120_);}\r\n\t.st167{fill:url(#SVGID_121_);}\r\n\t.st168{fill:none;stroke:#FFFFFF;stroke-width:0.8074;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st169{fill:none;stroke:#333333;stroke-width:1.1556;stroke-miterlimit:10;}\r\n\t.st170{fill:#606060;}\r\n\t.st171{fill:url(#SVGID_122_);}\r\n\t.st172{fill:url(#SVGID_123_);}\r\n\t.st173{fill:url(#SVGID_124_);}\r\n\t.st174{fill:url(#SVGID_125_);}\r\n\t.st175{fill:url(#SVGID_126_);}\r\n\t.st176{fill:url(#SVGID_127_);}\r\n\t.st177{fill:none;stroke:#282D41;stroke-width:0.5558;stroke-miterlimit:10;}\r\n\t.st178{fill:none;stroke:#FFFFFF;stroke-width:0.7109;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st179{fill:#455C9A;}\r\n\t.st180{fill:#DA8F48;}\r\n\t.st181{fill:none;stroke:#DD6309;stroke-width:1.1544;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st182{fill:none;stroke:#FFFFFF;stroke-width:1.3043;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st183{fill:#8D78B2;}\r\n\t.st184{fill:none;stroke:#374FA6;stroke-width:0.8264;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st185{fill:none;stroke:#FFFFFF;stroke-width:0.5558;stroke-miterlimit:10;}\r\n\t.st186{fill:#1E0032;}\r\n\t.st187{fill:none;stroke:#AE6FFA;stroke-width:1.6717;stroke-miterlimit:10;stroke-dasharray:3.3435,3.3435;}\r\n\t.st188{fill:#C1C7D6;}\r\n\t.st189{fill:#DDE4F0;}\r\n\t.st190{fill:#A5A9B7;}\r\n\t.st191{fill:#182246;}\r\n\t.st192{fill:#D25A2C;}\r\n\t.st193{fill:#69B884;}\r\n\t.st194{fill:#CB2376;}\r\n\t.st195{fill:#66A8DE;}\r\n\t.st196{fill:#3359D0;}\r\n\t.st197{fill:#E4E9FB;}\r\n\t.st198{fill:#BFC9E8;}\r\n\t.st199{fill:none;stroke:#3B68F5;stroke-width:0.8359;stroke-miterlimit:10;stroke-dasharray:3.3435,3.3435;}\r\n\t.st200{fill:#78C9DD;}\r\n\t.st201{fill:#E7AD47;}\r\n\t.st202{fill:#263A81;}\r\n\t.st203{fill:#233471;}\r\n\t.st204{fill:none;stroke:#3B68F5;stroke-width:0.8359;stroke-miterlimit:10;}\r\n\t.st205{fill:none;stroke:#3B68F5;stroke-width:0.8359;stroke-miterlimit:10;stroke-dasharray:3.3006,3.3006;}\r\n\t.st206{fill:none;stroke:#3B68F5;stroke-width:0.8359;stroke-miterlimit:10;stroke-dasharray:3.2024,3.2024;}\r\n\t.st207{fill:#C4373B;}\r\n\t.st208{fill:#EABD68;}\r\n\t.st209{fill:#157224;}\r\n\t.st210{fill:#E58F36;}\r\n\t.st211{fill:none;stroke:#AE6FFA;stroke-width:1.545;stroke-miterlimit:10;stroke-dasharray:3.09,3.09;}\r\n\t.st212{fill:url(#SVGID_128_);}\r\n\t.st213{fill:url(#SVGID_129_);}\r\n\t.st214{fill:none;stroke:#92E8C2;stroke-width:1.1063;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st215{fill:none;stroke:#8DCBFC;stroke-width:1.1063;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st216{fill:none;stroke:#FFFFFF;stroke-width:0.657;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st217{fill:none;stroke:#DD6309;stroke-width:1.0669;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st218{fill:none;stroke:#FFFFFF;stroke-width:1.2054;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st219{fill:none;stroke:#374FA6;stroke-width:0.7638;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st220{fill:none;stroke:#282D41;stroke-width:0.5137;stroke-miterlimit:10;}\r\n\t.st221{fill:none;stroke:#FFFFFF;stroke-width:0.5137;stroke-miterlimit:10;}\r\n\t.st222{fill:#D1EBF8;}\r\n\t.st223{opacity:0.5;fill:#E0D7E8;}\r\n\t.st224{opacity:0.58;fill:url(#SVGID_130_);}\r\n\t.st225{opacity:0.58;fill:url(#SVGID_131_);}\r\n\t.st226{opacity:0.58;fill:url(#SVGID_132_);}\r\n\t.st227{fill:#E7E4FC;}\r\n\t.st228{fill:#BFD0FC;}\r\n\t.st229{fill:url(#SVGID_133_);}\r\n\t.st230{fill:#F1F1F1;}\r\n\t.st231{fill:#777777;}\r\n\t.st232{fill:#E9EDFD;}\r\n\t.st233{fill:#333333;}\r\n\t.st234{fill:#69B9EF;}\r\n\t.st235{fill-rule:evenodd;clip-rule:evenodd;fill:#69B9EF;}\r\n\t.st236{fill-rule:evenodd;clip-rule:evenodd;fill:#E9B34D;}\r\n\t.st237{fill:#497DB3;}\r\n\t.st238{fill:#D05433;}\r\n\t.st239{fill:#A52B31;}\r\n\t.st240{fill:#F7EC41;}\r\n\t.st241{fill:#90D677;}\r\n\t.st242{fill:#E9A42B;}\r\n\t.st243{fill:#5752B6;}\r\n\t.st244{fill:#625DB5;}\r\n\t.st245{fill:#E1E5FD;}\r\n\t.st246{fill:#353389;}\r\n\t.st247{fill:#C4E6F1;}\r\n\t.st248{fill:#B92F14;}\r\n\t.st249{fill:#D7D5F7;}\r\n\t.st250{opacity:0.28;}\r\n\t.st251{fill:#221B22;}\r\n\t.st252{fill:#564C54;}\r\n\t.st253{fill:#EDE0C3;}\r\n\t.st254{fill:#F77659;}\r\n\t.st255{fill:#E33D15;}\r\n\t.st256{fill:#F0F0F0;}\r\n\t.st257{fill:#EBB12B;}\r\n\t.st258{fill:#D38400;}\r\n\t.st259{fill:#3639D9;}\r\n\t.st260{fill:#4B71F8;}\r\n\t.st261{fill:url(#SVGID_134_);}\r\n\t.st262{fill:url(#SVGID_135_);}\r\n\t.st263{fill:url(#SVGID_136_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -799.7023,
    y1: 10.5517,
    x2: -799.7023,
    y2: 395.8407,
    gradientTransform: "matrix(0.4041 0.5247 -0.887 0.6831 849.2276 418.1155)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0812,
    style: {
      stopColor: "#F9FBFD",
      stopOpacity: 0.1013
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1869,
    style: {
      stopColor: "#E9F0F8",
      stopOpacity: 0.2332
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#CEDEEE",
      stopOpacity: 0.3819
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4352,
    style: {
      stopColor: "#A9C4E2",
      stopOpacity: 0.5429
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5723,
    style: {
      stopColor: "#78A3D1",
      stopOpacity: 0.7139
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    style: {
      stopColor: "#3F7CBE",
      stopOpacity: 0.8906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#1761B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "472.63,2.28 174.09,232.2 261.76,239.45 472.63,77.04  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -577.9021,
    y1: 105.2551,
    x2: -577.9021,
    y2: 452.0799,
    gradientTransform: "matrix(0.4041 0.5247 -0.887 0.6831 849.2276 418.1155)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0812,
    style: {
      stopColor: "#F9FBFD",
      stopOpacity: 0.1013
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1869,
    style: {
      stopColor: "#E9F0F8",
      stopOpacity: 0.2332
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#CEDEEE",
      stopOpacity: 0.3819
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4352,
    style: {
      stopColor: "#A9C4E2",
      stopOpacity: 0.5429
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5723,
    style: {
      stopColor: "#78A3D1",
      stopOpacity: 0.7139
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    style: {
      stopColor: "#3F7CBE",
      stopOpacity: 0.8906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#1761B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "511.29,157.91 212.75,387.83 300.41,395.08 511.29,232.68  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -703.6799,
    y1: 235.9066,
    x2: -703.6799,
    y2: 608.3139,
    gradientTransform: "matrix(0.4256 0.5526 -0.887 0.6831 853.8523 423.9862)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    style: {
      stopColor: "#1761B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6592,
    style: {
      stopColor: "#76A2D0",
      stopOpacity: 0.6358
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#C0D4EA",
      stopOpacity: 0.3283
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9412,
    style: {
      stopColor: "#EEF3F9",
      stopOpacity: 0.1096
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    points: "4.44,503.59 354.58,233.93 323.39,168.07 4.44,413.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.813,
    y1: 512.9648,
    x2: 329.813,
    y2: 75.0559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5070FF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2129,
    style: {
      stopColor: "#437FFF",
      stopOpacity: 0.3703
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6206,
    style: {
      stopColor: "#23A6FF",
      stopOpacity: 0.6964
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D0FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_4_)",
      strokeWidth: 1.812,
      strokeMiterlimit: 10
    },
    d: "M412.93,512.06H246.7 c-11.33,0-20.51-9.18-20.51-20.51V97.28c0-11.77,9.54-21.32,21.32-21.32h164.62c11.77,0,21.32,9.54,21.32,21.32v394.27 C433.44,502.88,424.26,512.06,412.93,512.06z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.9112,
    y1: 383.1406,
    x2: 434.9112,
    y2: 509.0574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 426.45,
    y: 376.46,
    style: {
      fill: "url(#SVGID_5_)"
    },
    width: 16.91,
    height: 7.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.9112,
    y1: 383.1406,
    x2: 434.9112,
    y2: 509.0574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 426.45,
    y: 389.25,
    className: "st10",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.9112,
    y1: 383.1407,
    x2: 434.9112,
    y2: 509.0575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 426.45,
    y: 402.04,
    className: "st12",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.9112,
    y1: 383.1406,
    x2: 434.9112,
    y2: 509.0574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 426.45,
    y: 414.82,
    className: "st13",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.9112,
    y1: 383.1406,
    x2: 434.9112,
    y2: 509.0575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 426.45,
    y: 427.61,
    className: "st14",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.9112,
    y1: 383.1407,
    x2: 434.9112,
    y2: 509.0575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 426.45,
    y: 440.4,
    className: "st16",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.9112,
    y1: 383.1407,
    x2: 434.9112,
    y2: 509.0575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 426.45,
    y: 453.18,
    className: "st17",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.9112,
    y1: 383.1408,
    x2: 434.9112,
    y2: 509.0576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 426.45,
    y: 465.97,
    style: {
      fill: "url(#SVGID_12_)"
    },
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.15,
    y1: 323.9867,
    x2: 442.15,
    y2: 377.4652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M457.17,336.54h-0.7c-2.06,0-3.08-2.49-1.63-3.94l0.49-0.49c0.9-0.9,0.9-2.36,0-3.26l-1.86-1.86 c-0.9-0.9-2.36-0.9-3.26,0l-0.49,0.49c-1.45,1.45-3.94,0.42-3.94-1.63v-0.7c0-1.27-1.03-2.31-2.31-2.31h-2.63 c-1.27,0-2.31,1.03-2.31,2.31v0.7c0,2.06-2.49,3.08-3.94,1.63l-0.49-0.49c-0.9-0.9-2.36-0.9-3.26,0l-1.86,1.86 c-0.9,0.9-0.9,2.36,0,3.26l0.49,0.49c1.45,1.45,0.42,3.94-1.63,3.94h-0.7c-1.27,0-2.31,1.03-2.31,2.31v2.63 c0,1.27,1.03,2.31,2.31,2.31h0.7c2.06,0,3.08,2.49,1.63,3.94l-0.49,0.49c-0.9,0.9-0.9,2.36,0,3.26l1.86,1.86 c0.9,0.9,2.36,0.9,3.26,0l0.49-0.49c1.45-1.45,3.94-0.42,3.94,1.63v0.7c0,1.27,1.03,2.31,2.31,2.31h2.63 c1.27,0,2.31-1.03,2.31-2.31v-0.7c0-2.06,2.49-3.08,3.94-1.63l0.49,0.49c0.9,0.9,2.36,0.9,3.26,0l1.86-1.86 c0.9-0.9,0.9-2.36,0-3.26l-0.49-0.49c-1.45-1.45-0.42-3.94,1.63-3.94h0.7c1.27,0,2.31-1.03,2.31-2.31v-2.63 C459.47,337.57,458.44,336.54,457.17,336.54z M442.15,346.33c-3.41,0-6.17-2.76-6.17-6.17c0-3.41,2.76-6.17,6.17-6.17 s6.17,2.76,6.17,6.17C448.32,343.57,445.56,346.33,442.15,346.33z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.1056,
    y1: 471.892,
    x2: 163.1056,
    y2: 33.983
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5070FF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2129,
    style: {
      stopColor: "#437FFF",
      stopOpacity: 0.3703
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6206,
    style: {
      stopColor: "#23A6FF",
      stopOpacity: 0.6964
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D0FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_14_)",
      strokeWidth: 1.812,
      strokeMiterlimit: 10
    },
    d: "M246.22,470.99H79.99 c-11.33,0-20.51-9.18-20.51-20.51V56.21c0-11.77,9.54-21.32,21.32-21.32h164.62c11.77,0,21.32,9.54,21.32,21.32v394.27 C266.73,461.8,257.55,470.99,246.22,470.99z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.679,
    y1: 57.8923,
    x2: 38.679,
    y2: 183.8091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.22,
    y: 51.21,
    className: "st26",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.679,
    y1: 57.8923,
    x2: 38.679,
    y2: 183.8091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30.22,
    y: 64,
    className: "st27",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.679,
    y1: 57.8922,
    x2: 38.679,
    y2: 183.809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 30.22,
    y: 76.79,
    className: "st28",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.679,
    y1: 57.8923,
    x2: 38.679,
    y2: 183.8091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.22,
    y: 89.57,
    style: {
      fill: "url(#SVGID_18_)"
    },
    width: 16.91,
    height: 7.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.679,
    y1: 57.8923,
    x2: 38.679,
    y2: 183.8091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 30.22,
    y: 102.36,
    className: "st30",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.679,
    y1: 57.8922,
    x2: 38.679,
    y2: 183.8091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30.22,
    y: 115.15,
    className: "st31",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.679,
    y1: 57.8924,
    x2: 38.679,
    y2: 183.8092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30.22,
    y: 127.94,
    className: "st32",
    width: 16.91,
    height: 7.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.679,
    y1: 57.8925,
    x2: 38.679,
    y2: 183.8093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 30.22,
    y: 140.72,
    className: "st33",
    width: 16.91,
    height: 7.84
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.1913,
    y1: 450.4479,
    x2: 117.1913,
    y2: 506.519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M132.94,463.61h-0.73c-2.16,0-3.23-2.61-1.71-4.13l0.52-0.52c0.94-0.94,0.94-2.48,0-3.42l-1.95-1.95 c-0.94-0.94-2.48-0.94-3.42,0l-0.52,0.52c-1.52,1.52-4.13,0.44-4.13-1.71v-0.73c0-1.34-1.08-2.42-2.42-2.42h-2.76 c-1.34,0-2.42,1.08-2.42,2.42v0.73c0,2.16-2.61,3.23-4.13,1.71l-0.52-0.52c-0.94-0.94-2.48-0.94-3.42,0l-1.95,1.95 c-0.94,0.94-0.94,2.48,0,3.42l0.52,0.52c1.52,1.52,0.44,4.13-1.71,4.13h-0.73c-1.34,0-2.42,1.08-2.42,2.42v2.76 c0,1.34,1.08,2.42,2.42,2.42h0.73c2.15,0,3.23,2.61,1.71,4.13l-0.52,0.52c-0.94,0.94-0.94,2.48,0,3.42l1.95,1.95 c0.94,0.94,2.48,0.94,3.42,0l0.52-0.52c1.52-1.52,4.13-0.44,4.13,1.71v0.73c0,1.34,1.08,2.42,2.42,2.42h2.76 c1.34,0,2.42-1.08,2.42-2.42v-0.73c0-2.16,2.61-3.23,4.13-1.71l0.52,0.52c0.94,0.94,2.48,0.94,3.42,0l1.95-1.95 c0.94-0.94,0.94-2.48,0-3.42l-0.52-0.52c-1.52-1.52-0.44-4.13,1.71-4.13h0.73c1.34,0,2.42-1.08,2.42-2.42v-2.76 C135.36,464.69,134.27,463.61,132.94,463.61z M117.19,473.88c-3.57,0-6.47-2.9-6.47-6.47c0-3.57,2.9-6.47,6.47-6.47 c3.57,0,6.47,2.9,6.47,6.47C123.66,470.98,120.76,473.88,117.19,473.88z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 251.2914,
    y1: -3.7678,
    x2: 251.2914,
    y2: 385.2516
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5C5C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1806,
    style: {
      stopColor: "#3C3C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5755,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7808,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M334.41,489.11H168.17c-11.33,0-20.51-9.18-20.51-20.51V74.33c0-11.77,9.54-21.32,21.32-21.32H333.6 c11.77,0,21.32,9.54,21.32,21.32V468.6C354.92,479.92,345.74,489.11,334.41,489.11z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.29,61.64h-26.27v5.94c0,5.07-4.11,9.18-9.18,9.18h-83.12c-5.07,0-9.18-4.11-9.18-9.18v-5.94h-26.27 c-9.34,0-16.91,7.57-16.91,16.91V461.4c0,9.34,7.57,16.91,16.91,16.91h154c9.34,0,16.91-7.57,16.91-16.91V78.56 C345.2,69.22,337.63,61.64,328.29,61.64z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 169.3855,
    cy: 216.6396,
    r: 142.8988,
    gradientTransform: "matrix(1.208 0 0 1.7218 -0.9242 -140.6416)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M333.6,53.01H173.28l181.64,391.35V74.33C354.92,62.55,345.37,53.01,333.6,53.01z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st51"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 955,
    height: 438,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA74AAAG6CAYAAAAvcJo+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAVZ5JREFUeNrs3cuPZMeV53k7Zvf6 Ix6ZGSwGqzQlCRC7i9MgMb0RaidgOH8EZ93r+SeU/CdmP9thr2db1KqAbmgxGCjRrSoQqhK79AiJ kZnxcvd7zc6cY3bdIyKT1Iv5zu+n6qZ7RHh4CsEMc/v5MTsWAgAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAeJsIPwKA3ykAAPBKUX4EAJN04BX6vfm616VPb/9e3ecHBgAAvsFT 84Qf658wZScYAwRf4Hn8nujTwXb7QvWzD+WTJ77h5OQBv1sAAODPcnz84a1A+5n/8dEn9rlPb4Tk J4OxEIQBgi/wbX4v9Dro3r8dcE9Ojutjzs5+LuGHIaxOj+rH6/Nf3/qd+rvw7/lpAgCAP+ifwj/f +nh+8Dd1ErI4el/DT38aDg8/mCYlP6nh+FYgvhWGd9MQgjBA8AW+6Xfh64Ouh9ybAdfD7Xh1KN9Z 70v4bgib1VKG9ankzZnYq1E4tu8Z1mc3frfe5acLAAC+we929/r5oZ6EOvkIaXao/fzIJif/FmaL I52fXOiXy7+2j/+5BuPFF6faAvHNMPxAvyYIE4IBgi/49/902P345IEF3e9Y0P2hBd0v5PjkIq6P 92WzOrWAu5R37i7k6nwTx4OZ5KGXg+FS8l4veezsWkmxK4SDsFys+P0CAAB/kqvVok5KYjfW29QN mi6X6rdXe33pzjfa9Yf6cL7W9GhlofhKD//qg/Llb650fnCui6NTDT8N4fDwV/q5L5kmBAMEX/Bv vo37T4fd1fte0T2Q44f/LW7e3ZfV4ijeW89lNV/H5eUQN7MxDqscZ/0iFgu6sy7HccixzJL0Q7Hb jZSc7O9YBC0Dv18AAOBPm6DE3iYnqxBTr3FTdOhjiSnb/aybWSzdmEpKo67HrswWXbka+pL6QRfr eTm7+6j0D6909rsLPbn3H0oNwrUi/HUhmOXQIPgCb/i/9RvV3U++Luyex4vDVTxcDHF1eRiXcw+6 y9iF8zSsF7GLIY0pR4u1aQiSutFCr9itvS7lscS+i5Lt9UntVkuU3l9RdJx+x3r+CwAAgCcMbZIi nQ41/BaVsWhK8zL4rU8yyliy3doUpIx5KP08ZH/PfdSQPQwv9kNej1dltrEwvO7LYu+snK36sn+2 KCf3Dp4OwZ9ZCKYKDIIv8KYG3lbd/eRnH0rds/vBz+XRL9fx+OEYN+/+nSzkt8nD7iw9TqsYU1cD bUwbWaYUQhIdLM5KGspot7MULfxm+3z0r4m96kiKKWosHnztM6r2YC31lv8EAADgD05WbMaQJdqE JYdYpHgAzhZ5o0rRLmT/XLGgW+wBKdiXpvsz6cZs93NY5Zk9xVhKHu12YbebfCd7CF7pe3n2u3/S k3tdufu9eTn8+Qd6fHyinz1dBSYAg+ALvCmB9+T4JH7//EB+2/0y+TLmg/NN7KOki7LuPOxG7TuZ D52Urtuo5d8udqLZPo5dKNpbzLWPS2dPX29L6Hxds0XdkIq9FkWx4GthVy0lhyn0qgVgv038NwEA AJO8C72xBU5/u7zUWYQWuyf+UbLQa8FWLex6KlaJY6q3OoYxjn6rXvwVy7tjN878No6jrvuxyDB6 CN6P83GwHH1+MCuL1Wl5b/xe/teDcz0+OS4EYBB8gTcw8HqTqrPDd6NXdy9iTDOJSXLfxTL4Zt1O x9Jr0t5ybh8sAdvLSq8xtfseev2+3dqLTL0VC7+WajtJKUnZBt8YtYZfrcE3tleP9nsW+Y8DAAAm 5XriUloCrqHXA2/RUkQs+LZ8nMVvPeRmGf02RBlCLu3WL0u5UvIQ0nQ/jYNku+3ioJvRN2SNmoZx oyXvl5K9Cnx49rtycrxfCMAg+AKvZeA19z+Vrw+8JfWxpLN81cVF14VN7oOF3RJlNot2KzKzV5xZ CmFmL0AzC8LzaB/XbhNiH4cyC/bK0YJwsNtgwTf00oq5SVvl1yu+Mdqrlmr93yQ18XoQBgAAuDV7 EW0J2ENv8Eqvv3Ou9a7GWuWN2wpvaKHXvmK3FmrVQ2+x27ixZ9jYnGQjSTf2+I2l5Y1NRDY2Kdls Shxi0U2wEBxmaSircTxMy3Eo0QJw/IYAzB5gEHyBVzj0bptWPR14JZ93UtZdWPadDvM+y3rmQTdr mncWarNayA0yLyUsYipze+GpoVf985Is9IZ6BSmzqN520cKvhV71qq8H3qD2NNKqvRZ+pYZekV3g rdnX7/MrBwAAbKLgobfcDMDTejG7sT+LTRnqEmeZqr72WQu8Fl6DBV8LvTbrsLCrfoTExlLyRiSu 7VnX9lRrzdFuy7oEXSf7/Gih2CZDaw/CSecb6ddDuBpGjfNR08H4ZAD+3ALwdRMswi8IvsArFngf yNkH35FHv/xevNv9Mi2kS318J4V81eXewu5qNcsx1MAbky4swM5z0YW9cCzs5WZRxG/TItitvXDM RbPdppm9Bs2DB18LyFLDb7DQ68FXOo3S7Sq+xQK2r272hUr1jdsbFd/6v5aqLwAA2GZfmcJkq/iq h2GNJUzLne2PutS5BV/f4ysWeD38hhp+JcQafO2bN7vA67cWdu25Vyp5FettWGmRVYqyKh6Gs6xq AC4WhheLTRosBNcK8Fd5pWN+NH4v3/3eL8vhz5/sAk0ABsEXeKmh9xMLvV98cRofvbeOxwd/Ex9b CO2Hiy7leRf63C+HeT/oMM+a56lPcymdhdtxmYMs7bVmaQl1aS86S4lx4R/bMy/s1Wdhf8HcXkTm vvy5Bt8SZrGGXuktJHvg9Wpvrfhqq/pGP4jA3691t36/blR+AQDAW+5WpffGbEHbPl/7goVePx4i FJtd7Kq+9tFoDxhtmjHYNGiowTda8PWKr4oF32ABOKzsayv7/JWWsrLJx5U945V/nIJeBe2uNI6r POR1krTupV9feQV4SENO63Ho98c79nednP+63P3tvLz//lH5jPALgi/wsv7d3n9qWfNXs5SWyWu5 udd16UO/6DsdfQ3P3D9rLxseapdigddeR/Zs3N4Lkpb2YrHXwq9dejP4eqU31iqvSrHwK3V5c7DQ 612dW9ht1V6PtPYCZbnYlzcHaeuXblZ4pb6BS/AFAAAefLUtb741U5gKv558fRJRwvWV/ZgIm1+M oYXgVvm18Ot7fdX3+IYyVX6n4CsWdkOoodemJZdBs30slzYZudQagO3rSa+8AtxJXo/SrcOwGmQe B1ml4SqX/M4m56eXP99Xwi8IvsBz//d6vbT5hzeqvHF9ZmP2oiuz3GeJbTnzqAspFnjFA69dGvc8 8NoLwL5F1j3xWwu99rR74Tr4LuyVplZ77UVhLjXs6rS8WVqFVyzo+lWmW6/jql0SWpW3Bt+bv1vb AMyvGwAA2M0PttMbvfEprTOJds/vl3rpVAEOMnV5rscbjaFdw3RtQl32HNbSgu/Kg28NuEEvbS50 aTOSi5D10sLxhQfgIMUCsYdgvVJfCt1Ny6C1bOImDZpWY5kfjtvq70/fPyosfcbrquNHgNcq9N7/ VD7+PMSzo1P5/eEs3cnLtPF/x7rswzz3fennOY9zibLUHJc2wPu1bwnVQm/Yt1eMA0up+6qyby8g eyLSKr9eBVZZiO/ztdAbfC+vepfn0I4t8quG3FrtjcFP1mv121j/t0mt+Eqt+Ep9GbgRfWUKv7w2 AACAW9MbvZWDW+gNteJ7HYCL1n1UtU48VYBbALa72R452ixjrNVfCRtvdmXPs7bvWNm8xgKw1kqv evhVsdCrF0XkwiYu5zZ9uchiQVg9EFtAFp3lolcS+249H9dhWHqgjnv53vj7w5x/eHQaDj8O+vnH n5Zwvy7JFsIvXqMwAbzqPDTe7th8J4Tke3nj5dAfTlVer/AOqV/IGJZdV/ZK8YAb9i3cHtjrRbsN 4aBWei0E27Na4A17YoHXBnqv+M6Dbvf0tq7N9rnOvq81r9J2XNEUdr1Pc5wG/KmJlbTfp2335id+ u5TfNwAAcD0J1ycnCm22sA3DrdPz9JXtVba39pWy6/gc9Hr5c/CjjtTCr6ztc97o6ko9AIfgAffS bi+0VnzDuc2Pzm2ec9Fuw0WMcjGO8VK7cNXnoVaAvfp7tklD2esH3/tr86/8NZ2fCb8g+ALf/jXh 9tLmu908deN+53t5PfD2ZZwPeb6wgXvZhbxncdQCb7KgGw7speDQBvcDCRZ6pVjojRZ4tQbf4Eub gy7tL1nYi8I8SDuyaGpa5aE33bha2K1LmmUKurW8O+3lvRF29cnfK37NAADAN9Enpw1641Pqe39L m1xM4VenJlhP7AG+vnzP7yjT2b6hdnv2Zc9S9/x68LXvtvBb7Dae2192bpOZ85DkTL0KLPlCSrgY Q7q0v+iqT+vVELu1B2Df+zt2F+OjcZ1Z+ozXDUud8cqH3o8/vr20Oc+zZd1NvxgOZrkri3Gw8Nrr Xhdkr2QLuaXz5cyHRfXQBvtDkXhgg/qh+PLmFnr3auhV+z6xwOtNrERr86qbnZrtr5+WM7fKrv2v iW0hs+6WM+uN/bvazjH64y9oAAAAfyAHt+29MtWAt/d1O93QaY1Z2QZh7wLtS6L97N/Q3sT3vb8+ v6l7f+37FxZiveeJB9+lPYWveNurt63pp590sYj1cd286DjrUujHoP04pC70fUpjjKtwHjXN4t56 Odxa+vz5p2X638HSZ7zK4QJ4RUPvtJ/35PjDW0ub95LMRh3nqZst6uBddD+WfOBLmW3EP7R8aoE3 35F6Xw9V5cCrv7WpVd3PW48wsu+Vtpe3Vne1r/t4d9VdteArsR5M1IKu1N02152aZfen/qHfI37F AADAn5B2//QHXC+F3nWBthir9Wa7/3eqAuvoS5/DrvmVrlWnplfe4VnCRavy6rl9fGZPdWZTIJty lbNo930JdInpXKJc+PfkcbPqpFtfZt3cXvr8oHz+sf2d96n8guAL/Bn/Ju8/tZ83ruddma/7TV7P +9LNbQxfqqa9UsK+hHIoFnb90qh3bKitV63y+nJnC772rG1pczuuyAPvNvS2Cq/6rTessrDrld0Q ngy78vTvzPau8nsEAACe19RIvyEg6/Xt1xyFpFMIll3357GFX9/3a9d03FHwxlYWfGsAtvBrn3/s lxR5rBaA2xXPYgwXIvkyaH81xHE9S/O1zc8Gm5+NT+/75cgjvHoSPwK8OqYGUVPo/XL5/6WDMnhb hT7PutlmGBYphWXZjPsp2pey3Ikh3JUk9yyrHtn3H9l4/44Ns+/YwH0k4p+Xe/asdyzBHrYA3Do4 h7qvN9R9vcErvuJNrGLdzyvhZgOrmm6nW9l2rJInLgAAgOeWfJ++plYjtz8fw/VkJdq8RqYTKFq/ Et0dw9jZfKirxzTarYp0fnyjzZtqMUDrCRbTti+bG0m05yohel9pe1IZh1Fin8LGI3Syp79chVge h5P0b+E/PvqB/uLv90N48JF98R/s+pT/eiD4Ak8P6iKfWOhdfnEa7937t5S7H6Sw6PpxczXv+rLo i+8/ifvSR29a5YH3bvBwK3Jkg/E7NrQfeej1sGtB1z9/15730J74QIN4sysPvb48ulV769m8LfS2 FwJ/hXgy9H5t2AUAAHhFwvDTIVhaCVh2Ry/W5pw3QnAQD8EWciXd6G/STcc2tnAcxbd9tRMtPPNa ANasUSz0xlGk95XUaZTNuAmydzcsyrHeS/893P1yCD/60ffDgwf/2Z7mc/5LgeAL3B682/JmD73v vbeO/yPf69JB6C2pzkpIiyDjXpG0b8PuYdRy1wbhezaIH9mAbUHXw65uq7x2BQ/Ed2ywPgx1b6/u e+OGaYnzzL5vVsNuHdTbi4Bcv1Mar19ECLsAAOB1C8G3A3Cd28QbK9h2zTtt/mP3vcJbj27UGoY9 6PrHndScoC0k+5GOqh5+W++TKJJr1s4hxkVYpqhDN4aHV134zuGFfmnh91cWflvll/ALgi8wDc4a wicn0Zc3e6XXQ2/cy/1Sy3y1Gf3Iob1U/AxeC7JF79pwe88DblB9J0g8ikGPgodeX9bsS58l3PGm VsGPLJK2rFlELfRKXda8PZf3RoVXviHwAgAAvIYh+PZ8Rnar2DyyyvWb/VJProhtbuS9TlrFV9UX Mbf5UrTHqESbM5Xojyze1DO3YxxT8c3EJQzjGOZhDGOfw+PNXg2/390te/6/tR5NCRB88daHXu/e /ODD6Ht6fXmzV3o99K7HsJiFbk+SHEjUO1H1rg2/dWmzhPhO8OXNEo7Ewq8HXhusLfRKC7xB9lro VQu9bR+vjdOd1Hcuw9ctaSbwAgCANzkAT0ug6/wr6lQAsLlTWwLdblsl2LeAiaa2rTd6Vdg3DPv9 6Gdd1Hta2kYx+7bOplebUtQrv7q30ItyrCfpv7c9v//p/wrh87rflzkWCL54W/m7hRZ6gx9ZtB+9 kZXv6fXlzV7p9dBbku6HEu6EIl7pPRL1Sq+HXq/2qu/nPQpe5Q1yx24t9Eo9p1e1HlnkS5v7UPes bJfsCIEXAAC81QHY4+qNKvCuAuyV3rqnt82XkoSpElzDsLa9whqjqLYAXWKb0aWg2/C713V12fOi DPr4btGPHpyEX/ziJ4FmVyD44u0OvR9fn9Pr3Zu9kVXd0xu0Vno99GqUu9EbV4l3bq5V3ndkCr1S lzbLtLRZ2pFFdWmzV3l1qvJuA6/GNs4TeAEAwFscgGU7F6vBdTrKUbfV3yn4ttB743OpLo2Wtly6 No32xdLeQ6u08OtHKeUimq8utS9LXcySnu4fh4/eI/yC4Iu3dvBtxxb91Xe7uLdadn5Orx9Z5N2b vZGV7+n15c1e6fXQW9SrvdGrvH/lgddG6HvBm1j5mb0hHNh1u2NzrfRuQ++2wivyRNdDAACAtzcA 32qCdXOOdGuFXLRIWxtiiVpIrpHXq79eANa6f8xPDZZYNBZvgzVq1/eq3V7phl5nXQ5X3+30V+97 sys6PYPgi7dqwG3NrH74xWn8/fks6b4n3lzP6fUji7x7szey8j29vrzZK70t9JZ37Du9yuuf88B7 x8bo/RZ6w8K+NpewO6LoG6q8SuAFAADMx76++ivT0UeiN3ui1Kqv13ejd3X2CrHNrlRabyyv9Kp/ g2ZLv/aYkrKWjVpanhd9bE/+6Jcl/LvfXEydnml2hZcj8iPAizU1szo5lkfvreOdWUrxcug3eV3P 6i0h7dmQeiCqdzRG37tbjy26Dr3+sR9VpL68uVZ6bditlV6pDay2obe24G9VXt2+e0noBQAAmOZk MgXdqdqrU5MrP+Io9NL6pMynedZenXf5/MvmYdNJGnV+5vO0+rHP2+zrPo/z+ZzP63x+5/M8n+/5 vM/nfz4PrPNB4AWj4osXqQ6sH99sZjWPs6V08xTSomzGfenjgZ/T60cWBZkaWUnY7uc9qqHXjzWq ld7pqKK6vFnafl652bjq1lIeAAAAfP387OZ8qa6V03ojtcLbvhZl6okl02NEd9/iTaK1tHZXWjRK 0XXWPvbFErSW2aBLkSeaXX3OTx4EX7ypg+r9W/t6vZlVyXlmw+kipbKXYjoI2Y8kauf0tiOLtDay ant6by5v1rq82W5r6LX7N/fzsrQZAADg24TfW12gt+E3XG8hk1jbQE/faVnXt//6bl+7spauiznI WMZSShhK2Ta7ut7v+xHhFwRfvImD6dP7evu4mc10fx76uGdfPihZ7kiSu3Vpsx9XVM/pnY4s8kZW NfT68uZW6bXnnHkDqzB1bd6eMRduDdQAAAD40+Zr18HX5lXTQrrdUmjZNQqVaZn0NitL3eZr/1eT cAkpZpvXFXtokdSXmc5LmW/0PPaF/b54WdjjixfA93E8va83S5xtuuL7RpalhH3xI4k03NHgZ/Ym X+581+8HP59Xb3Zu9irv7dAbWuhlaTMAAMC3DsCeabf7ftuZvm3e5fOvutqu7ftt87PDNncLbf4W ahHjjs/rfH7n8zyf7/m876n9voH9vnhxqPjiRQye8sknH8q/7F+md2YHKSy6fk+GWdS81EH3bTw9 lJDvSpK2rzeEd2LQI6nn9m7P6Q27RlbbPb03Q29gaTMAAMAzDb/hqZ4pbZlzPbs3tGzcVj7XQ4Bt ElaKepXXlzxHX/ZsH4eYwziUPuay6ELRvYXemR2U0/3L8PFHx/qAI47wgnT8CPB8B01f4vyZfPHF aTw+nMXhTumCLvvcx9k4dgvpdS/mfODh14bMO6q+pLnUdws1qAViOVDV+m5h8M7Nuq30KqEXAADg ualLm7XdtnOLWnXWAm5d0lw/KHa32Oey3RntK6N9elSNgwXiwb5jkJKH3KdxyN3Y9WUMq7FEuSrH j6N+cbbR8MmHJXxWl0hv/wKA4IvXbsAMbYlzkC/feycOeZnu5FkX5hZ7x7CwAXHZBdkLUg5CiIfq LfJjuCPeJl/l0MZSu8K2e/PcgvDMRsTOnjVJbR9YbixvJvQCAAA8r/A7zbvCNA/TloilePgNfoRv vWyGJ2GwR2/ssxv7eGMP2XR2O9rn46hj6HOW9SJ/Ncvl8r21fnzyQD9vS56V3Wog+OJ11EauTz6U s6NTOT49iuV8k8os933p50OSRZfHvZJDrfZK1DsWfO/aIHnXsuyd0qq9u9Br1zb0dvW0dG2Lawi9 AAAAzz/8brs8+zzMImo3bc6dteAr2W6zzd8s34YxFLXwGwb7jo0W2YScN/YNw5D6oS86ltmQlyXm /YO/KWffm5dwfCThs1ZODlR98ZzQ3ArPa5AMfkB5bWj1y+/FxyEkXeTa0Gos41zGsLT4ui/S1Wqv N0Gol5/RG8KBRdppebNum1n1oQ2yHnrjLlgTegEAAF5A+K285Bun+VhX52dtnlablU7zt4M6n9vN 7eKhz/fqvM/mfz4P9Pmgzwt9fujzxNro6j6NrvB80dwKz0NraHXcGlodlN90oqWPG51r3y18326X wmHReNcS7JFKeUdU3rHPH9lo6g2ubJBUC8Cyp1oHUX83sbdnTdO/WY4rAgAAeOHzuxv35fpz0w5d nfYAF7vry6BrFdg+zDHIaHl57JKOKpI1St3rG2QoSznVx3eLWvil0RWeKyq+eA682hvCycmxHJ9c xIV0KeV5F/pFH0ddyCjLUnTfBsiDaUnzoTeysqHzwEbN/aCyZ9fCBs65PcbfSbxxbNGt7oIAAAB4 sdl3OxebjjnSrs3XZF7nbz6P8/mczeumRqWHdb7n8z6f/9k80OeDPi/0+aHPE32+eFKrvtM8EngO qPjiOYyI19Xeku6mZZr3m24970tZ2li2r97B2Y8pKuEoiB9bFPy6Z99nV9gG4GmZc+g1iC9xTlNH Qfb1AgAAvLx53nTbtv3qrvjrnxX7sHZ8rk2vbNbWqr4hjDbvG+0Lgz1oiFrGFErOveZluJvP+oPy +O4jqr54rqj44hl7stpbUshX3XKY96OmuQfatrdXDmy4PBCJB6pyYGPngfpB6CEsVXWh9dii2nyt dnAO01lx099B6AUAAHg5c71pkbNs/5wqv6Hz+ZvP4+p8zud1Pr+zq873bN4XY9wPXdyT2C18Xujz Q58nLuS3VH3x3FHxxbP0VLW3L2cznS3mQ97sSWeBN8hhDPGuDYr3JMQjFX2nVnsl3JWghxrEH7MU 8UYJddlMNy2lubHMGQAAAC93znfrbm1M1dbliW/w9f/3T2Sv+urU7dnmf0MMMoRQRpvdjRZFRumH 3D1V9f1IQz3iCHh2qPjiGXq62itl3eXVapY1z0OWZdDoDaumim85EF/6rFMHZ5WF+NFFbZ9IZ6Nl av9GyxR6Gf8AAABeoewr0zwttnmbdD6Pq/O52q+lVn33xCu/UfajxGneJ0spuhh1nOsw78+mqu/3 zw+kVn0JvSD44lUf/T752YdycnwSzw7fjX0sKSz7LscwS70vc/ZlL2WvWOBVP7JIbfCrbe/VBkUL vrsq73aJs95Y4sy+XgAAgFfHdLTvbsmz7pY81/mcz+ss/KrP86KF3+LLnm0OGNWDrzfAWkY/7FLW s7jouosY02+7X6azD34u4ZMPOdoIzxxLnfEMg6/Ie+99GN/VGHP6TX9Zwqwrs8UouhdDd2APuONL nGPQIz+6SGtDq3DXrjvi3f+CN7TydwjDzD6eqr0scQYAAHh153/Xd2+cbeR/+JLn0pY6B1/aPHhz qxjiRoNsit1Pdr9IP2jOYxf389VsXi5+90j/46N/1V/84ieBJld4lqj44hmxoeyTD8XfpfN36/xd O3/3rr6Ll3QRZKzV3pBkTyX60ubt5ef0Lmrg3VZ7xZfLaBSOLgIAAHgdsm/d3queLaT2ZqlVX4vC 3qx04av+vMprH9ctb6rZjzta5qIL3w5n6XgmedXZhDAdH/xNPDv7joRPfkbVF88UFV88oxFP5OP3 TuLJ5SyFveNuqbkPY7SBzqu96SB7VTd4Qys5skHsnj28VXtVp2qv7/Hd7u8NNLQCAAB4jZLv9q6E Ka9K/dNyrhb7XKv61sZWurEvbmyOuJEQN1Fl02kZtC+5iylfPFqV4TuH5ePwEUcb4Zmi4otnoDW1 8nfnjh+O8eB8EyX3XRhLnzXN/d28UHwPb7Jwq/XdvlCPLtKlhV6v9LajiyQke6rUdvUq1V4AAIDX J/vW+Zuv2vPVezan62yu542uZl7cEK/8Bt3TOg/UPZ8bStRFTkOt+upQ+otx1S1TTBe3jjYCno2O HwGeiZ99KKv3bZhb/U+yLI9TLkM3xn5mo93MhsCFjYN+Pu8Ueu1WazXYB0ALvrJraDUNlFF3iZeG VgAAAK+2Ol9TnVYBSu3yXFqX57aVbR78fF+RhXizU5sXiq/2s/AbJc5V0ky6dd/LQVrPY/yr7rfx 7Ds/F59f7p4W+Jao+OLbqi3nPz55IOvzA/FW9Bdl3cms62bRK75lLurv8BXfy7uc9nh4B2c/vmiq 9mrf3hX0fSFTb0CqvQAAAK/XlPBW1Ve2XZ57i8V2ydymeXVOGKY5oX1+ISUskshMx76PedPNRNNq cRQf/XIdP6nP+ynb3kDwxavg5jLn87i6PIydSNKx9N6owEa9eRFdSIzewMq7Nvu7fK2ZlXjolb69 G6hJfF+vtjaA03MzyAEAALwec0KZZobSAnCYgq9675a65FlVbf53PSf08FuSzRU1z0Pqet8mZw9O vm3uu1eHwnJnPEssdca3Ny1zHh6t4r5sUtFFp6n0GmSmJSxiTIugupwGuYXUpc86V+/gt1viLLtO zrqr9tLJDwAA4PUh2wA8zefUt69Z+C295WCbG7Ylz201YFiotnlhCWkewjCLs9Rd5XWn8/04dr+N geXOeIao+OJbjm7Xy5wPF0NcWcqV+dBp7nob5WYxlXndyyu1lf1Cp6OLboTeusRZpw7OVHsBAABe V7v5m9ScoeJFDV/VV5c8S1Cf/83ss3V+6M2tPAT7fDFlX+5c+k5CmsnjNKyXsjo9kk9up2qA4IuX 5P52mfN/2y1zltJ1FmX7YgNbUZlrsEund/Xaeb1tX29rdpDaMufdsUXs7QUAAHht7aZyfrJRtPnf dK6v+gketeprn5vmh3ZZCI6+DNrnh0l7KckmkpIOF3fj8ba7c9vnCxB88bJoXeYcfvjDsHl3X5bz IXYxpo2mLmTtdSzz6JVdzTXwSlAb5NQHO29r30KvH1+kEtuhb1R7AQAAXvP5oZ/gu5vTSWty1cKv zf9sbtj7qR429WuXtvlhiKn3+aPo0A3rRVzN13F9vC9nZz+f9vmyBQ7fDnt88a348pMHp19IWBzF NHYxj2OSrnRapI9aZkXL3PLtLEqxwBtnNhLWzn5TF+d6fJF623u9Pu2cgQ0AAOC1J63HVZ3j+dFG 3tOlU62r/qZGV74S0E/58IaoeVa6WSehdN0QUroc4lW8047L/NkRE0R8a1R88S0Gs09rtz1fhnJv PZcunKfk+zg016XOQWIf/Vy2sGtkNQuqMwu5nUXdFNoy5yi1wqu0qgcAAHhTponX29i2y52nDs+1 ANJbJJ55tdfnh7HUhqgz9YpvGTspQ3dlk8jV4iquz3/NPl8QfPEybY8x+rn4MhRfjuLLUnx5ipTY hVIru22/xnSplJnv7fB3+9rg5//+RFjmDAAA8EbNE+Xmfak9rrbhN9S9vjUAyzRH9LmixD7EYqE4 dYOENO/GWljZHWvEPl8QfPHS1P29IWxWp7K89P29IUWv5Fro9X0aGkodyGoALtOZvdpCr2oLvto6 /k0DGeMZAADAG6Qtd1aNoc39km5P9VAPvDIVSmzOKHnmc8jR5ooWk9P6UhL7fEHwxSvBl514m3lv N7+ZjXFMOQ5l7EKSWvENJfZBSl3iHNu+3j5MXf1sCPQBMLa+fyxzBgAAeOMy73SrbX2faJv7pVoI kdBF1VksOquVX6/42nzRe8V4IWXWz6MXVrzA4oWWdp4vQPDFCx/J2nIT33fxzt2FDKsck3jFd5ZE S6fiVV/to7ZBzAY4u61t7L25QevuJ/JE4GWZMwAAwJs1Z6xL+6QWPGRa7uxzQi+ISLQ5Y50j9qH4 fNFvpfNCykZWyQsrX3OeL0DwxYvl+y3Gq0O5Ot/EWb+IQ5AUW7CdKr5+VpvWQaz4ABekBV/VaX+v yu6cNwAAALxBbhU0ZCp4bPf53gi/oRVKvDFqlM4LKF5I6VMfvbDiBRYvtLSn+ZRVgiD44gW7326+ s96X8WBWG/B1Y465dnUunXjIje28Nl/OYiNUpz7IlXaEkXdzDu3dP/b3AgAAvLmmQoe24OsdnqdC SS2MqLZCiVd8vXAS2h5fL6h4YcULLOOuwRVA8MUL1RoL1EYD3w0hD73MuhxHkWT/oFIJnVd1a+i1 XNtprA2tOmnn9u66Ocv2bDeGMQAAgDcy805Tx+15vrEWQEptcpWkNrmSViiJoRZOvIDihRQvqHhh xQssXmipz3OfnygIvnjRdh2dl3IwXMo45NjFEkVGH8SSpFRvQxvUpjN7t6G3DX66XQKjuwZXAAAA ePOy71TwmJY7y25+WAskXihpqwS18wKKF1K8oOKFFS+weKGlFlymiSNA8MULc93R+VTyXi9lliSP JRbf5uuDWdmGXm3HF21DbzvAvO3vJewCAAC8wXS3rU2vT/G4tdf3ZqFkWzjxQooXVLyw4gUWL7TQ 2RkEX7xUeXNmgbeTfiix76LFXo0l5ORXW8IiUUvxABy1LW+ZKr3bBn+EXwAAgLciBN/c52u3Gm4X Srxw4gUUL6TUgooXVvb6WmihszMIvnjRdkG1dtg7Pg55XEmZbSRnC712RfEr1pb1avdF/Pgiids9 vdNtO9KcDb4AAABvduRtRY86DdTpVF8viNTCSC2QSA3B2+KJF1K8oOKFFS+weKGFnyIIvngJPt0N Psd2FQ++OYnaAKXJBjS1ywKv3Vrw9Xf1/HPTUpdtF2fVGx2dAQAA8KaSIOH6HI+bhRCpBZJWKAm1 cOIFFC+k1IKKF1ZsnumFlusjjaanAQi+eBFOTh7UAWdY+ztwB3ZvEbTEFnpjC7r2kb+t5yFYpDVx ru/wtcDLeAUAAPDWqAWQG41NfY5YCyFeMAlTwaQWTlohpYu1sOIFluNbT/Qpk0j8RTp+BPi2louV DJskfYo2nhUpIbbBrC1mFpmaGfjSljpSMVwBAAC8haSFXtnOEaf5ofoHKsWDcJxWDxb/el+/qxVa doUX2jrjL0LFF3+xvwv//tbHqmMdqK7/Yen0zt4fa2BFEgYAAHgbcu/10b46LXluIVhrFbjWSyRZ 6vXIq2UQL7DwgwPBFy/H/ZsfvPvUl73q26q98Y/8M2McAwAAePPT7h9yXSiJu7mkB+Hx1jc+WXAB CL54ifo/8i+MoAsAAEAA/rrJop9y5Pt+y9c88Eah5T4/SRB88VoPegAAAGBOuNXzIwLBF68z+hEA AAAAIPjitTU8/alC6AUAAMCT/ti8cOBHBIIvXrL7Nz/43VNfrueQ19GsfF36JQgDAAAQdJ+YJ5Z6 2JHPI59+zO++YR4KEHzxAvxT+OcnAm9Xe/BdD2H1VLbap+AvGwgBAADwZgbe3QxyN18suzml93Xu 9A/NOwGCL164q9VCJfbqC1Kyv0tXT2KTehKbN6TXNuCpbAOwknUBAADeygw8zQGneaFXTLQdYBSm OaSqzyd9XunzS59n8oMDwRcvzfHxh3UQ6ueH02C0ssGp2P0cpLTT14r623UWeDX6Z9pg5v/XAjE/ RAAAgLct+Upo80FtZJov+rxRvHAyzSPbvHJl33O+m29u558AwRcvyI93g86J/yPqRo2pVxmLRVwp dbCyYaueRq7tnTu5FXpDXcOyuw8AAIA3W63oTqv/pM0JRVphxP70+WOp80f/OGubV6assVvoyTfM QwGCL56n3WAzP/gbDSdtKIqboinNi787V2zQsj89+JbgA5hdwevA0wKXXbm33mHsAgAAeLMnj9eL /bROBf2POiUsqi3w2kd1/ujzyJikJLviZqbJgq/PN+u882vmo8CfquNHgG8jzQ5tQBp0iLOiow1V KZboQTcGX6iSg2hWH9RCsCAcio92be+v1BFw2t8h/CQBAADeTDLN+8K250udD0qbH0bJNlP0eWKW kLI9JmdPwD6v7PvSdaP6fDPzY8S3RMUXf5HP7Focva/9/EjT5bIuRUldC72aQvbNvu3SeutLWELr U++3GqZ3+/hJAgAAvBXxd3vSx3Y+WMNuqPNFGetttEtDjppLnVdubH55OdT55uLoVD/jhwiCL164 jz7R8NOf2p1/C17x9YEp+ltznQ9WbRCL9Z27dvlAdnOgCze7PO8GQwAAALxRYXfq6bLt4jxdPhec Qu/1rebcbrXLY4ml61M57/d0triyeafPPx8wXwTBFy90ELPr03B4+IENREd6tdeXzSyW7O/MFV+2 oi3sio5tUGsf1/ttD0cd9Eq9ESq/AAAAb6qps8u0p7eFXt0F3tFmhqNl49Gml0MQGWMYs6Xi3Knm zZhK6gcNX4Y677yehwIEX7xg85ML7c432vnAlGMp24Gshl4ZbXgbt8tXgp9wZHlXZFvx5VgjAACA Nz31TlVfX+rsodd7wbQiiQXfOmf00Ft8zqijShyTfW3sUvGTQ3ye+av5RXui+/xEQfDFi1YHnp+E L5d/rV1/qCmNOuahlFrpjaNmmQayONgAN4bi92WUIG3J87Tc+fpIIwIwAADAG5l+22LnaX+vzQXr tjgdo/p8UQabHw6WSuyy2+DtUkPug+bNsCrLg1nplmd6fHzCZBEEX7wMP9Z2iPg/h4fzta7HrvTz kJMNUmmq+KqH3WnpispU9Q0h70JvmM72JfUCAAC8YeT28UM6LXNuu918+5sXSbxAMhQpQygWgFUG L6AU3fhm39wvUvnq0UqvjzL6MfNGEHzxQtUBxzvr+UCUbECaLboybJc6e6XX37ETu7Tdit/3fRx1 v693pNftXt9vGiABAADw2s8ZRaczLOtZvaFtgauFEZs3Dva1TdC4CbG0im/WsY/d2OVUZhsvrFzR 0RkEX7xkH32iiy9O1Qekq6Evo4VeX+ocxjjavdHftZOoG1EbyPySOriNrZmBZLnR4Tmw3xcAAODN yrzOcq9M29xs7tdW/9VeMGrzxGDzRLuCXxZ+i9Twawk5jyVkb6DqjVTp6AyCL16y1tn58K8+qB33 vMHVTLpxV/G10BtUh+ADmVd+NdSqr+/1De0dP0IvAADAG2e3im/a1rZd5ix1b6/dH0RsfujV3jgF X/X7efDzMVX6sZ+vymI9L95ItXZ0vl+flx8tCL544QPadYOr31ypD0zjfshZV/VA37ZPo/gS53V7 F6/d+kBX93TUd/vkxn5f0ScGSgAAALy+U8VpmbPoVOzIGkrr5BykLnG2r24sF2+Kh15t+3xV0pi9 q3M4yN5H5uR4v7TGVuzvBcEXL0cdgD4//lDnB+d6dvdR6cer4gOVDjZWxTyUkOpAZgPa2ka7jQ9w Kh5+a8Or0Y83Cu0tQOU8XwAAgDdomuizOl/mvGtqFbK04sfgYTd46PUCSWnFkZJ0Y/eHfizjTK/y bHNVFqvTsjh6n/29IPji1eANB/qHV3q16cpC+jGkxRBDZwNa2MRa8fVL1zeqvpvp3b5a+a37Pqa+ B2RfAACA19kTy5ylVXvrJd7oNAy+rFklWOgNa3uwzQ/LWtTmjikPQfI4lpKv1n2Z/e5Cw09/Ou3v ZZkzCL54eQNbHYgOf/6BHp7Nymx9XsageTYtdY5S1sUCr4qu7aErr/x6GK7NDOqSZ81he66vTlVf ubnsGQAAAK/hFLHO56TO6bQeYSSh9ngZ6lxwqvSqF0VsvqgSvUhSm1tp7MZR9/Ni76yc3PsP5fDw V9P+XoDgi5epDkQ/CV8u/1oPj46yd3YOmzxKHIfsFd9iwbfIStUukZU92O+vg1d+vcuztqONwnav b4285F4AAIDX0/UyZ90tc5bR7o5ty1stgtTCiHphRNLKK8A+b5QULfjmcXEQ8tmqL76dzrfVsb8X BF+8AiPbjX2+q2VZFs0a+zGUOETVTQlxHWNZRbFLy8q+YSVeAZ6Cr0hd8pxb0wO9MahR9QUAAHi9 PLnMWW8uc24r/nwFYNv+ZoFX11J0XcSXOoeN94nx1YOWjPP+3UXxYzM5xggEX7w6bEDygWn2uyu9 Wp+XEsfR37HzJSu+3NmGvJX9U7vyy8Kw3ffKr0zLnj34tqqvcLwRAADAa2y3dG/bvLR1c/Zqbw29 Ye0NrYLPB/2SYpesosR1KOMgXRxKmo9+WsjJ+cGNZc7s7wXBFy9dO9bIB6aTezZATcud1zkOY/GK rwXfaEFXw1W9LPzaSOiD3XTMkYff1uRKp+XOQtUXAADgdZsT6jQz1Gk+16q9GkYLt4MfXeTBV1oR 5Kpemq68H0zWcRP7flOXOQdf5vyoLnM+ZpkzCL54hTyx3Pm0bIrmInmMs9mmSKwVX63LnPXKMrEN dBaARWuzK9X67t/QBsZW9dXd0UaMcQAAAK/NlLBWemtTK5vT1SXOFnp1rIUOkbX3fLHbK/V5YL2C b4dbe8VXchzKajbeXOb82UefMBkEwRevktbd+fjkuHh35z0Lvss0jGHcDHEs6+QV36hXEvTSBsPL 0K6rtuQ5rL3LczvbV7K2zn9UfQEAAF6fueCNaq93tNKi2+Crsmnzvdrnxed+Nie0uaDqlfd/KUVW 3hdGumEY9Twv1mc3ljl/GljmDIIvXi33Qzg+PtGT4/1ylUvWbjFKH4fY60azd3VOV/avzcPupQdg v/VGVzaW+fltvtx5aINjoOoLAADwWtlWe9sSZ9k2tGqr+lrwrUucg80B9VJ9+5vYXFDCKklcb0oc dDOO+3E+rvS9TDdnEHzxCo92P9bP7I4vS/HlKb5MpayGcdDZJnsXZ9WrXCu9OlV89VLagOfv+nl3 v9boSgJVXwAAgNeGzdNk25y0ht9ttXewj2pDq7rST66LHyLlsvV/6a6yL3X2vjCxH4eieba4Uro5 g+CLV3nQC+GzB1qbXJ3/uqxswJP53XqkUZLUljvbACeSLkTChdaBT9ug52f7htrwYKr6+l7fOmhS 9QUAAHiVQ+/1VE1129Cqntrh8zpZ2xSxNTm1wGuTu0ufB/p80IsimnJd5hy6OGgaxvODWfF5JN2c QfDFq2zX5Oru9+Zl4U2u9FEOs2Thd73x89lSaPt8i+ilDZMXoUir+nog9mYH2/ArMraBczrXt76L SNUXAADglZv+7QoVdbvadl/vINvQ25qaXkooFnjlXFUuvPiRUrqKY14n6dZhSMNGS75jodnnkSxz BsEXr7ip6vvzD/S98Xt5v5RcVuOYdL4p2Su+elWXOBexgS+ea9TzUHwglEvv8myD5Dpsq771eKPp XF/djnuEXwAAgFdk3qe79Gup1vu0WPatwVckbPz0jhp6Q7iwr1144PXCR6v4xrrqT+N8tc6boaRx 9HljbWr181+pzyep9oLgi1fcj9WbXP3rwbl6c4LDtBylXw+ddO08X6/62oBXtFxI0QsVC7/iy57D ZTviyJsfhNrlWYL64GmDaGwBmDf9AAAAXpHQe13tFZXifVrs81682Ki20Osr/eoqPwnndv9c7bYU uchjudQyrnxVYMyLTU7rcaVjnh/8l5tNrQCCL15ZdZD6bHe00e/KUL7KabD/01CrvhLiZYlyEWM8 1yA2CNqthnP7znrUkWw7Pat3ea6DZ7695Jn0CwAA8ApM+XZLnHdHF9UjKv3M3rav1yZvF+pVXpvr 2f0ztfBbe7x0Xu2V1Sjdelvt9SMxj0/+13KjqRVzPhB88SqTW0cbedU3pOV4Vau+ee3v7oWxXJZS 2iCo5Vxa1ddCsLe4r0ti1r5EJkxLnqdL7fF0eQYAAHi5c72bxYhpibNORxeJr9yb9vVa4PWgG/XM vn7m1V7f7hajL3vWq1HGdRhWw7bae3L8L8Xnj+H+j1nmDIIvXgvtaKMnqr7etGDcLneu3Z3DRUhi A2G7atU31OvSIu6VPcaXyGx8ybMHX2+WcLvLM+EXAADghYfeOhXbndu76+Kstdoraz+qMvi+3hDq qr5W6Q1nyW6L5At72FWXZdXFbi3zOAz9/vho/F72au9nVHvxHCV+BHj2PpXw+cfy93+/H/5lfyZh vJRso51F36jzzjJsSClKLCopBulU1D/Z2Td2/jW72m399yn+5oxd4m/9yfQO4JP3AQAA8CJCb/2j 9l8ptR+LSF3eLCG2JqaqFnbDY3v8I5F4GiWcBo0P7TEPbVr32L7lvNTHpXW+uNzsLZdj/9e/yf9o M8Pwf/4fVHvx3FDxxfNwq+rr7+L5u3n+rp6f1aalXI1jvBTJFxrKWdD02Ma4erXKr17UY46CXh9x 1LoE+n7fqdEVlV8AAIAXH3r91A2dKr0y2txtaB2cfd4WLlW8h4ucbed2oeiZV31z9G7O5TKU7qqX fh3Xl8MQl2M9t3fXyXk7jwSePSq+eE686vsP4Rd//1/lB3/9m7C3Woq3r0pdsUzbx5IkplIsB9cK b5LQblulV7bV3iT16171nSq/vqtEthXfNhIH3hoEAAB4AaF32tfbihGjfW0jEtY2NfNq74VXeu3+ I5uZeYX31Cu+9h0PY5RHksWCcLkYQ7najJv1bPbu5uDycpRTKf/43e9reEC1F89Xx48Az0ktx9Zz fT8O+uVyXfbyvXxnk4b1fFzPxtANoeu7FPpcykyDzqKGmX2LX71K6ES18/CrqtHSskyhd/vMIdxe scBICQAA8LxDrzezklBDb2j9WFbevTmonNtsrVZ6pYRH9uBH9vDHQfUsl3xhk7nLMsoqat7kuQyr /Ov88PiofHi8X356fW4v1V48Nyx1xvMcLIMvefbz2O7+dl7e2eSsaTV6o6vSyco7+uUsF7Euh/Hl zvGR5Vu71AZK3xsSagfAYAPltHzGG175PpI8NVO4seyZgRIAAOA5h97cQm+dj23UuzertLN6g3dv 9m1r+qhIrfo+rg1MOzmrnZzTsOpkXHd5f3Pd0Op4amj1Y+ZyeO5Y6ozn7FMJDz4KP/rR92ujq1k3 D7mL0pdBogyimmorq6gai92XUPzfpFd4oy9xFr+/XeYs9Y2a6Kekt/9vHa/C7WovlV8AAIDnEHrF Q6/USu96OqXjsh5TJMGCrtQGVjY9+8quU9F4qlIeRY1nEuP5OJarIee1TeyGxSyN/Ze/yf/4XRpa geCLN8o/hAcP/nP46L0Pw6/1C0lXnY2WFnJ7D6+jxNEjrQVgj7I1y9rwKC3s2qeiRd2ps3O9/AEW fo2Gbwi/dHsGAAB41qFXvdKrYWMPWUldkVePonwsQR/ZlOyhqJ7ax/Xypc4xlMc2YTsvebxM0q3G Ptv3roaLbpk/OFqWB3WJ8/+2/buA54qlzngRA2hoS55P6pLnx5ucy14/JC2b2SgrS72XsYwXFoXP gtS9II+K6kMNdok+tKHwsfrB5yo2uMqlarDvCRsLvYMNzePTy57p9gwAAPDMQ69XekXq8mYNMoVe 8f28Nm/zsCsPpV2P/eSOkrpzke4y97Lqs27KZRpY4oyXhYovXpC25PlXP/p++Hffvdh1eR5SZ/8K o5TQ+zHoolElxjiVdGsxN6rfD7W7VV3u7PctCNeva/tApnz9RLdnKr8AAADPLPS27s2XwYsVoTy2 Odoj+/pDm5Cd2oTMLvnKZmsPvWdLLPksdOFChu4qxGEdw2Y4uAyjnJ4WljiD4Is33OfBw+//fHgu p/vHIZbHISz2w0w3YSxd6DwD2wirxbNsDG0vb2gB2Hf2hpp+a7itK5xbtBV/XPSM/LVHHRF+AQAA /vTQKyXc7N7se3rr8uYp9PryZg1nUrs2h4f2eV/WfGpTt9Oo4aHN4x7Vc3ul2OPS1RjKKm1kCHt7 4+n+rPy/R8sSWOIMgi/efP8QfvGffhI+evBhOEn/Fny/79jnMPPeVTaCZj8K3Vctx7q5t2bZMFV1 Pepuw28rBt8IwWEbem8e76tyHXkJwAAAAE8H3jpDmoJvtEmYtnN6r7s3r31Pr325VXpr6JWHNjU7 VdHT4Pt6xSu+8rBIfGTffpa6fDEr4TKmss6z2aaUx6Pv6z0+eVB+8f+cTEucPyX0guCLN9mnEj63 8Pv3/1X+46Mf6O9ns9AdrcJwKSFlb++8CaXra5Qtnn+9Ahxa3G2pN2xvbJzVmwF4F4Svr1s5l+ov AADArdB7c2mztOXNHnqDXp/TW7s3i4fec1/e7JXeFnqLhV75yuZpp1H0oX8+ifo5vhcpxkuNurr0 M3vPy3geLvJ3Hv2gfP7xv5Tw+Y+VXiwg+OLtCb8PPrLwux9+8OVvwr1VDBf3FuFgHHQzs7AbQ+iy huI1X3/jsVj8jdEH5xZ+63PsQm8r9GqQ3U7f9vUbn7oVjAMBGAAAvN2Bd2e3n9ebhUpQX3u3C71+ Tq8fWRSm7s2+pzd4I6ta6ZWvYiin9vXT2tBKwuOiei6SLksOq4UMm8vLNPxtenfcu/rb7E1O2dcL gi/eQp+H7fm+v/nuRThKJfw+LMJe7MJm41k3haS+09fXPJcgJapvNQnTgUftGN/teH07y+p0xtGN pldPjfiEXwAA8HaG3lsNrLZNrIrU5c0y2IRrY/OotX3pSrx7s4Rd92ZvZOXLmn15s1d6PfT6aRwi 5cy7PHvo1aJX3sH54b0w/O3q3fG3v/1la2bFvl4QfPH2auf7/uh9C78HHn6/H/T8N/avUsO8JG/v bGPnFH49BesUayW21c92P4gH4jqM63VdV65j7XTnxvbfJ8IwARgAALwNgTdMe3lDC5/iYdcbWUnb zyt1P287ozfIVQ2yIViYDY/8nF4/ZtK7N9dGVhZ+2/Jmr/R66I1nHnrzZrWaadqc7j0c3v1Vl0/f Py3vL4+m83rvc3QRCL54W33awu//buH3X78f/mW4lFk3D91woEO6COlG+M21fmt3ox905IHXWz6L Touf/ZwjbWuhd8m2BeKbA6yGb6j+EoABAMAbHHivZ0K3qrw288l235tYbSzYbiTEK5sMeffmC5tV ndntY5tz1YBrz/WVH1nk3Zulfi54BfjxttLroXcus/XpXj8cn4Tx7INNfv/0qHz22QOaWYHgC9Tw +3kLvx89OAl+zNGsy7fC78bCbh+yeuiNvgVFkw3UUuqKZ6/6qgdhX+BcS8AefuugPvXB0l3irWN/ vJV/hQAMAADe8MArN0Jv28vrVd7awGqwT23sduWhd3tckfrSZvGlzR54/ZxeC7yhdm7+yo8s8u7N 3shqu6f3dui9uA69H1nopZkVCL7ALvy2Ts/1mKOnw6/GZdHBgm/OmmJXioXfVFs6e+cr72IVS7Qg bJnWw3CplV/1B/htqNXhNtjLdvDfRdztup+vD8CEYAAA8DqF3d005npJc9gWBFrHZgnbY4qkHVVk odc7N9sDLmz+dG4TrLqf157jYd3HG+Qre9xp9E7OsZ3T60cWeffm7Z7etrz5a0LvfUIvCL7Anxh+ Vxr7XkufSsxj3Y+ilnzFg27bAFyC2pDr+1S0tEqwTp0J/TGyW85Tl0bXKLyrCLcXBbnx6vBE/CUE AwCA1yPs7oLu1P1kWtL8ROC1SwebBW1sYrSyR10F79rsITaEM52aWHnota+dqkQPvqcefFtzK/Gj jOo5vX5kkXdv9kZWvqf31vJmQi8IvsCfF34P7456Osz04HLQElNJXa3vlmBB2HJv8Y+u96ioB9/c 7lsAbvtWtl+v1eEahq/f/Qw3A/BuT7DUmEwIBgAAr0nY3d7WN/hL2J3HK7ndbqu8oS1rlrDyrs02 b7qw7zq373lsX3sUWuitQbc1sfIAHP3+oxLK41jyWZZyPiuhntPrRxZ592ZvZEXoBcEX+AvD78cn x1q7Pf+yhN/fOwuq72gfVjqGuse3NrtKavk3+ruYMfvZcxLT6IG37l2xYFzDr4Vh8VBcOxdOQbhu B74VgqcArDX0ynZ59JMh+GYUvhWECcMAAOB5hdynphhfG3ZlF3hrQSDbF0dpYdfP5V3bo1f2WG9g dWGfu7BJzpnUpc3qofeh3T9tl1d66zLnhyrlUbTQG1J3Fjr7Pk1XMZX1peZ2Tu/q3bF2byb04lX/ beJHgFfz36XWEPzJJx/KF1+cxvfe+178H/l3XX930ZXz89kiHcykKwvVcU9D2itR92XUQ0ushzZQ H4Yoh0XDnXq/2Ock7Ft+3bcn9WtpT7+w27ldMxubZxZuO/tbu9DeDPIr2v+MaDnY20h7v6x2JpK2 U4S/5vdH+FUDAAB/Pv1zHqC7QCz1qMfW2LM1+ty+yZ9D2/blRxSNMchQgg4tAHv41Rp+g5/RG+oS 53P73nNfwhy98lvUz+T1isOZdva5IvaYfCnSXeoYVxsZ12HRDcOj1fi3qZ3T+/77N7s3E3pB8AX+ 3BcCqRVgC78/tPD76L11vNvNUzfud7rIfZY4S4MuYjezAJz3Sgn7KaZ9uz2ogTcUC8HBbuXQnunA XgQOgodflT27XdrzL6fwO1cPwKq9Rdwp/GpXg+8uBGusBwS335k4/fZIOz1Ywo0w3LYT86sFAAD+ ohjsk4ub4XE6oaKuQtuF4GnVmjdplptHE+Up+LZzef1SP6oobGxmsgrturLr0p71wmYs3sH5PAYL uarnNsWx0FvOYkznueSLGFsDqzJuVrmXVdKysT+HsbsYH43r/N2r/yV/fnyigdALgi/wLP6N3q/h 9+OTYzk5Pol3LIzG9VknedENSWajjpaGdSG5X1g+3StJ95OFYEufBzbyH9oQXIOwvYwciOi+hrhv LxR79lphAVi88mvfp3Mb/Gf2l/X2AlEDsNbwu6sATwE4RG+p5ccIb4Ow1oS8WxN9vSNYn/z94tcN AADcjrlPTBX0xqfq0YylTSh0G3RV69GN2328N5Y2+9mPaoFXvLo77eety5zXHnrtiVc2v7n0I4tK kUvxKq96NdcCb4xn0Ts6azjPFnZjlgvL05eahlUeZdVJt/YmVppWY5kfjo/t7zo+OS7Xofe+hj+h dA0QfIE/+u/Ux9RP5ePPQzw5/jAen1zEr2Ypxb3cy1r7RUoWgLt5tABsA/5SLQDb2L8fNe2rL4P2 0GsB2Jc724vCQZSwZy8je/bc9jhZ2OC/Xfrs1d/eHjuzv9VDcGevL52E6FXgZC8IyV5s4hSC5cbt dN1YCl2PFpanfsuU3zsAAJjYPJV//3/27m1HjuO+A3BVdfccSC4oJl5YDiwEEBIhSC4F5DZ5CT2P 5OfRS9gPoEsZgRL4RkYiizYoZUnuzHR3Vaq6Z5e71AFBDkokfh/QqO6dwxIkZ7t++69D6yHEV0OZ l2puuHvcrE3S9rVo83nXsBvKunhVPG9RVMJYA+4xlHwKyyJWsR3X9WX1WINvff0yxzfV0Fvf6EWq gbe19Tk1EKeX9Vtf5yXwTsfDPJ/KNo75ZTf+2Wmen14+zJdPf5t//Y/1z7PO5w1CL4Iv/I/fI+4O fX4nPe4/X4Y+p7zpp+7FJtcA3JduG9K0rz/09yEO+zYEur78QaoBuP6gf7hUfUtYq75r+N3XH/D7 EmsALqWG33ie+xs2LQSHFoRDm//bKsCpq+ddvcm8VgF+FYLLmn7P4Te8Nuq5+MwBAOHesOB1a4mb +FvinbBb1jlUtxXetoBnWUJvnusjU33ysmLzeQ7vqT79FJe9ectxWb25hOu8DG9eQ28Nti9uwm9s qzovYbce4Rx453iY4nxMNfD288NTTqdpHdr8zvz4y8/zJ+8+yXeGNgu9CL7wv+PVvN+7Q5//vR7D +KJv1d8Hw34Yy7jtQr+durJbAvAU9l3fqsB5CbulzA9bVbjeEPb1BvEgljbkuezXoc/n8LsMfw6b evMY6nkNwsv8376F4Jpnl+HPLQDHZaRzSaHtKtyOeK7+rqE3fjP0+tgBwBven/m28FvO4becz9ft GEvM9XIJvGHZj3ddrTm0Yx3a3MJuDb7LkOZjaQtYtS2LQj6EkNp83us1/JaXS/itIbdd18dq2G3n 3XXu5kMLvF2YjkMcji/H67FVecfh4VT7WfM3hzabz4vgCz/Q/9t16PMHn66rPt9Uf3fx7S4fnw55 +2AIfR6mPG370m/rLWMXU79ri1rN89wC7n5Z4Gqd57u/G3zrO+/q9bak+iO/hG1oc39z2JRYhvPw 51YFXuf/ltLXx+8sghVSfX2KIdyuAv36psCxDYFO/hEB4I3UNlWM5wWr7vQOXq3SvHQc7s/hLaVt 5TiFmz1510WrxtpfGctS6c01/LbgW45teHPtahzSsk/vq+Bb2nVq52W9zvGQUzz0XTzMaT6mUk5t 8ary8jSl7eV4KF/MN1XeZdXmV1sV3U3uIPjCDxJ+X6v+3sz9HfJ1313s+nLMQxh2Q1+mbY7bGmCP u9x32zh3NQRPNfCGXY5p19oQayAuaVdvRi3w7urNo4bfsI3nha/qradVfZfwW9oK0C30pnUV6Pon 6Wo47lqkXSrA9Y3Ksg9Sub/5XjmHYMEXAN7Y4Lv2ZO5VTM+LVq2rNC8V3rYlUWoV3vPiVblM9QlT 7Vwsobe+Yqz9iVN94am+cqn0noc2H+rzDqnkpW1Bt9SAW/J86FJ9bK6Bt4bdLnbHmppPLfC2o3Tj NF8dpjHtp1dzeb9R5RV6EXzh/zQA36v+HtPlo7fTzfDnbt72ae773B02224zzEsIjpuupO1c8jal sqt3lm1ahzfv6s2hht15V+rXYlvsKrWKbznP+41DvQ9t6rftl8pvbEOfl62P1vDbjhJTWYY+t9ib U7zd7uicdqN5vgDwRis3oTcvHYNlZHNJeRkW1oY2x9L24T2H3ja0OU63WxSFMsWQTkvwXeb0xhp4 y/G24ltqsA35mJawWwNwzMcWfPOUjrGMp7kG3rQppzClMYyHMW7TOPf76VC/VxvW/PT5F/nxl1tV XgRf+H8bfm+rv7+NV+/9In79+c3w5757kVJ3E4DDMA9hykONpJtNqm0NwbkG4C72S5tq4G1ze5fz VvUN3SYtC13lNfjmWNsyrOE3DzGGV1XfNve3vqDdvdaC73ml5zuV3nKz2jMA8Cam3rD0EO5Vfpfe Qc27y1JWy568bbXm25Wbl9CbltBbHx9jKkvwbQta5VbxjenY2lQDcA7pmHJe23q050w5nNIm1LB7 GuNQ36eG3qXCey/wPsqP3/k8X3z2b+XXl3+ryovgCz+eANyGP/8mXT79y3R1cUo3AXgTUxfnoU95 7OOm78s0DKWrAXgcNyH1Qwu93RJ0581ynruhvms9r8E3p2GZ69uGOrdhziUuqz3H2uabim/MNQTX W1Kb/BvbPSzE24pvUe0FAG4C71rxbb8ib2Xe9Tfl9bSkZeXm1EJvrGG3VXxrWx9Z9+mt4TfUjkws 6ZTbHN8STrGrwbeez+16bnv5tiHM7etpPM5pzHGe9jXsln43nZ6F+fBE4EXwhZ9A+A23w5+fngPw 8fnfx8tHz5ch0I+en9KQYvciH/s+PurS7tTXvFpDcB7iUNs5DyHVgDvX0NvaduTz0aV+aWvYrTeZ JfyWdXGrdaujerdKMS3DnUtZq70p3Nm/1/xeAHiz5VedlnwOwfE8zDmXnGOMuZyrvUvVt4XeeQ2/ IdXQO+e1bUeuITfPY+2FrOc16MYadGt2nspxnuqXptxtp1Mu84N6XM95fvh4l5chze9sXwXe22HN txFB6EXwhR9bAA6f3h0Cvc4BPh32cRe/7A7bi7SpgfVQjzTXIBxi10JwzFMNtV0/9qmPZa7Xaans hj4v7bzM5819PA9xzrG2c1vgqgXfNfSWtsNvC7/t7tF2IghrQgYA3lzzTWelDRBbTkqb2buE31zP lnm+XZjro8uQ57JUftPU3VSApzS1tqRc2xpwp37atDb1Uwu8+bCZpvraXQ7zaQ7zxZMwXx2e5Yur TW6LVu1+96xcXLxe4RV4EXzhpxGA784BvvpFPLz7JB6fP1qqwC++PqSL3eN02B7XEPw81OT7outT 6k4xdl3YdTXddqd6Z0ktINfzuYbdm/OcasSdalujbpfqVU6xfa3F3K4tzHgOvwAA9zoqtZcwLwF4 DinX0JtymXPrTNTw29fwm1sVOMy5PqGrIfjmfBP7qSbieQ6HeVPfYsq5Jt9Sw+6jJezuHlzlq8OQ H17t8tO3HuXto+elrdJ8efm0fBw+DuHjv7s7pFngRfCFn9b/9fMc4I9q8+n3heAxHV5epP12TKfN lLb9Ph1ehG7q59TXoDvUqDseazjuhjTX825qd6i+/Y41DX2Kc9sOr7YtALdNf0tbgHEx+JcAAKrx HHz7ZXnmFnjjlEvXbfPY2r52LfKU59p2Nf5O85iHbZjHdl4Dbz91efcwzMfpOm9Ofb4+Dvnbwu69 6u4ynLl9V3N4EXzhDfl/f6cK/NGH4YNPP45PXw/BX/1TOv3sYRzf2seLr9dq8DwOcT/UMHxoYXhK 89zHFoY3p3pv2nQxz10cxnae2nSb+n12oeTR5wwA+O6OSWrraB5CakuLnHIZhxp6u7mez+W0SbmF 3K6bynHq82ZXQ+445G4Yy+64zVePv87DV9dl88cX5elbf3Mv7F7WsPvxN8OuwIvgC0JwuFcJDu/X 29CzNQj/8uf7ePWnz9J43Mf58S6+ddzGabyK06NN3L8c0zwNcX5wHVvb3i1P/dLudwefMwDgO10f dktnpE3RbW3Xj6V7uW8rjZTrB0Pun59KP1yUr7bH0n19KMP2ulz8+Xv593+4LkvQffKshE9C+PbK 7m2XX9hF8AW+OwR/UJtWDQ7hH8LV1WfnivAX9fqvwi+v/xCPlw/j6fCsXv9FGI/P4ny6iuHyMlzW 143HqzufsZ/5GwYA7vjj7dmwvShPw9LpCN3moobbJ7VT8q9hs3tStk9flN/vf16v/yVsH719rui+ V69/E5aqbnudsAuCL/zXPxuvBeHwYQ3DH98Lw00LxOH998Ph2e+W163B+JW/riEZAOB1/1zD7F0t 2LZ29+TdEj75JKwBt7kbcj+oX/tV+JagK+yC4Av/3c/K6/eRmzB8PxDftYZjAIDv10Lt3et7Abe5 F3LvdeUFXRB84Yf67HzbPedX95/zkb80AOD7+gYflv9Ed13QBcEXfLYAgB81wRYAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAHhD/YcAAwCm6WQR3WTdbAAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 137.08 398.16)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st52"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M314.54,247.3H187.19c-8.2,0-14.85-6.65-14.85-14.85V205.4c0-8.2,6.65-14.85,14.85-14.85h127.35 c8.2,0,14.85,6.65,14.85,14.85v27.05C329.38,240.65,322.74,247.3,314.54,247.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.8868,
    y1: 194.5143,
    x2: 312.8868,
    y2: 215.8855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M321.46,206.06c0,4.74-3.84,8.58-8.58,8.58s-8.58-3.84-8.58-8.58c0-4.74,3.84-8.58,8.58-8.58 S321.46,201.32,321.46,206.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.8868,
    y1: 219.2585,
    x2: 312.8868,
    y2: 240.6297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M321.46,230.81c0,4.74-3.84,8.58-8.58,8.58s-8.58-3.84-8.58-8.58c0-4.74,3.84-8.58,8.58-8.58 S321.46,226.07,321.46,230.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_28_)"
    },
    d: "M233.3,203.53v2.23h-1.45v-2.24l-2.43-4.04h1.54l1.68,2.79l1.68-2.79h1.43L233.3,203.53 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M235.9,203.34c0-1.45,1.12-2.49,2.66-2.49s2.65,1.03,2.65,2.49s-1.11,2.49-2.65,2.49 S235.9,204.79,235.9,203.34z M239.79,203.34c0-0.83-0.53-1.34-1.23-1.34s-1.24,0.5-1.24,1.34s0.54,1.34,1.24,1.34 S239.79,204.17,239.79,203.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M247,200.92v4.83h-1.33v-0.57c-0.37,0.42-0.91,0.65-1.5,0.65c-1.21,0-2.06-0.68-2.06-2.17v-2.73h1.4v2.52 c0,0.81,0.36,1.17,0.98,1.17c0.65,0,1.11-0.41,1.11-1.3v-2.39H247z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M251.31,200.85v1.29c-0.12-0.01-0.21-0.02-0.31-0.02c-0.77,0-1.28,0.42-1.28,1.35v2.28h-1.4v-4.83h1.34 v0.64C249.99,201.09,250.56,200.85,251.31,200.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M260.27,201.75c0,1.4-1.05,2.27-2.73,2.27h-1.27v1.73h-1.45v-6.28h2.72 C259.22,199.47,260.27,200.34,260.27,201.75z M258.79,201.75c0-0.69-0.45-1.09-1.34-1.09h-1.18v2.18h1.18 C258.35,202.83,258.79,202.43,258.79,201.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M264.29,200.85v1.29c-0.12-0.01-0.21-0.02-0.31-0.02c-0.77,0-1.28,0.42-1.28,1.35v2.28h-1.4v-4.83h1.34 v0.64C262.97,201.09,263.55,200.85,264.29,200.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M264.81,203.34c0-1.45,1.12-2.49,2.66-2.49c1.54,0,2.65,1.03,2.65,2.49s-1.11,2.49-2.65,2.49 C265.93,205.82,264.81,204.79,264.81,203.34z M268.69,203.34c0-0.83-0.53-1.34-1.23-1.34c-0.7,0-1.24,0.5-1.24,1.34 s0.54,1.34,1.24,1.34C268.16,204.67,268.69,204.17,268.69,203.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M275.96,199.09v6.66h-1.34v-0.56c-0.35,0.42-0.86,0.63-1.51,0.63c-1.36,0-2.41-0.97-2.41-2.49 s1.05-2.49,2.41-2.49c0.59,0,1.09,0.19,1.44,0.58v-2.34H275.96z M274.59,203.34c0-0.83-0.54-1.34-1.23-1.34 c-0.7,0-1.24,0.5-1.24,1.34s0.54,1.34,1.24,1.34C274.05,204.67,274.59,204.17,274.59,203.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M282.12,200.92v4.83h-1.33v-0.57c-0.37,0.42-0.91,0.65-1.5,0.65c-1.21,0-2.06-0.68-2.06-2.17v-2.73h1.4 v2.52c0,0.81,0.36,1.17,0.98,1.17c0.65,0,1.11-0.41,1.11-1.3v-2.39H282.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M283.07,203.34c0-1.45,1.12-2.49,2.69-2.49c1.01,0,1.81,0.44,2.16,1.23l-1.08,0.58 c-0.26-0.46-0.65-0.66-1.09-0.66c-0.71,0-1.26,0.49-1.26,1.34s0.56,1.34,1.26,1.34c0.44,0,0.83-0.2,1.09-0.66l1.08,0.59 c-0.35,0.77-1.15,1.22-2.16,1.22C284.19,205.82,283.07,204.79,283.07,203.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.6338,
    y1: 197.9482,
    x2: 260.6338,
    y2: 210.4138
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M291.85,205.52c-0.29,0.21-0.71,0.31-1.14,0.31c-1.14,0-1.8-0.58-1.8-1.73v-1.98h-0.74v-1.08h0.74v-1.18 h1.4v1.18h1.2v1.08h-1.2v1.96c0,0.41,0.22,0.64,0.6,0.64c0.21,0,0.41-0.06,0.57-0.18L291.85,205.52z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 274.8643 234.7012)",
    className: "st66 st67 st68"
  }, "X 1"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.2559,
    y1: 224.1211,
    x2: 244.2559,
    y2: 242.0403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M235.3,237.16v1.75h-1.56v-1.7c-1.55-0.09-3.03-0.58-3.89-1.25l0.86-1.9c0.78,0.58,1.9,1,3.03,1.11v-2.61 c-1.73-0.42-3.67-1-3.67-3.23c0-1.65,1.2-3.07,3.67-3.36v-1.73h1.56v1.7c1.17,0.09,2.31,0.41,3.17,0.95l-0.78,1.92 c-0.8-0.45-1.61-0.72-2.39-0.81v2.65c1.73,0.41,3.64,0.98,3.64,3.18C238.94,235.46,237.75,236.86,235.3,237.16z M233.74,230.26 v-2.22c-0.83,0.19-1.15,0.64-1.15,1.16C232.59,229.74,233.05,230.04,233.74,230.26z M236.43,234.02c0-0.55-0.45-0.84-1.12-1.08 v2.15C236.08,234.93,236.43,234.52,236.43,234.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.2559,
    y1: 224.1211,
    x2: 244.2559,
    y2: 242.0403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M248.71,231.34c0,3.78-2.26,5.89-5.57,5.89c-1.15,0-2.26-0.27-3.03-0.75l0.94-1.86 c0.59,0.41,1.3,0.55,2.04,0.55c1.81,0,3-1.08,3.07-3.18c-0.64,0.64-1.58,0.98-2.72,0.98c-2.11,0-3.76-1.34-3.76-3.4 c0-2.23,1.83-3.64,4.14-3.64C246.85,225.92,248.71,227.81,248.71,231.34z M245.89,229.43c0-0.94-0.7-1.62-1.9-1.62 c-1.08,0-1.83,0.62-1.83,1.62s0.73,1.64,1.86,1.64C245.12,231.07,245.89,230.38,245.89,229.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.2559,
    y1: 224.1211,
    x2: 244.2559,
    y2: 242.0403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M258.66,231.34c0,3.78-2.26,5.89-5.57,5.89c-1.15,0-2.26-0.27-3.03-0.75l0.94-1.86 c0.59,0.41,1.3,0.55,2.04,0.55c1.81,0,3-1.08,3.07-3.18c-0.64,0.64-1.58,0.98-2.72,0.98c-2.11,0-3.76-1.34-3.76-3.4 c0-2.23,1.83-3.64,4.14-3.64C256.8,225.92,258.66,227.81,258.66,231.34z M255.83,229.43c0-0.94-0.7-1.62-1.9-1.62 c-1.08,0-1.83,0.62-1.83,1.62s0.73,1.64,1.86,1.64C255.07,231.07,255.83,230.38,255.83,229.43z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_56_",
    d: "M211.06,196.49h-23.87c-4.92,0-8.91,3.99-8.91,8.91v27.05c0,4.92,3.99,8.91,8.91,8.91h23.87 c4.92,0,8.91-3.99,8.91-8.91V205.4C219.96,200.48,215.98,196.49,211.06,196.49z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_56_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.1213,
    y1: 196.1639,
    x2: 199.1213,
    y2: 233.3556
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_42_)",
      fill: "url(#SVGID_43_)"
    },
    d: "M211.06,196.49h-23.87c-4.92,0-8.91,3.99-8.91,8.91v27.05 c0,4.92,3.99,8.91,8.91,8.91h23.87c4.92,0,8.91-3.99,8.91-8.91V205.4C219.96,200.48,215.98,196.49,211.06,196.49z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.57,
      clipPath: "url(#SVGID_42_)"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M171.67,237.61l12.55-12.39c1.17-1.16,3.07-1.12,4.19,0.08l6.15,6.58l11.13-14.78 c1.16-1.54,3.43-1.64,4.72-0.21l22.89,25.3H171.1L171.67,237.61z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M192.28,208.7c0,2.69-2.18,4.87-4.87,4.87s-4.87-2.18-4.87-4.87c0-2.69,2.18-4.87,4.87-4.87 S192.28,206.01,192.28,208.7z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M316.55,206.97h-2.73v2.67h-2.03v-2.67h-2.72v-1.92h2.72v-2.67h2.03v2.67h2.73V206.97z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M309.73,229.42h6.46v2.85h-6.46V229.42z"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 229.42,
    y: 210.76,
    className: "st74",
    width: 61.53,
    height: 6.52
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 229.4165 214.4346)",
    className: "st66 st75 st76"
  }, "Lorem ipsum dolor sit"))), /*#__PURE__*/React.createElement("g", {
    className: "st52"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M314.54,341.21H187.19c-8.2,0-14.85-6.65-14.85-14.85v-57.41c0-8.2,6.65-14.85,14.85-14.85h127.35 c8.2,0,14.85,6.65,14.85,14.85v57.41C329.38,334.57,322.74,341.21,314.54,341.21z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 229.4175 268.5732)",
    className: "st66 st67 st77"
  }, "TOTAL"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.5833,
    y1: 272.9962,
    x2: 250.5833,
    y2: 292.1414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M235.71,286.93v1.87h-1.67v-1.82c-1.65-0.1-3.24-0.62-4.15-1.33l0.92-2.04c0.83,0.62,2.03,1.07,3.24,1.18 v-2.79c-1.85-0.45-3.92-1.07-3.92-3.45c0-1.77,1.28-3.29,3.92-3.58v-1.85h1.67v1.82c1.25,0.1,2.47,0.43,3.39,1.02l-0.83,2.05 c-0.85-0.48-1.72-0.77-2.55-0.87v2.83c1.85,0.43,3.89,1.05,3.89,3.4C239.59,285.11,238.32,286.61,235.71,286.93z  M234.04,279.55v-2.37c-0.88,0.2-1.23,0.68-1.23,1.23C232.8,279,233.3,279.32,234.04,279.55z M236.91,283.57 c0-0.58-0.48-0.9-1.2-1.15v2.3C236.54,284.54,236.91,284.11,236.91,283.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.5833,
    y1: 272.9962,
    x2: 250.5833,
    y2: 292.1414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M250.03,280.7c0,4.04-2.42,6.29-5.95,6.29c-1.23,0-2.42-0.28-3.24-0.8l1-1.98 c0.63,0.43,1.38,0.58,2.18,0.58c1.93,0,3.2-1.15,3.29-3.4c-0.68,0.68-1.68,1.05-2.9,1.05c-2.25,0-4.02-1.43-4.02-3.64 c0-2.39,1.95-3.89,4.42-3.89C248.05,274.92,250.03,276.94,250.03,280.7z M247.01,278.67c0-1-0.75-1.73-2.03-1.73 c-1.15,0-1.95,0.67-1.95,1.73s0.78,1.75,1.98,1.75C246.2,280.42,247.01,279.69,247.01,278.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.5833,
    y1: 272.9962,
    x2: 250.5833,
    y2: 292.1414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M260.66,280.7c0,4.04-2.42,6.29-5.95,6.29c-1.23,0-2.42-0.28-3.24-0.8l1-1.98 c0.63,0.43,1.38,0.58,2.18,0.58c1.93,0,3.2-1.15,3.29-3.4c-0.68,0.68-1.68,1.05-2.9,1.05c-2.25,0-4.02-1.43-4.02-3.64 c0-2.39,1.95-3.89,4.42-3.89C258.67,274.92,260.66,276.94,260.66,280.7z M257.64,278.67c0-1-0.75-1.73-2.03-1.73 c-1.15,0-1.95,0.67-1.95,1.73s0.78,1.75,1.98,1.75C256.82,280.42,257.64,279.69,257.64,278.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.5833,
    y1: 272.9962,
    x2: 250.5833,
    y2: 292.1414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M271.28,280.7c0,4.04-2.42,6.29-5.95,6.29c-1.23,0-2.42-0.28-3.24-0.8l1-1.98 c0.63,0.43,1.38,0.58,2.19,0.58c1.93,0,3.2-1.15,3.29-3.4c-0.68,0.68-1.68,1.05-2.9,1.05c-2.25,0-4.02-1.43-4.02-3.64 c0-2.39,1.95-3.89,4.42-3.89C269.3,274.92,271.28,276.94,271.28,280.7z M268.26,278.67c0-1-0.75-1.73-2.04-1.73 c-1.15,0-1.95,0.67-1.95,1.73s0.78,1.75,1.98,1.75C267.45,280.42,268.26,279.69,268.26,278.67z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.5026,
    y1: 259.6386,
    x2: 196.5026,
    y2: 303.9244
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st61",
    cx: 196.5,
    cy: 277.33,
    r: 15.88
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M204.36,273.22c-0.17-0.26-0.47-0.41-0.78-0.41h-12.45l-0.83-2.12c-0.14-0.36-0.49-0.6-0.87-0.6h-1.56 c-0.52,0-0.94,0.42-0.94,0.94l0,0c0,0.52,0.42,0.94,0.94,0.94h0.92l3.1,7.98c0.14,0.36,0.49,0.6,0.87,0.6h8.51 c0.39,0,0.73-0.24,0.87-0.59l2.31-5.85C204.57,273.8,204.53,273.47,204.36,273.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 193.86,
    cy: 283.48,
    r: 1.67
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 200.32,
    cy: 283.48,
    r: 1.67
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.6248,
    y1: 314.6789,
    x2: 257.6248,
    y2: 342.2523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M277.4,333.23h-39.55c-4.93,0-8.93-4-8.93-8.93l0,0c0-4.93,4-8.93,8.93-8.93h39.55 c4.93,0,8.93,4,8.93,8.93l0,0C286.33,329.23,282.33,333.23,277.4,333.23z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 241.8472 326.5283)",
    className: "st6 st67 st84"
  }, "Buy Now"))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 229.42,
    y: 296.43,
    className: "st74",
    width: 80.5,
    height: 15.84
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 229.4165 300.0977)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st66 st75 st76"
  }, "Lorem ipsum dolor sit amet, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 6.93,
    className: "st66 st75 st76"
  }, "consectetuer adipiscing elit"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.318,
    y1: 262.362,
    x2: 313.318,
    y2: 281.1016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M318.24,266.31h-0.23c-0.67,0-1.01-0.81-0.53-1.29l0.16-0.16c0.3-0.29,0.3-0.77,0-1.07l-0.61-0.61 c-0.29-0.29-0.77-0.29-1.07,0l-0.16,0.16c-0.48,0.48-1.29,0.14-1.29-0.53v-0.23c0-0.42-0.34-0.76-0.76-0.76h-0.86 c-0.42,0-0.76,0.34-0.76,0.76v0.23c0,0.67-0.81,1.01-1.29,0.53l-0.16-0.16c-0.29-0.29-0.77-0.29-1.07,0l-0.61,0.61 c-0.3,0.29-0.3,0.77,0,1.07l0.16,0.16c0.48,0.48,0.14,1.29-0.53,1.29h-0.23c-0.42,0-0.76,0.34-0.76,0.76v0.86 c0,0.42,0.34,0.76,0.76,0.76h0.23c0.67,0,1.01,0.81,0.53,1.29l-0.16,0.16c-0.3,0.3-0.3,0.77,0,1.07l0.61,0.61 c0.3,0.3,0.77,0.3,1.07,0l0.16-0.16c0.48-0.48,1.29-0.14,1.29,0.53v0.23c0,0.42,0.34,0.76,0.76,0.76h0.86 c0.42,0,0.76-0.34,0.76-0.76v-0.23c0-0.67,0.81-1.01,1.29-0.53l0.16,0.16c0.3,0.3,0.77,0.3,1.07,0l0.61-0.61 c0.3-0.3,0.3-0.77,0-1.07l-0.16-0.16c-0.48-0.48-0.14-1.29,0.53-1.29h0.23c0.42,0,0.76-0.34,0.76-0.76v-0.86 C318.99,266.65,318.65,266.31,318.24,266.31z M313.32,269.52c-1.12,0-2.02-0.9-2.02-2.02s0.9-2.02,2.02-2.02 c1.12,0,2.02,0.9,2.02,2.02S314.43,269.52,313.32,269.52z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M312.92,124.69H188.81c-9.09,0-16.47-7.37-16.47-16.47l0,0c0-9.09,7.37-16.47,16.47-16.47h124.11 c9.09,0,16.47,7.37,16.47,16.47l0,0C329.38,117.31,322.01,124.69,312.92,124.69z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.7055,
    y1: 98.4696,
    x2: 312.7055,
    y2: 121.5046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st64",
    cx: 312.71,
    cy: 108.22,
    r: 11.33
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M318.56,112.44l-2.73-2.73c0.51-0.78,0.81-1.71,0.81-2.71c0-2.75-2.24-4.99-4.99-4.99 s-4.99,2.24-4.99,4.99s2.24,4.99,4.99,4.99c1.03,0,1.99-0.31,2.78-0.85l2.72,2.72c0.2,0.2,0.45,0.29,0.71,0.29 c0.26,0,0.51-0.1,0.71-0.29C318.95,113.47,318.95,112.83,318.56,112.44z M308.65,107c0-1.65,1.34-2.98,2.98-2.98 c1.65,0,2.98,1.34,2.98,2.98c0,1.65-1.34,2.98-2.98,2.98C309.99,109.98,308.65,108.64,308.65,107z"
  })))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 189.8354 110.7178)",
    className: "st66 st75 st87"
  }, "Search"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313.85,136.8H189.73c-9.09,0-16.47,7.37-16.47,16.47l0,0c0,9.09,7.37,16.47,16.47,16.47h124.11 c9.09,0,16.47-7.37,16.47-16.47l0,0C330.31,144.17,322.94,136.8,313.85,136.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.0719,
    y1: 142.0332,
    x2: 191.0719,
    y2: 171.4451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st65",
    cx: 191.07,
    cy: 153.66,
    r: 12.97
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M191.16,151.42c1.44,0,2.61-1.17,2.61-2.61c0-1.44-1.17-2.61-2.61-2.61c-1.44,0-2.61,1.17-2.61,2.61 C188.55,150.25,189.72,151.42,191.16,151.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M196.57,156.04c-0.93-2.06-3-3.49-5.41-3.49c-2.41,0-4.48,1.43-5.41,3.49c-0.16,0.35-0.16,0.76,0,1.11 c0.93,2.06,3,3.49,5.41,3.49c2.41,0,4.48-1.43,5.41-3.49C196.73,156.8,196.73,156.4,196.57,156.04z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9429,
    y1: 141.503,
    x2: 241.9429,
    y2: 154.7166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M217.85,147.55v2.23h-1.45v-2.24l-2.43-4.04h1.54l1.68,2.79l1.68-2.79h1.43L217.85,147.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9429,
    y1: 141.503,
    x2: 241.9429,
    y2: 154.7166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M220.45,147.36c0-1.45,1.12-2.49,2.66-2.49s2.65,1.03,2.65,2.49s-1.11,2.49-2.65,2.49 S220.45,148.82,220.45,147.36z M224.33,147.36c0-0.83-0.53-1.34-1.23-1.34s-1.24,0.5-1.24,1.34s0.54,1.34,1.24,1.34 S224.33,148.2,224.33,147.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9429,
    y1: 141.503,
    x2: 241.9429,
    y2: 154.7166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M231.55,144.95v4.83h-1.33v-0.57c-0.37,0.42-0.91,0.65-1.5,0.65c-1.21,0-2.06-0.68-2.06-2.17v-2.73h1.4 v2.52c0,0.81,0.36,1.17,0.98,1.17c0.65,0,1.11-0.41,1.11-1.3v-2.39H231.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9429,
    y1: 141.503,
    x2: 241.9429,
    y2: 154.7166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_57_)"
    },
    d: "M235.85,144.88v1.29c-0.12-0.01-0.21-0.02-0.31-0.02c-0.77,0-1.28,0.42-1.28,1.35v2.28 h-1.4v-4.83h1.34v0.64C234.53,145.12,235.11,144.88,235.85,144.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9429,
    y1: 141.503,
    x2: 241.9429,
    y2: 154.7166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_58_)"
    },
    d: "M244.81,145.78c0,1.4-1.05,2.27-2.73,2.27h-1.27v1.73h-1.45v-6.28h2.72 C243.76,143.5,244.81,144.37,244.81,145.78z M243.34,145.78c0-0.69-0.45-1.09-1.34-1.09h-1.18v2.18H242 C242.89,146.86,243.34,146.46,243.34,145.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9429,
    y1: 141.503,
    x2: 241.9429,
    y2: 154.7166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M248.84,144.88v1.29c-0.12-0.01-0.21-0.02-0.31-0.02c-0.77,0-1.28,0.42-1.28,1.35v2.28h-1.4v-4.83h1.34 v0.64C247.52,145.12,248.09,144.88,248.84,144.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9429,
    y1: 141.503,
    x2: 241.9429,
    y2: 154.7166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M249.35,147.36c0-1.45,1.12-2.49,2.66-2.49s2.65,1.03,2.65,2.49s-1.11,2.49-2.65,2.49 S249.35,148.82,249.35,147.36z M253.24,147.36c0-0.83-0.53-1.34-1.23-1.34s-1.24,0.5-1.24,1.34s0.54,1.34,1.24,1.34 S253.24,148.2,253.24,147.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9429,
    y1: 141.503,
    x2: 241.9429,
    y2: 154.7166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M257.13,144.85v0.21h1.24v1.08h-1.2v3.64h-1.4v-3.64h-0.74v-1.08h0.74v-0.22c0-1.09,0.66-1.79,1.87-1.79 c0.39,0,0.81,0.08,1.07,0.26l-0.37,1.01c-0.15-0.11-0.35-0.17-0.57-0.17C257.35,144.15,257.13,144.38,257.13,144.85z  M259.61,143.5c0-0.44,0.35-0.78,0.87-0.78s0.87,0.32,0.87,0.75c0,0.47-0.35,0.81-0.87,0.81S259.61,143.94,259.61,143.5z  M259.78,144.95h1.4v4.83h-1.4V144.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9429,
    y1: 141.503,
    x2: 241.9429,
    y2: 154.7166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M262.49,143.12h1.4v6.66h-1.4V143.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9429,
    y1: 141.503,
    x2: 241.9429,
    y2: 154.7166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M269.89,147.76h-3.65c0.13,0.6,0.65,0.97,1.38,0.97c0.51,0,0.88-0.15,1.21-0.47l0.74,0.81 c-0.45,0.51-1.12,0.78-1.99,0.78c-1.67,0-2.75-1.05-2.75-2.49c0-1.44,1.1-2.49,2.58-2.49c1.42,0,2.51,0.95,2.51,2.5 C269.92,147.49,269.9,147.64,269.89,147.76z M266.22,146.94h2.38c-0.1-0.61-0.56-1-1.18-1 C266.78,145.94,266.32,146.32,266.22,146.94z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: -566.9445,
    y1: 613.4018,
    x2: -566.9445,
    y2: 604.2849,
    gradientTransform: "matrix(0 1 -1 0 921.2845 719.5233)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5070FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2059,
    style: {
      stopColor: "#447EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5957,
    style: {
      stopColor: "#25A3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D0FF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M311.66,159.28l5.95-5.95c0.41-0.41,0.41-1.08,0-1.49l-5.95-5.95c-0.41-0.41-1.08-0.41-1.49,0 c-0.21,0.21-0.31,0.47-0.31,0.74c0,0.27,0.1,0.54,0.31,0.74l5.21,5.21l-5.21,5.21c-0.41,0.41-0.41,1.08,0,1.49 C310.59,159.69,311.25,159.69,311.66,159.28z"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 215.52,
    y: 155.5,
    className: "st74",
    width: 61.53,
    height: 6.52
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 215.5249 159.168)",
    className: "st66 st75 st76"
  }, "Lorem ipsum dolor sit")))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M332.03,74.7h-9.58c-0.44,0-0.8-0.36-0.8-0.8s0.36-0.8,0.8-0.8h9.58c0.44,0,0.8,0.36,0.8,0.8 S332.47,74.7,332.03,74.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M332.03,78.39h-9.58c-0.44,0-0.8-0.36-0.8-0.8c0-0.44,0.36-0.8,0.8-0.8h9.58c0.44,0,0.8,0.36,0.8,0.8 C332.83,78.03,332.47,78.39,332.03,78.39z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M332.03,82.07h-9.58c-0.44,0-0.8-0.36-0.8-0.8c0-0.44,0.36-0.8,0.8-0.8h9.58c0.44,0,0.8,0.36,0.8,0.8 C332.83,81.71,332.47,82.07,332.03,82.07z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M169.54,78.14l6.13,6.13c0.42,0.42,1.11,0.42,1.53,0c0.42-0.42,0.42-1.11,0-1.53l-4.37-4.37h9.42 c0.55,0,1-0.45,1-1c0-0.55-0.45-1-1-1h-9.42l4.37-4.37c0.21-0.21,0.32-0.49,0.32-0.77c0-0.28-0.11-0.55-0.32-0.77 c-0.42-0.42-1.11-0.42-1.53,0l-6.13,6.13C169.11,77.04,169.11,77.72,169.54,78.14z"
  })))), /*#__PURE__*/React.createElement("g", null, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M312.92,461.93H188.81c-9.09,0-16.47-7.37-16.47-16.47l0,0c0-9.09,7.37-16.47,16.47-16.47h124.11 c9.09,0,16.47,7.37,16.47,16.47l0,0C329.38,454.55,322.01,461.93,312.92,461.93z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.2139,
    y1: 438.5203,
    x2: 192.2139,
    y2: 456.7468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M182.48,444.21L182.48,444.21c-0.34-0.59-0.14-1.34,0.45-1.69l8.71-5.03c0.39-0.23,0.88-0.23,1.27,0 l8.59,4.96c0.59,0.34,0.79,1.1,0.45,1.69l0,0c-0.34,0.59-1.1,0.79-1.69,0.45l-7.36-4.25c-0.39-0.23-0.88-0.23-1.27,0 l-7.48,4.32C183.57,445,182.82,444.8,182.48,444.21z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.2725,
    y1: 438.5203,
    x2: 192.2725,
    y2: 456.7466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M185.77,446.75v5.75c0,0.62,0.5,1.12,1.12,1.12h10.77c0.62,0,1.12-0.5,1.12-1.12v-5.75 c0-0.4-0.21-0.77-0.56-0.97l-5.39-3.11c-0.35-0.2-0.77-0.2-1.12,0l-5.39,3.11C185.98,445.98,185.77,446.35,185.77,446.75z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M289.27,440.56c-0.18-0.27-0.48-0.43-0.81-0.43h-12.93l-0.86-2.2c-0.15-0.37-0.51-0.62-0.91-0.62h-1.62 c-0.54,0-0.97,0.44-0.97,0.97l0,0c0,0.54,0.44,0.97,0.97,0.97h0.96l3.22,8.28c0.15,0.37,0.51,0.62,0.91,0.62h8.83 c0.4,0,0.76-0.24,0.91-0.62l2.4-6.07C289.49,441.17,289.45,440.83,289.27,440.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M278.38,449.48c-0.96,0-1.73,0.77-1.73,1.73s0.77,1.73,1.73,1.73c0.96,0,1.73-0.78,1.73-1.73 S279.34,449.48,278.38,449.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M285.09,449.48c-0.96,0-1.73,0.77-1.73,1.73s0.78,1.73,1.73,1.73s1.73-0.78,1.73-1.73 S286.04,449.48,285.09,449.48z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M221.9,442.99c1.61,0,2.92-1.31,2.92-2.92s-1.31-2.92-2.92-2.92c-1.61,0-2.92,1.31-2.92,2.92 S220.29,442.99,221.9,442.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M227.95,448.17c-1.04-2.3-3.35-3.91-6.05-3.91c-2.69,0-5,1.6-6.05,3.91c-0.18,0.39-0.18,0.85,0,1.25 c1.04,2.3,3.35,3.91,6.05,3.91c2.69,0,5-1.6,6.05-3.91C228.13,449.02,228.13,448.56,227.95,448.17z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M317.11,443.12h-0.3c-0.89,0-1.34-1.08-0.71-1.71l0.22-0.22c0.39-0.39,0.39-1.03,0-1.42l-0.81-0.81 c-0.39-0.39-1.03-0.39-1.42,0l-0.22,0.22c-0.63,0.63-1.71,0.18-1.71-0.71v-0.3c0-0.55-0.45-1-1-1h-1.14c-0.55,0-1,0.45-1,1v0.3 c0,0.89-1.08,1.34-1.71,0.71l-0.22-0.22c-0.39-0.39-1.03-0.39-1.42,0l-0.81,0.81c-0.39,0.39-0.39,1.03,0,1.42l0.22,0.22 c0.63,0.63,0.18,1.71-0.71,1.71h-0.3c-0.55,0-1,0.45-1,1v1.14c0,0.55,0.45,1,1,1h0.3c0.89,0,1.34,1.08,0.71,1.71l-0.22,0.22 c-0.39,0.39-0.39,1.03,0,1.42l0.81,0.81c0.39,0.39,1.03,0.39,1.42,0l0.22-0.22c0.63-0.63,1.71-0.18,1.71,0.71v0.3 c0,0.55,0.45,1,1,1h1.14c0.55,0,1-0.45,1-1v-0.3c0-0.89,1.08-1.34,1.71-0.71l0.22,0.22c0.39,0.39,1.03,0.39,1.42,0l0.81-0.81 c0.39-0.39,0.39-1.03,0-1.42l-0.22-0.22c-0.63-0.63-0.18-1.71,0.71-1.71h0.3c0.55,0,1-0.45,1-1v-1.14 C318.11,443.57,317.66,443.12,317.11,443.12z M310.58,447.38c-1.48,0-2.68-1.2-2.68-2.68c0-1.48,1.2-2.68,2.68-2.68 c1.48,0,2.68,1.2,2.68,2.68C313.26,446.18,312.06,447.38,310.58,447.38z"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M257.19,450.63l-3.55-3.55c0.66-1.02,1.05-2.23,1.05-3.53c0-3.58-2.92-6.5-6.5-6.5 c-3.58,0-6.5,2.92-6.5,6.5c0,3.58,2.92,6.5,6.5,6.5c1.34,0,2.58-0.41,3.62-1.1l3.54,3.54c0.26,0.26,0.59,0.38,0.93,0.38 c0.33,0,0.67-0.13,0.93-0.38C257.71,451.97,257.71,451.14,257.19,450.63z M244.3,443.55c0-2.14,1.74-3.88,3.88-3.88 c2.14,0,3.88,1.74,3.88,3.88c0,2.14-1.74,3.88-3.88,3.88C246.05,447.43,244.3,445.69,244.3,443.55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.0283,
    y1: 92.8981,
    x2: 106.0283,
    y2: 162.8597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M106.03,153.42c-16.47,0-29.87-13.4-29.87-29.87c0-16.47,13.4-29.87,29.87-29.87 c16.47,0,29.87,13.4,29.87,29.87C135.9,140.02,122.5,153.42,106.03,153.42z M106.03,103c-11.33,0-20.55,9.22-20.55,20.55 s9.22,20.55,20.55,20.55c11.33,0,20.55-9.22,20.55-20.55S117.36,103,106.03,103z"
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 95.1567 126.0469)",
    className: "st6 st104 st105"
  }, "100%"))), /*#__PURE__*/React.createElement("g", null, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M106.03,224.99c-16.47,0-29.87-13.4-29.87-29.87c0-16.47,13.4-29.87,29.87-29.87 c16.47,0,29.87,13.4,29.87,29.87C135.9,211.58,122.5,224.99,106.03,224.99z M106.03,174.56c-11.33,0-20.55,9.22-20.55,20.55 s9.22,20.55,20.55,20.55c11.33,0,20.55-9.22,20.55-20.55S117.36,174.56,106.03,174.56z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.0282,
    y1: 179.4397,
    x2: 106.0282,
    y2: 267.6313
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M106.03,224.99c-16.47,0-29.87-13.4-29.87-29.87c0-2.57,2.09-4.66,4.66-4.66s4.66,2.09,4.66,4.66 c0,11.33,9.22,20.55,20.55,20.55c11.33,0,20.55-9.22,20.55-20.55s-9.22-20.55-20.55-20.55c-2.57,0-4.66-2.09-4.66-4.66 c0-2.57,2.09-4.66,4.66-4.66c16.47,0,29.87,13.4,29.87,29.87C135.9,211.58,122.5,224.99,106.03,224.99z"
  }))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 97.5054 197.6084)",
    className: "st6 st104 st105"
  }, "75%"))), /*#__PURE__*/React.createElement("g", null, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M106.03,296.55c-16.47,0-29.87-13.4-29.87-29.87c0-16.47,13.4-29.87,29.87-29.87 c16.47,0,29.87,13.4,29.87,29.87C135.9,283.15,122.5,296.55,106.03,296.55z M106.03,246.12c-11.33,0-20.55,9.22-20.55,20.55 c0,11.33,9.22,20.55,20.55,20.55c11.33,0,20.55-9.22,20.55-20.55C126.58,255.34,117.36,246.12,106.03,246.12z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.6345,
    y1: 242.0395,
    x2: 118.6345,
    y2: 303.0923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M106.03,296.55c-2.57,0-4.66-2.09-4.66-4.66c0-2.57,2.09-4.66,4.66-4.66c11.33,0,20.55-9.22,20.55-20.55 c0-11.33-9.22-20.55-20.55-20.55c-2.57,0-4.66-2.09-4.66-4.66c0-2.57,2.09-4.66,4.66-4.66c16.47,0,29.87,13.4,29.87,29.87 C135.9,283.15,122.5,296.55,106.03,296.55z"
  }))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 97.5054 269.1709)",
    className: "st6 st104 st105"
  }, "50%")))), /*#__PURE__*/React.createElement("g", null, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M400.99,309.03h-19.9c-4.94,0-8.95-4.01-8.95-8.95l0,0c0-4.94,4.01-8.95,8.95-8.95h19.9 c4.94,0,8.95,4.01,8.95,8.95l0,0C409.95,305.02,405.94,309.03,400.99,309.03z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st108",
    cx: 381.97,
    cy: 299.8,
    r: 5.13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M400.99,335h-19.9c-4.94,0-8.95-4.01-8.95-8.95l0,0c0-4.94,4.01-8.95,8.95-8.95h19.9 c4.94,0,8.95,4.01,8.95,8.95l0,0C409.95,330.99,405.94,335,400.99,335z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st109",
    cx: 400.09,
    cy: 325.77,
    r: 5.13
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st51"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 505,
    height: 534,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgEAAAIeCAYAAAAiZtwvAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAALO5JREFUeNrs3c9yHNeV5/F77s2s P0ABJNwqtdRtTUQrbC2k8EoRvbVeYJZ8HpGvMa/A5bwAe9sRWnWYC7VDEdOyLVlQCyLxp/5k3nvm nJtZBVCWx2OJpAjq+5GTVSiiIEU5ked3/2YIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+JkQ PgJw7gOvBOUjABdC4IWc4993fX3w7Pl/nw8LL8lfnGsf61+5NBMMQAgAfnjRt0K/u+D+7n25951v Pj19zO8AflLL5fv7Qv/Q//jgsV6HhF04EAIBCAHA3y78Y9G3gu+vfFSL/G/D+fmnEj4MYX12Ul/f XHz5zLn/6/ArPkW8VP8Zfr9/Pl28VQv87ORMwychHB19oR4Oaih4aKGghgGCAAgBwP+z8O+L/nuf ihf8zcVCfrn6s2yWh7Jdn0m3mUvenos1v8LS3tJtzm/8DrzBp4qX5Ov9s2+nR3YSn4b05Ejb6Uon sxM9vViU6eJCZ5+dqQeCR95bQBgAIQDwc/ZGV/+9ofCfn78t63e96H9pRf9Izo+2sbs7l6MnXey7 qWymXVx0E8kHreR+ZUcrpV/bz1qE+WzN7wFeutTM9OIihNj0mppO01Wnq3kq001bLhaTMluflf8+ n5TD5WFZni7Lo+XpzSBACAAhAD/H4j+0+u9Zq//0dCnezf/kzU0cCv8b8Wi2iquLbbyKkuaTPnbN PE42fdwGSbOSpE/ZQkGJ08lWSk72M2dBS8fvAV7+CR1bjSlrjEU3XdamjaUPmqeq2R+3WnLXHvbH IeTTiy/Lna+m5ZN3T8oQBO4rvQEgBOBnW/xPl6fxf1ws5NvFRXx6epoW8zuxtcK/sqMRa2RZ0d/a o5SuSSIppzZGa3zlvsQmlpjt2qtNFC1RWr+aaj/+LrR84njBuiDSaB+TihSVXLRoyI0V+yBNrzH3 llYtqvZ93DT2uO375rJ/0m/yL1e/yUOPwL3CsAAIAfgZnJve6HkgN4v/8vQyenf/TJp0GWOaSEyS 28YLv/alDZPUbK34i1oeaKI9Zjtiky0ESOiTNb9i9BBgl2D1hKBF/DkfOV7ayW1nXJaolkdLTLkU DwB96aVttr2GrQXWbbfJm5jLNh2UraxTFxeT7ql93/L0cXn0KBSGBUAIwOvf+q9j/jeL/xtW/L+y dv0v0nleNTFb7W9zaxfQVlNpJ6ltS99NQmxaK/NtyKkN/jgGgeK9Ax4G7AtrftUgEOIQANTCgD8m Pn+8IHkfAqKKSpFYivrLWXtJaVty2RQpG1VdtU27Kv12nS0CTMJ08/Q4bC9PL/t/ON/mYVig9gYQ AkAIwOt2Tt6vXf8fPQrx/L235cnn78Q7zefJW/674u+Ff95N2yybSRGpR9I8LaGdxFCmdmWcWH2f +GMsYSJRmlByW0KyAOBBoCRVu4JaBAj2jXHocxh+HyL/J+AFqZ34cex7slJvAcBOwL6odPb1Jmhc 2TddlSKXInIZk1xuNvlq0sh6EzeblLfb9eykf9/e95C5AXgOGj4CvIqt/w//91k8ffdEjs9Cmi4u rHF+ktbrvl3Hi3aerfj3zWQT+mnSdhqlm4Ui0xAnM2vOz1TTVDTPNIapFfyJFfWJXW5ba/G30Yu/ NfbtKpysKRajX4rFm1P2p1d/uzb7hRp4MWe5VX4f+g+eANQjgQWA4BNSNvZ3q6Dlys7LieXU6H/d 9X1p7XSPXewnqesvZyfRl72erv5dKP4gBOD1CgD3H0ht/Z+cyX8fTdLxk3UqKabjxaQpm74tUSZN H6Ze/K16z1LRmbXwZ1naech5rprn9qPsKDOr5zP7oVO70E7t50/sAttanW9rAFBtZOgBiB4A/Mps //rhv6HmAA8EdJLhedPhTNOoQ9oMPhTQW4t/ay9u7Hy8ChLPrfgnib2dilLsu3pLCtvY5G0TpFtc bOPx4iKef/V2Cfe/GDsCOFdBCMCtDgD3rfX/0ALAb+vYv7f+D5fWFOraZtt27WwVJnY1nKZJnGof 5o0VfivUB3bBtMIfDkSLPz+wnzW3nza3y6wFAe8R0FkMcaJSJvZaa/8qO9/VrqXiw/7R6n/0HgAJ tS9g7AmokYCrKl5Q1pUaAPwPO82ynXZ9DQAivlmFBVZNdlra6ViyPW6j6tpO1Ink1GyaPuVpF9P6 su5+Oe6KSW8ACAG4tS0juTn57w/z/0h31tNU+sPGW//9tpvYMc3TNJUuzT0AaEgHochBjPHQrqSH 1qg6tOb8gV1ILQTIwRAAwtxaTzNrYU1L0EntCfDir6Gxgt/IMAXAAkDxICDD1Xm8nnoDzS+rzAvA 81bqmTaM4dccUMcFujoUEMKV+rk5nIfZIqq9VlYxpal2/URCrKtfJqscL3Uu+WxW74PxkE8VhADc 5gBwzwLAZ5+dxT+8+WW80/xLCrM/tf06tmWTJ42UmbX65yHrXGM8sFbRoTWkFtEKfyllESUehqKL Er03IBzaz5xbgR8CgMrMJwX6nACr+U3R0vqEwDBM/o9jT0AdChjmA+waa94KU3oC8CLOeB36A8S7 n0oYFgt0dqz9WixDQuiD9wwUmds3TUPJk9DEpu9DKl2JyXe8bM7rJlfPdjHQIwBCAG6PZwLAm29u YpfvNmGxag7CyWTbbqdha8U/2YWweGu/HFqpXtjzhV3pjooVfiv2i2KvWV0/lFIOay9A8J4C9avj 1P4NUxl2/mm11DkAzVj8U+3wDxrHi2e4ngCgshsP4JKK53/S1/H73Wz+GgI0yFZ8CGDQ29+svQfL zuOppdRWkzS+yZW9ObVNkk3nZ/JyuAHW4q0w3g6bsxWEANymAHC/DgHsAsAf37jbxPPcTvv15Kqv 3fjzYG2elKzFr+XIWvJHdp07shJ9bO304XkIC9F4aNfUQ3t+ENR7AWrzyIu/d/9PhjkAYTyGIYDh UYchgNr00hszAOQ6CAAvqEPAx5w8BFhLvxfVpMOJ6L0CG3vmAcAnsjaWEmoAKDlF+y7Lunb0Se5u zuXPYX8bbE5WEAJwmwKAXbN8EuDpUuZvfhn/mIcAcCBpsulnVsT7g+Td/d7yD/EoRjnWUu6EGgDi sYWCYwsFi3rnH58ToHogUicEzrz1JCqtPd+vBKhDAHUYwFv++/F/GTpnv28VgFzvFwA875Nfx1NM QxFfJiB1saAHgG3wZawyzFvRYXggaYl1U8GgSXyq4GJh6WHDZwlCAG5rI6guA/ztMAmw+ZfULlaN 9wBECwATCwBZZGFtpKOoeqwxW/GXO0niHWs73fGeALuQHqsWHw44tAvmwTD2X2YS4kTUlwKOLf96 MQ1j67/2APjldhz/37X+v7tVsNz4E3gRSUCHXwQJeUibvlfAMFdFx0dfteLnrg4JIfqmFvY26UuR 3Od60v46/Cqswr/zeYIQgFsTAOo8AN8HwJcB+iqAMFu1ByHUIYB9ANDuWFNzbMX6bgxyV+uhd+39 d0IJx3bVtAAQD301wDA7qvgkQCv+QyuqrgDwLdmGi2ocm/oyXH51vOPKsEPQ94YU4MXG4Ot7Ye/X oQxDVePS1LGnqvidBSSHLMPuAr1cL1l54/oH3h8PgBCAV7n9s1sKeGpXsmMf5+wPm77uACh1DkCJ eihFjzTGO3bVu2t1+sSulScxWggo9rWIB4Aj+1ljABALADq1130JYOvFPwwTqHbj/jcCwL7bf/xD vv8/EXjhvwi7EYEwbFAl+80DRHYBwBOqxmHEYM/nuGY+QBACcBsDwDAP4MPPzuLR0SR2x6XJs6ad dJNpabqZbH15XzlSbY9j1Dul6Im96xf21pOi5a6FhDv2c46C6sJXAchu/H83+U/rBkC7zX/i7oKq +xAgNwr9X1v+Ry8AXsqvw7hSUHYLBa7PUa13svD9hGv3f6izAjkz8WKxJQpesOF+AD4R8Mmb78Rv JimJJYAscbJtykxLOiixOQyajlTKXSv6J1bKT+ySeGJvPbGLoT/eqYevDJC6H8A4FFB7ASYWEuo8 gDoRcNj2Lw4bAIebPQDy1wMA8JP8ZsgunNahgHgjNwP0BOD16AUY9gN4HHwewFnK00nblWaSOp01 TZhr0cNSewHkTrQWv10Y71qL6EQ9APhcAPHRAz0adgNU3w1was/b8dytG/9cF3yVmxdWlvsBAD0B +MkCgA8DDPsBLA8v40zeSpYCml77aWwms2IBIFsAsG87DlLujBMA73oQEFEfAjge9wSorf8w7APg QwCt+DDAd3YAfLblT6sfAAgB+ImMywFPH8uTNzfxmz+lVDan7Uxk0miahj7MPQT4zn8hpmMNMoaA YIcc167/IL5D4KGEMPYAhGESYF1Hrcn+FTHIM+P+FH8A+DswHIAX1AsQ6l3Ozt87k+XZSdzauVY2 TZu1m0ps5kW6w6jNQn0/AC0+3n/H3lQ3BfKeAa1LAS0khDisAhgCwDgEMMz+D7tFVjdWXQEA6AnA K9ELsJQnn78TrYKn1K8aiwFtCs3UlwSqpkPxQm8tfqvkx1H0WKIcWQv/yF731r/fFXAMAPr9AeDG sj8AACEAr1AvwOny3+Kd5vP0bXfZ6Ka0fWmmfdKZtfwPYgyH2Sf81fkA4bgEO9QCQJBFGPYCsKCw GwKQvxIA6PoHgB+D4QC8AN4LEOQP83+V5eIinq/7JrTSNtpPNca5+kz/eidAn/XvGwB5b0C9F8Ai iPrdAGd+I5V6D4CgfvMfAgAA0BOAV9+wIuD8/O0aALwXIOamaUUm0ScE1kl+dcOfOhwwjv37sMC4 AsCHAMS/r/UbqmgNAH6eFgIAANATgFeY7HsB3vxFnJ6GdHgSk7a5zZqnmuIsZJnHmA9LUWv5x4Xf C0D1OgCIjrdSDep7AYyb/wy7qQy1nwAAAPQE4NXsBbgfQu0F+LaPi/k2Sm6b0Je2iEwkq9/w58CK /kGM6UBFrfj7HgA+CTDM7e0z3a8CiMm3Ag67EKAs/wMAegLwavvd+7J+1wr2+p9kXp6mXLomp3nb aJ6GKDPVXIcDVMuh+NyAYXhgFtQCgoTaAyD1vNR0vRPgfhiAzxcA6AnAK2gcCngsm4uFzOSrtIqS pPh8gO0ka5mKF/og89r1X+cF+HMPATruBFhvldbsbgP8nQBALwAAEALwaro5FHAR11dHMeZNo80w FBCDTLPoTErYFf55KcWfewAYVwKERm7OA9jvAUAAAIAXgeEAPD/7oYC5DwXELIcpaN9ob6188Z6A OLPyPvOxfx8CkGjFX4d7AfhKAHtn7QXwcHp9K2CGAQCAEIBX2fWqgPkvJCzeimEtaZq7Rlv7R9s2 apgW1VmKteU/U4kWAHbbAQ8BIIx3BLwOAPQCAMCLxHAAnqPfhl+ujmRxsY2NhNTZoUXbJP3EZ/1H X/5XlwDKGABknAew2xFQk1wPAwg7AgMAIQCvvN18gE9lszyUzbSLfZOjTFIjKTZBkrf0J5rCxHcC FL8fwLgSQMN+V0A7F0Wu7wpILwAAvGgMB+D5uDkfYPs0lsM2hdI3qqFVzZMocRKKBYFa/GVi9b0d lgNKstIfVXUYClAZ7wjIXAAAoCcAr7raWr9nx+biS1mfr+J2chDTWpKdXClrbKzEtyq11T+pdwSs AWBYDeC9ABYA9pMBx9Y/PQAAQE8AbocHcnpqhXv+r+Hu8RcSuyPZeOmXLoVUmlB8zL9O/muvH3e3 Bg7xxjGGAPYFAAB6AnCL+KTAP0vfTWXb9jHJpvYEiHoAsMMLv/pRA0EzhIB6c6Bkr8dhW2AmAwIA IQC3y/3hwScF9ouJ+KTAnNoYh41/ksQxCMTQ1KWAulsNEJJ6AJBgWeFmACAIAMDLwHAAfqRh8t75 +f+ScBRkWxZxIcUKe4lZJUUfEFBtoh06tP7rhkAyLAmMMq4GiPUeQcwHAAB6AnC7/O6hhA8/tCf/ FBZ9K2WSLAIUL/CpyNDiLyGm8Z4AYwB4di6APjMHgPkAAEAIwK3gKwPWZ59JtzmTfLCSkpPkvolF rKWfreiXcVjAlwN6EJCx+OtuMqDQAwAAhADcZnl7bsW/lbYrsW2ipFiiWhDwQ6T4BECfKBgtDERr +Q9zAa6XBQalBwAACAG4NfZF2/cICMtlfV4mUXLeRC3RKr5G+9OKvg/7D4GgzgUYW//72YD1CRkA AAgBuEUe7Cu3R4DSN1JyJ9pEKdGKvorU3oDgj1bz/WsdtwfWserbC/vnAABCAG6P09PHtYB3m/Ox kM+C9wLULQDiUPTrfsDqSwF9wqDWMHAdBKj/AEAIwK03n61FS1f3BU5ahmJvKUCHYj+uCLyxGoAp gQBACMDt9uvwq2e+Vu2Hbv/9SaY1DPzt5X8kAgAgBOB2uH/zizf+4q9Vy7gCIH7PKXczEFD8AYAQ gNdE+900IPuzTfXGPACWBQIAIQCvpXTjLFMv/qLjpIDrIKB0AwDAT4J7B+Alkmejp/KJAAA9AQAA gBAAAAAIAQAAgBAAAAAIAQAAgBAAAAAIAQAAgBAAAAAIAQAAgBAAAAAIAQAAgBAAAAAhAAAAEAIA AAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAh AAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAQgAAACAEAAAAQgAAACAEAAAA QgAAACAEAAAAQgAAACAEAAAAQgAAACAEAAAAQgAAACAEAAAAQgAAACAEAAAAQgAAACAEAAAAQgAA ACAEAAAAQgAAACAEAAAAQgAAACAEAAAAQgAAACAEAABACAAAAIQAAABACAAAAIQAAABACAAAAIQA AABACAAAAIQAAABACAAAAIQAAABACAAAAIQAAABACAAAAIQAAABACAAAAIQAAABACAAAAIQAAABA CAAAAIQAAABACAAAAIQAAABACAAAgBAAAAAIAQAAgBAAAAAIAQAAgBAAAAAIAQAAgBAAAAAIAQAA gBAAAAAIAQAAgBAAAAAIAQAAgBAAAAAIAQAAgBAAAAAIAQAAgBAAAAAIAQAAgBAAAAAIAQAAgBAA AAAIAQAAgBAAAAAIAQAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAh AAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAAEAIAAAAhAAAA EAIAACAEAAAAQgDwAunwUMYDAEAIwOsrh+uCLyIaVGoSUH8+hgLZpwMAACEAr4Hu2S+96Jcbz/d1 XwgAAEAIwK10/+YXX//FX4tEHVr6uwRwcxzgZgAgCwAAIQC30n+G33+n+Dfe46/XZd8Kfu0B+Fst f8IAABACcCut1jOV2KoPBmSJVvi1Fn8Rr+5qX4xTAnZhQKn7AEAIwK21XL5fy3g7PRrL+TpILOrT AqVo7REoan+ITwuM/soQDvyfIRzwIQIAIQC3z8f7Cn7qJ1TTa0ytSl+s3EvxACBqj8EftRZ/eSYA hGGioJAEAIAQgNtkX7ini7c0nJ4OJ9W2aErT4r0BxQKA/ekhoAQPA3YE7x8YBwL23QD1CTkAAF6m ho8Az0uaHGlqOu3ipGhv5T/FEr3ox+BDADmIZiv0HgAsFITiVX+YKzAsGRznCQifJADQE4Bb4qEd s5N3tZ2eaLqaa0zZwsAQADSF7JMDhkPr47hjQLFyX8Y+AKYHAgAhALfSB/c0fPKJPflT8J6AuM0a S1+0CTlq3TQwRy/+46GxvrYLATUIyDNLB9lACAAIAbgFvPf+QTg6ek8nsxNdHbRlO4kle09A8bF/ HQq/aB/qLsLD1/W59xQMEwF8wsCu+BMAAOAlYU4Anpvp6aWWeauhTSUGCwIhZ8sIWTwAaOxV7VGk ryGgrhoMRWTXE8BSQQCgJwC3z33/49/CH+b/qE17pCn12ueulNoDYMU/ixV/DwCxszrfh7ILAzIM C4xDAtfLBAkDAEAIwC3xsQ4bBv0+fDvd6KZvSjsNOQW1w3cM0l698Acv/qFTCwBhNyQQbkwOVPYP BABCAG6TWrR9hYDvFZCerHUya0qXYyk6zgWI0lnLvws6PIo/D6EfVguozxPYzQ24gcmBAEAIwO3w wT2dfXam7XSlq64tVuGzDweEPvb2rBcLABJ1K1osDNghoRMLAsMkQclyY6VAYH4AABACcJsMKwSO /uG9ktpOmz6ViTT9vifAAkBQv69Q3NYeAQ21N8DnBoS6b4AQAACAEIDbR64nB/55pbPNtPSHIWdd 1w0DQpHOewBUZGPfuZUgGyvzW3vDMFFQwm6OwBgEdkMBDAkAACEArzr1yYGPlu/rdHGh53eelLZf leyFPXsvQO6KF30NWw26KaFsPQyojkHA5wcMmwrt7ylAjwAAEAJwy8xOzrT9dqWrbVNm0vYquY+h qa3/KLoRCwFRwtrDgOx6A4KOcwPGewrs9w2gNwAACAG4Baxsf/BYjz59T4/OJ+WgaO6D5kls+1D6 rrb8S1pbi98OWYsdWsNA2Nh7uzDsKNj7JkJS7zIo9AYAACEAt8Z9/8M3DTrX+WJSVwiEbe5j025L iBsVtUPWlhfskFW051JDgB0q21CXC0q906DvG0BvAAAQAnA73JgX8Jaer+dlXjRLE7tt7roYuq0X ffu2lRX1K/v+lao9V38teEAY9xEI42qB4daC9AYAACEAt8IwJOD7BRydf126cUhAcuyypI0WK/ga Vh4ArLE/PA5hYONzBnzvgFCXDfq9BYZ9A+gNAABCAG6L+yEcHX2hPiRwsZgUTV0fmthF1W2UMgwH BL0SiZdqj1brVz404EFgWDZY9xDYbSmszA0AAEIAbof9kMCdr6bl2Ar5VksOXaohQJOskw8HqK6K WBDQcCkhXtr7rjwIWKvfA0I39giMQUBv3E+A3gAAIATgFWal/OFj9d0D714symEpuaS+Tzrd5q5s gjZW7ONVyOqF/9J7BWoIqHMFhqWDdTdBGbYUlr/YSpggAACEALzC/K6Cp/pfiwtd65v5KM17aTdD b0DsvdCvRMKl2mGF/UJUL+vwgIaVjBMF7ejUb0V8fbthhgUAgBCAV9xwV8EPHuvydFmGCYIxh1XX pxK2ucsbCenKewOkyKX3BmiUi6DlUrxXQHQVpIaAcSOhkn3vgH0QkJvbCgMACAF4xQz3EvDegNPl YVlrzBqn/WY22yZfJRD7dZZyVXsD1HsCwoVqvJAYLQzIlc8ZqHsJ7CYK1h6BMQTspwgQBACAEIBX tDfgY73ZG6Bp0Ydu0/m4QMne5R+vSsmXMci5FfTzGPTcA4EV/4u6j4CqTxKswwJBpJO6kZAHgTgO DRAEAIAQgFvTG5DTvI+zsG1TXNfxfx8KkOJLBWsQCB4Egl7oLggEqRMFtd52WMY7DeqN2w4TBACA EIBb0Rtwt+166ZuuU902qVuLxKui8SKqFf5Qzu0dT+2EfGrx4cLDQN1PwIKA7OcI6I0gwIoBACAE 4Nb0Blglz7npe18lUHq/kZCvEsiXdhqeB5GnGuRpUXnqYcCK/7mqWBioKwh28wN8smAf6oqBumqA IAAAhADcht6A04svS/dk3cdN07XSbkLRVSztZRnmAjyVGJ9YLX+idth7n/rwgG8o5JMF1bcXDrq/ 9fCwYqCGAYYGAOAHavgI8OJ7A1Qf3XuoH342LUe/ybn7Ztqt1ecE5qZtUhOLtEVLK5pbkdhaQW/U z02R5EHVnkfxH6Qi/uN2P3Y4f3X8Qi3QqoTrFwAA9ATgp+8NGHYRfPfdk3J66ZMEv8w5bfpGmk3p t+sY5TLVIYHmqbXwn/ghqt9axf/W3l17BeyHeG/B5XgDos2+R+B6jkCpuwvKboiAXgEAIATgFQkC H+vDh8OwwJP+nVyuUtdm3Vrbf72xwp4tCBTtL6zw+9yAb1XimQb91p9bXR+HB54JAuM8gWHlgL0v 1zEBZZ4AAPz/YjgAL0ntqddHSx8WOCtHR5Pczbo+abNNfYxl2sXYlxRS9GAaRTXaW4ZhgHpo3S7Q C7tI8ecqtchrPXQ/STAk+x7vFIhhNzgwPGGIAAAIAfjpegOsOD+8r5/ce798YF8ch9DLxVa2TS/R goBKsTTQxaBNFNFYJAzj/Fb2ZWjUqwti31onBtohXv99cqDuhgA8D6QxN4yFfzdXgDAAAIQA/IRB 4OMQHj4Iy49COV2+H2bNpYTZibT9OsY+SN+EmPsi2drxyTJDqe14r+3Ry78nAh2KfyjjVsI+F2C3 SmAynNM1EMQxDHi3gAwJgDAAAIQA/IRqF3549NGD8tGjZfjD/Mt88GQt+SDLQZNCtNIf/LEPoUsa knf9Sxx6AIZWvgUAyfZVrrcaltjbX/X2N9lqu78+GbNDU4cOxtUFQxjQ7wkDgUAAgBAAvMQgsF82 +NHpb/J8vgp/vPo6TA5yWOVGUpNDjlaYcxOyBYFG6/R/HbcM9rsK2mFBQHzjIPUbDPXDtsLai7+m MrV/RTue377MMF2Hgd0cg2G8YHyu+/8uQgFe3m/BeN75fbGkJtRhqjarXEEIwOttPz/g0b33g08U /Oc33+n/ePR1OP5GpbMLYGpqh77m3vv6O7UXNBQt4q19K/R2wbQX7Sihs9fsLTUM+DGvfx90aj+h te9phyCgNQzs9xyQcd+BWvB1mH84dFLcCAXfc9kGfuSpP5T43QKW3TyW8bmHgd3tsot3b7GEC4QA vLZB4H6wIBDevfd++ezk8/CLTyf5m3fC9vibFIYg4D38UUuSYrW/ZEk5e9e/tfqtkndS7zAYtvaT tvUxhK390G2sj3FmzSvvEfB5Aq0O53oj9ZpqgUDrFXdcfSBDz4BezxXQZ3YmuvGfDPy4k37XA6A3 97QYXhtWugyjVj7txTNrHt/ZEQdACMDreE38ODx8+CDc8yDw3pkHgeBBIJ5nPdDk+wSrRQCv4SVK n2Ns+6x9b42kLoZYQ4CIbIqWjd9oyC6nGx1uODSvh4Zp8AmDPjygdkidK+ATBi0A1N4BGa+uMhT+ Yc5ADQASbqwwoDcAP95Q9+sf2f6sE1x3m10NK19knPwqaqe9egj2ObDig2J1qov72o63h6f3+UxB CMDtvizWftGHH1gQ+N0QBP7583f0j/nrcHWQw9HsULd5W8K21NUApS19LLEvQX04YGuNeSv6eeNB wG80ZK+trUwf2nX10C6o6zEMTOsh4lsS2yG+gmA3XyDuDvnunIHaTtsNFTzbG6CkAfzdAeDGWMAQ AHqLm734HJcwTHQN4w6Yfq7XYYESiyVfCwdJxUJxalotuQv/GX4ffslHCkIAXpsgcN+CQBh7BL76 PFy9+U5/J2e9av9kbf4jnYRO+2mTrez3GmKfknYl5601nKz1HzcWCtYWBFb29cpvNmQXUN9V8MCK +IEV/5k9n9m1tQYBu7JOPAjIOHFQ68RBu8LW3oFa8eN+OKAuKvhuwa89BsAPONVlNxRQxgBgYVa2 4hNcRTo7tfphwquf58Hqf7EYkIra/2JSvbhI4aDlYwQhAK9rj8DDByFYEPjodK5/mP9HuLOehqYv mr2Eaylt6kuXp1mL9FbFO426tWaT9wSsSykrK9weAK7sRx3a9fbQLrQH9ndz+7u5ve5hYGLfM7Vw 0A4rCCwMqN+wqG5LEMfeAQ8AcWyzDZMIbwSAfbsO+LvshgLque69/XkMAN5j5cfGwudGfE6Lqs97 sSAgOaZcSg4aG63Ht9MjC8aXYbl8337OYz5WEALwOgWBUCcL+qoBXz54ujzVY7tiPvV9gK+6Mp2k 3PiQQK99l9pOep8QWDbWdveL5zpGXdml8srCwaHV60N764FqqEHALr8zK+EzGeYITFWlBgH7uxoE PBDoOFdgmDQ4Thgcp21fF3/fsFiFeVr4uyLAsAhwNzHQB/izDEtcPQBc1UPCeggCPs8ldFK0L41k XyjQd1lT4/MFzsJ08dY4S/VjZWIACAF4zZpLdlF7qPro/gP56FEI5++9rZefTvR4knRzMCth3ZfQ 5tzaBbKXvoup3YbeJwOWdcllZSX8KgW5tIvpQQjxINTHYaKg+LBA7QkIUxlXDoQaBrTuKzAEgJDs cl3vXbCbLHhzVoA34vi/CT8o4spwvwtX5wD4EMBwV8wrO9f8BloXFkSv7OxbiYeBlLZ2lteNNEsb S7xc2wl6pPnOX3YxAIQAvEZBwOqubygUHpSwPJEPz8/Ckzc3ugxvlSirIptZLpMupyb6JsNdbNI2 Ztn0kqxVlVcle6vKWv+iVvxlLsVCQAwza/XPrFXlvQF11YB6r0DUYeWAamt13zcW8p6AusGQ38Po 5qqBcfPBcVUX8HfwniMdb3o1zA3IdQ6AFXvvAfAAEOrdMuU8lGLnb1yVUjaxbSzkxt5ybs7zVNq8 0vZkpQ/PTvhMQQjAax0EhmcP74dP6jyBpZ4uTnX5NOo3k1zmJWad5RzWpc/trGtC38Uw3Uju16VJ V5KTFX2dhZLtW3UmmmZZZer3LPR5AXbxnYpPFCw6sWrfFhHvbPXegCYGn5Kt0f8RHfcS0LEnN9a2 nDAvAH/vKV3PIpX9PTCGja18Xwvd1B4ACwCq5amFzAsJ5aqIborGbRNzP1XNedOWuDjU7SdnIfzP xz6bFvhRuIrhlpyn3nB6IPfuvS+ffXYWn7y5icvFW9GaTantLpuUp3adbJqS1pNpmrRZ+6kV9UnS 6LMIp9GLvnrxj1O1EGBt+0ksY0+A7IcELADI9YoBHw5QidF3dNUbPQFKLwB+6Jks43p/P6XqNti9 nU+9zwHwIYBQ9MrOtotQmqcaynkJ+Tw17UXq4mVuV+vLZr7ZXCy6X67+PT965D/o/vWOgwA9AXiN ewW8COv16oHHev7OtGw+f6fMmrNyNDvsvx3CQN9tYxPatA1dafuU2lbypPj4fx/rozXuJ9YSa62N P7GL7rB3gIRG1N5nV1/ZLxuMlh0sMuhwO+M4LPAeAgCTAvFDFK07AdaNgIbugOyrAOokwDosEFe1 ByCUSxG5bFO72mzyRprSb7Xk2fqshEXQ5YKVAaAnAD/zXgELA/LR6VJOl/8WNxf/Kneaz9PR7CR6 GJhITJLbJpaukdI02pRWs7bSzBpfaejzANQCgCRr+WtpsvoKAQ8ATRLJyZpYKVoA8Eu1hQXZbQ2g 46TAxP8P+AHyvkMg+qBAkVg3wcoha++TAEsumyJlo6qrtmlXVvrXeSvrSZhunh6H7eXpZf8P59v8 ybsnJTy8V/YragB6AvBz6xUID0NdQRB+975+tJpbGPhCn1y8I8tFyD5MsFhvuxSbtEqSYt83Vveb 2HVpO0kWDHybgWQhQZMXf99KWOoQQJ+KfXuKGku2qGCveBBIYWi77bYM4MqLHyLuk2xR3wnQNwKq +wA04rth9z4J0OcAWMjceg9AzLJNB2Vb1tv+OExyWB6Wo/B/7Nz/glMQ9ASA83dfjocwIB+dPpbz 996WJ59v4vLbPm7f+LXM5Ku0vjqKk/TUAsBB9Oq/taLvj1b5U+5KjP4Y25jsmpv7YtfiKDlrVHvU En2/4WHotmLLNvwYvjlgo31MFiuL+i4Avg9AU5cMNr3G3FsWtbPSQsGmscetRdjL/km/yb9c/SY/ Wp7q2AtAHgU9AfjZ9woMYeC+1glSj3yYYHkiH60e6/n27bKereTJxdt5eXlhgeAfxb6Oi4tt1GkX m/Ywbtd9nE5y7DazmO0fSwdRJq2IB4NJJyX7/MA29KWT63Zc5pPHj+wPKMHvBeBbAfsugL4RkO8D 4MsAfRVA326zzwHojpvaA/Dk4pty56tpefSuB4DHSgAAPQHAXz2fxzkD9+1h1ztw/ras3z2RzcWX 8svVkWyWh3L5ZB3znZl4KOgXE8ldK4vuSvJBK7lvfKWhlN7vR7QI89ma3xU8V6mZ6cWFRQJr/Kem 03TV6WqeynTTlovFpPgkwP8+n5TD5WFZni7L0APgAeBjZS4ACAHA3zy3d9fJZwNBCL8N5+ef7kNB b6Hg7c2h+G3Ztuu5dJszydtzCctlWNrbus35jd+TN/hk8Rx8vX9W7wUQTkN6cqTtdKWT2YmeXizK dHGhs8/O9OjoC33k9wm4DgD0AoAQAPzgQODGUHDPHk5Pl/U1DwbhwxDWZyf1aw8IN3/Ir8Ov+CTx 3PjtgHd29wKYnZxp+CQEL/x+g6C6FxDFH4QA4Hmf8zevpWNPQbgOBjed1t4D4MUY7gY4qEX/Ayv6 u/OxFv/9aUsAACEAeHG/A993jX3w7O/IfT4wPAd/cR59rH/ltKTwgxAA8PuBnwEKPgAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAIAX5f8KMADvjLffPbzNGQAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 199.96 324.96)"
  })), /*#__PURE__*/React.createElement("g", null, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M380.98,414.19H253.63c-8.2,0-14.85-6.65-14.85-14.85v-27.05c0-8.2,6.65-14.85,14.85-14.85h127.35 c8.2,0,14.85,6.65,14.85,14.85v27.05C395.82,407.54,389.18,414.19,380.98,414.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.6346,
    y1: 377.9669,
    x2: 373.6346,
    y2: 412.6875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st91",
    cx: 373.63,
    cy: 391.83,
    r: 12.45
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.5211,
    y1: 390.2884,
    x2: 258.5211,
    y2: 404.0867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "258.52,385.34 260.31,390.84 266.09,390.84 261.41,394.24 263.2,399.74 258.52,396.34  253.84,399.74 255.63,394.24 250.95,390.84 256.73,390.84  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.9641,
    y1: 390.2884,
    x2: 277.9641,
    y2: 404.0867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "277.96,385.34 279.75,390.84 285.53,390.84 280.86,394.24 282.64,399.74 277.96,396.34  273.29,399.74 275.07,394.24 270.4,390.84 276.18,390.84  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.407,
    y1: 390.2884,
    x2: 297.407,
    y2: 404.0867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "297.41,385.34 299.19,390.84 304.98,390.84 300.3,394.24 302.08,399.74 297.41,396.34  292.73,399.74 294.52,394.24 289.84,390.84 295.62,390.84  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.8499,
    y1: 390.2884,
    x2: 316.8499,
    y2: 404.0867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "316.85,385.34 318.64,390.84 324.42,390.84 319.74,394.24 321.53,399.74 316.85,396.34  312.17,399.74 313.96,394.24 309.28,390.84 315.06,390.84  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "336.29,385.34 338.08,390.84 343.86,390.84 339.18,394.24 340.97,399.74 336.29,396.34  331.62,399.74 333.4,394.24 328.72,390.84 334.51,390.84  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M260.06,375.05l-1.45-2.1h-0.09h-1.52v2.1h-1.74v-7.53h3.26c2.01,0,3.27,1.04,3.27,2.73 c0,1.13-0.57,1.96-1.55,2.38l1.69,2.42H260.06z M258.43,368.94h-1.42v2.62h1.42c1.07,0,1.6-0.5,1.6-1.31 C260.03,369.43,259.49,368.94,258.43,368.94z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M268.18,371.75v3.3h-1.57v-0.72c-0.31,0.53-0.91,0.81-1.76,0.81c-1.36,0-2.16-0.75-2.16-1.75 c0-1.02,0.72-1.73,2.48-1.73h1.33c0-0.72-0.43-1.14-1.33-1.14c-0.61,0-1.25,0.21-1.67,0.54l-0.6-1.17 c0.63-0.45,1.57-0.7,2.5-0.7C267.15,369.18,268.18,370,268.18,371.75z M266.5,373.23v-0.59h-1.15 c-0.79,0-1.03,0.29-1.03,0.68c0,0.42,0.35,0.7,0.95,0.7C265.82,374.01,266.3,373.75,266.5,373.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M273.43,374.78c-0.34,0.25-0.85,0.37-1.37,0.37c-1.37,0-2.16-0.7-2.16-2.08v-2.38h-0.89v-1.29h0.89 v-1.41h1.68v1.41h1.44v1.29h-1.44v2.36c0,0.5,0.27,0.76,0.72,0.76c0.25,0,0.5-0.08,0.68-0.21L273.43,374.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M280.01,372.63h-4.38c0.16,0.72,0.77,1.16,1.66,1.16c0.61,0,1.05-0.18,1.45-0.56l0.89,0.97 c-0.54,0.61-1.34,0.94-2.39,0.94c-2,0-3.3-1.26-3.3-2.98c0-1.73,1.32-2.98,3.09-2.98c1.7,0,3.01,1.14,3.01,3 C280.04,372.31,280.02,372.49,280.01,372.63z M275.61,371.66h2.85c-0.12-0.73-0.67-1.21-1.42-1.21 C276.28,370.45,275.73,370.91,275.61,371.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M287.95,374.78c-0.34,0.25-0.85,0.37-1.37,0.37c-1.37,0-2.16-0.7-2.16-2.08v-2.38h-0.89v-1.29h0.89 v-1.41h1.68v1.41h1.44v1.29h-1.44v2.36c0,0.5,0.27,0.76,0.72,0.76c0.25,0,0.5-0.08,0.68-0.21L287.95,374.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M294.81,371.74v3.31h-1.68V372c0-0.94-0.43-1.37-1.17-1.37c-0.81,0-1.39,0.49-1.39,1.56v2.86h-1.68 v-7.98h1.68v2.8c0.45-0.45,1.1-0.69,1.84-0.69C293.78,369.18,294.81,369.98,294.81,371.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M296.12,367.52c0-0.53,0.42-0.94,1.04-0.94s1.04,0.39,1.04,0.9c0,0.56-0.42,0.97-1.04,0.97 S296.12,368.05,296.12,367.52z M296.33,369.27h1.68v5.79h-1.68V369.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M299.01,374.52l0.56-1.21c0.52,0.33,1.3,0.56,2.01,0.56c0.77,0,1.07-0.2,1.07-0.53 c0-0.95-3.5,0.02-3.5-2.29c0-1.1,0.99-1.87,2.68-1.87c0.8,0,1.68,0.18,2.23,0.51l-0.56,1.19c-0.57-0.32-1.14-0.43-1.67-0.43 c-0.75,0-1.08,0.24-1.08,0.54c0,0.99,3.5,0.03,3.5,2.31c0,1.08-1,1.84-2.73,1.84C300.54,375.14,299.55,374.87,299.01,374.52z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M313.41,373.44h-3.5l-0.67,1.61h-1.79l3.36-7.53h1.72l3.37,7.53h-1.83L313.41,373.44z M312.86,372.12 l-1.19-2.88l-1.19,2.88H312.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M322.88,372.16c0,1.82-1.26,2.98-2.88,2.98c-0.72,0-1.31-0.23-1.74-0.7v2.7h-1.68v-7.87h1.6v0.67 c0.42-0.51,1.04-0.75,1.82-0.75C321.62,369.18,322.88,370.34,322.88,372.16z M321.18,372.16c0-1-0.63-1.6-1.47-1.6 c-0.84,0-1.47,0.6-1.47,1.6c0,1,0.63,1.6,1.47,1.6C320.54,373.76,321.18,373.16,321.18,372.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7817,
    y1: 367.5576,
    x2: 292.7817,
    y2: 382.6665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M330.3,372.16c0,1.82-1.26,2.98-2.88,2.98c-0.72,0-1.31-0.23-1.74-0.7v2.7H324v-7.87h1.6v0.67 c0.42-0.51,1.04-0.75,1.82-0.75C329.04,369.18,330.3,370.34,330.3,372.16z M328.6,372.16c0-1-0.63-1.6-1.47-1.6 c-0.84,0-1.47,0.6-1.47,1.6c0,1,0.63,1.6,1.47,1.6C327.97,373.76,328.6,373.16,328.6,372.16z"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 366.2363 394.8545)",
    className: "st6 st104 st126"
  }, "4.0")))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st51"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 505,
    height: 701,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfwAAALACAYAAAB2AsBYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAMopJREFUeNrs3c9yHMedL/rMrOpu gABI0WN47DPyibmOGS/kmJW3N2L8Anep5zH1GvcVdHf3Aa7OdiK8OmEtPBM+J8KesceQRVMAiP5T lXkzq7pBSLKtfxQFaj4fqVmNBroJNAv1zV9mVlYIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8F9N9BZg//+Y4m0BBD681vv4n8vyd+58/uflFf26aFQA Ah+++j5dPh3qT/Z3f/lWfPtzvMi77Y+fvF1f6J2v9t08+eQDr6RRoUEBCHy+rftw+US4/zy8/ct3 p89dXJxP28vLX8Xw0xDWTx9PH2+ufv+p/X91+v3bsDz69dPb+2dnP74Tov/jS32j5+dvlZfeqPhm GhQaFSDw4ZsK+TngLy7er5/753D541/FFuwt1Iebs/iDzUkMb4awXR/H3ebp9Pzx0VE8v/OiF/s/ u2dnZbF6XF/8P8Ly6PFtsK0urm/vHx//7ecOvH8N//ZKGhVfS4NCLwUIfPhm9tc7If/23D3fKvgX AX8a3/zb43j5x1+l3eY4fqeG+s3VNg2nyzjuFvF09zyODxZxHG7qbRHzsL79HUj90fTiXb8rXX9c uue7crXYzo8tTur2aeivTqaP+8XZ5wykD27vLVZn5etoVLyqBoVeChD48IqCft9d/8u34s9qJX95 +YO4/tHjeH5xnTbnJ/H62TqdHe3SenWWjp/v0nY5pN16TMvFUcpDH5f9mIbdmPKyi6vcxbzYxZzT nd+BdahPKptuLCktSmrb7Vi2y5SnBsF6KKlfzQ2AbvhCYXGznhsTqR9ecqPi629Q6KXQoEDgwysN +rdr0Ldq/uL8IrVK/vz0Ks0h/yhdpw+748VJWl/VLI2ha+G+rduu3nYhdv0wpjEtUhe33TjktOhT zCXFcifwY8rTAXrsUo5DroGc8q5uYxxLl/ehX79mWxsD0/3d+LkP6HF6Tm1QdLUhUV9js3u5jYqv r0Ghl+LlNyiixgECHz6+X9Zj4JN34t2gb9X85dm2hvzjdFkzbFlv18O6X8TYpbHvW8DH3PXbMvSp fi6WsUb7ohvr/enjOHS5fmlX0z7HkkqN89u/NNaPahiPNdxryyDHMZdcw79+YY61eTCM7atrAyB1 08E5jt1nHKR3+9fty27foGgNifb8l92o+LobFHopvoYGxZO/1DiIGgEIfP6LVfVvt677u0H/3XQU /9Bdp9R146pP46ZPR4uapnkRl10fhrKo+b6IferDmBehz3VbFvUl+1rK9zm09kAL/ZrUMU2B390J /LEFfm6hP/2Za0C3qM+5zIE/b1vo16Afh5ayny+M63PG6WvHMDUeUqqNijy9Zqqv+eUbFa+uQaGX 4uU0KP5cY+LQQJgbBu+XTzcEovBH4PNt3B+fTN33P3svpMsf/yA++80P06P+N91R7LtF+k53Od70 YTEuwm61WHV5kWNY5t1uWROt3sKyC3E5JdI4zNtcFjXA+1Bq8JfSx66rtfsc+KUGfv2jxnGOc3CG +uWhBu+LwJ+2pYZzbQRMH6Wuhlr7P86BXF/0z/0g423Y7xsFh8ZE+9um1355jYqvr0Ghl+Lr6KVY ndTGxP+ev/a3x5fl0Dg4elwbBb9ojYLfldYImBoA79YGwBT8Qh+Bz7ewqv/pr5+mNhnvYT32flRv R/UW1sOiBf1xDfqxBvtQhlUXxlWNm1Xu4yqVXO+nVQq5JkG3TPVranYv6ysvaz4vQgo19GulH0rf jull6u6vj8Y7vwOlpncL2xb6KdVorC2BFpjt/1ADM8xhfQjZQ9r+2Z8ov/jBDk+Ygnx6vbZtzYdu /LKNilfZoNBL8fJ7KfqrbZkbEh+EP9UGQvdsXRsGN6U1Ci6uTvPq9Kq0XoEW/u+1HgDBj8DnWxP2 T96Jh6r+j79adg+XXXfcpS6dLvu8GWolH5d9DfmhBnwt9VdhGI7HVAv/HI5qZX5cM/GoVvhHNZhX NW5WcQr+Wu3HvKyPLeqtr9X7oh1vp279kFtvfqp/d/0w7RO6BuwU+i1qazbW0J+COLT0ql+Qw74/ IJbpm86fnZKH1517D9rz2svXu+3ZcWo8jF+qUfE1Nyj0Urz8Xop+6PK6NgTSelVag6A1JFoDod1f bvt8c3ydV5tFvjpd5qP10/zHy2U+OT/J5xfn+b3zi7uhL/AR+LyO+9+Tj43VH6r6xW7Rx/rH0U2r 5nerbtnVkN8dx9QfDSE/qE897to2dsftfs2G4/pqx3EK/hb4pZVny1DSoobJosZzPeq2Cj90U4Vf IyTGafx+zuApVGsTobQ0qBlay/t6xB/DVOWXqREw9wFMafoZB936Ou318t3gn16jPbV9cgr8r9yo +DobFHopvpZeiraNUyOg/R0p18Zr3o1d7hfbPIQy1tbq2Lbbksfd4mSovw/jxdXv86M/rPIvfvQ4 z6H/pKjyEfi8RlqevZiY99vj/9k96lddP5z0raofrmvQzwP1q3o8PW5VfJmCPj2ox+mTmpoP6rHx JKRYHysParDMgR9C61OtgV/Dvo3rt7H7EGqFH1pX/p3u/JLCIfDvJnWYw3nOuHrEn1sDNTzDHPzz 5/9ySL748cqL1Nwna2su7BsOJewDP7YQnuYLfoFGxStqUOileLm9FPuzP8b6X9u25sWYh/bjjHXH HEvshtinXRy6XU7DkDZ93W6Hob8eng2b8c2bfxrnSv/trGsfgc9rFfZv17D/9a+fpmffaxPzxi4c /ccirM/m7vsxH9Uwr0Efa9CnB10pJzmOpymlk3rkPE0xndRDfA3+ctIq/Bb69YB7VO+v6suv2gS+ GgJT2Nejdj9N2NtX92Huw4/77ZSfLTH2mdwCpz1yCOb2zeb2iX2qzAFzG4R/uTL+RMiV6ZXnIM/z S0/bL9eo+FobFHopXnovRW55H6c5IV1oZ362k0TG+vOlodX69TO72gzdjbHb1J1yu9uMmzTmbfcg b+O629VG8O6j+tedX7yf33uvfVO69vniem8B31jYP36avlfDfjd+0I+rcXEWHi+2i+0qbGuAdzXo cw30lE/qwfO03j+tR7ezeiA+rUF0Wo+Wp/WFTmoAzBV+aD0AaVWPs6t6HFxOQb+v7OuBuh5ja9DH ug3xNuznfIwfW5k/hinsD12m+2r/8FicM3Pf/f/X2svl9msOgVOfm8octlOjYho/yC96Feag3LcI pslZ0/fy59IyHzoj4mES1xRo5bZ3Yg7F1rcc9w2KKTgPDYo4/SOEQyPnL9YCc8Pn9i8s8935tUoo +0+077q9KeM0DNI+jnPjZmoghMNr/KUGxf59jNN3VsL89sz96eFFg6LezWnfoGiDLGnfoJjeu/wZ te70nub532AO4ul7S+3uXMm3Jso4VeHTzxbbckytKTBV0odGRfkzjYp0aFCUMjcowjQVtP4M9TPT v3eur9eN03vffp6a8mNrVOQw1u+jPp6HkLpd/dptGeM6xFrKl3KzWi263BaLep7CMixLDft8fXFd ji5/UMLbj2N4V3WPwOfe9yjdCfvf/DD9+3c/6NPluHgQu+Xz9fqoVfT1APig62pFn/JZDOmsPu2s HoMf1gN+vV/a1ObTesg/CXOFXyv70Cr7emthH6awr4/19Rhc9+/Y1WN9DftWzX887Pdh+bEu/bmQ byEV55ycw7i0cMr7cIqf1ZU6vfJtaVxumxNTWJa56o2HcP5yjYqvtUHxShoVX3eD4hU2Kj5PgyK0 BkV7n+rPEerflcLYpgrU5+7qk7f1yZuY4k3dUZ/Xb6bPbZi/X4bdOObcD3mx2+S/Odvm9fnj3K4f 8W4bDnvRTgWBz30L+3mCXuvGb5V9C/vv1LC/ycMqDMujZa3qc2pd97Wir0FfK66H9Rj5qB4Ua9in h/Uo/DDGVCv7clozZhrHrwfT49aFvw/7Nhu/VvZl34U/Bfw+7G+78KekaXXbn/kG93+2uNx3lZf5 /Py5FzuUL3aMvVMRlhfhNw8TlC/fqHgFDQq9FC+5l6KF/PRelbHuy7WIzzX0466+xK4+f1NSuKmf vq5/5TKGrrUNwm6oQb9ajGmXhmW3G66PHk9LSl/c/EsU9Ah87nHY1+PT2+/OE/S+dzp146d92Hf9 g6PcjQ/yuDiph8iz1JWH9XjYgv5RF9Ojevh8VI/uD+uLtAZA69I/qZ97UA+1bYLeUZy68Nupd60b v3Qt8Pdh3067S2EO96ls3+dEDHdr+ztj+OE2FvbjtnEOuvyJ5P58P/An82EOuHgI6q/cqPiaGhR6 KV56L0XdG8cwzTtoCza3joMw1M/s6pds6156Ux9/Pi0eVXLd5Ycw9TS0uf4hbFM/bvsQd6dX2/Tw 9Cpd/uEHOTz53X6yvmlYCHzulcN59v+8n43/f3RtzL5147fKvoX9OEyV+1lJ6VE91L1Rn/NGPZS+ UY+nj+r9R/Xg+LAe22rYp7kbP7Ru/HJUI2IZ4jQ5b5qBH+bz7NsoaltEb5/X0yH7EPb7I3i5jd67 +Vr2d+KdML3t5v9YK+EL/Oy3T4svwuMrNipeTYNCL8XL6qWY5hlOqzi2aQKhnfQ31C/b1c+t6+du 6vNaL1XX2qmxVf8xbeu3uW4LSMWx6zf9UH9ndqlbX8fw0zBdMVKVj8DnHlb386I67Tz7R+vVNBu/ TdBrY/ZTN36r7GvYdyk+ymV8HEN6o0b243ogfFwPkVOXfn2Vs/pa+7A/jNfHaby+raA3Hyxju/Rd mmKtvshtwJc7FX05RG/8C99svPN9hzvtg/JySqnyshsVX0+DQi/FS+6lOJxBMVX5ZZwq/BK3tQ2w mar7uVeqvWLr6q+P5ZvUdauyG5Z1V+5rhd8tb8Z0XY7j+PQozuP4IPC5V2E/j9tfPn4aHz4NXR5O +mGdptn4bYJeG7Nv3fitsm9hH1J6XEuh79RDYw3++EZ9hYf1dR7WY2c7/W6aoFcPjm1hneV0UZx2 Xn27Ql59YpsavS+14m12346+HuLhiwb3fMj+yin/qhoVRS/FveyliPvu/f24fn1sqH/Ptj66rj9P tz+1cqiPb9qaEm3xqJDHZehTPwz192aXU/dgEcf+cu7c+th3odJH4PONh/08bt/Wxv/j2bI7OQ/d ydG4WO7GVd7202z8FMtp7srDuRs/PC4t7Et6XI+TtcKv1f0c9qct7MM0G7+FfZyugLfff6ex+rLP nDuBv8/2Er9YOHy6hnsFb9VXbFS8wgaFXoov3aBogT9PDQhjfWxoqz/GtrLP9CXTxzX846o1aFMM i9LF6RLP9fW6Rd/Fza6de3IeNle/j+H0+yHMM/WFPQKfb9p8MZyfXYT42+99Jz0cj7vyfLcYV2lZ D2eruMk17PPpkLs2Ge/RNGafakXfKvsa9vXZtbov7XOn9Qh5si9rVmEK+9vx+hb0tzPvbwdSwyHo X5dj4dfdqNBLcR96Kebegynex9iq+TidqT+H/bQ65BT2bYXIvj5jCvs8dql0ZV4CcOjiG5vL+J/1 iy8u3hf2CHzuS3U/n2//fg3k83rb1n1tNawXOY+rcVwdh0Wt7ks6HfP4sB4Z30it+76UuRu/VfZz 2J9Np96FcjyHfVi86MYv08S8cLeif+2C/tvSoNBL8XkaFK2fP86zRbvDWr1tAt+0X7cloOO0SFRf psWiauXfluOr/4XS1uMN8fQ0TCP+IPC5X9X9kxB+/f/+3+n6bJneeJj7rnvcjzEth6E/SiE9iGM+ HePwsB73HqU2E7+UfdDPY/ZTZT+FfWhhfzSHfZgm55V5Fv7t7HtBr5fideilmMf05z7+OL9hh6We p+s7hOkMk/3E02mpiJK6eemfOOQcx2Gczi/9x/AP4Sb8i10Ogc/9qO6nWfk/eis+fLbuPhqX/bK/ XpYhHKUYj7u2uE6Jp/Xw9zC1gM/xUWnd+jE8ivsx+7kbv9wJ+/1M/On8+pLCixpK0GtQvCa9FPPZ APsP9utEzOtFzGs8z6v3TKftlxTHdgmBaTbBEA+XfQjhuy/+gif7G3xOyVvAyw37NlHvrXh5+YPY LnXbrmkfl+NiFdIyje3iNm2BnbF1TrbT7Fo13xbVmSr7qQu/hPq5sD/17kU3/lwJ3Qn7Ty+LCy+h UfFVbuGv3OK+RbH/uBwen3v5b8N+GvpvHVj5zr698E+DwOc+ahP13o/PvrdJ18/WqV3q9mRXFkPp VjGl465158e5uo8pTqFfj3JncVpUp62gV25n44c73fjhdtW8u1348Do1JuKLBSHi3QbGVPxPYT+v 71emxaA7bxoCn3t8ULut7s9Pv58Wj276vBkWY4zL2C532y51m8JJqYHfFtppod8uhhPm+6f1YPc5 K3thz2v/m3I70XReJurwGbs2Ap/7L36yul+Gx13o82IM/SrG4bidS59yOWnVfNhfBa8e607bde3r EfBBvR3XW1titK2gd7h+vbAHEPjcq5rlSQiH6n4aux/6vuyWi64fVzH1R10oD3Kr7nNsk/Kmq961 MfuU9ovqxLC/vO1c2bcL4cSPjYEKewCBzzde3b/9y7fi+keP4zR2n9c17IdFrgHelbQaxnBcWrDX aj7HPId9mMfsc5ln49fwnyr78OJ0pTaF6TDDWdgDCHy+cU/a6l/n8friOp0dPUrr9LAr/bjowrAa 8jQJ70Hruo+pnKSSTuozHrTHWjd+Df92mdtlWzj0RdjHT8xmBkDg8w0r0+U6L3/8q/g3Z9t0nT7s 0vGmL0Ne1LxeptS1iXjHc8DHByXV8G9r44d4HKa1w8N81btDdT9V9fnu6XcACHy+YXN3fr3z7Deb tD56nJYxdWns+xxr2IdxFXM5iindCf0wraC3vwb4fn388uL0u7ZkbjwU9rryAV4GK+3xUrTu/DfD dbwJ21rPx25Xq/tasy/ymFalq4Gfy3FMbRZ+nFfPK+GoRnm7RO5iumpYiPsZ+eGwil4U9gAqfO6N Njv/5+Hy8ldxc34SN6uTdDMu+rjs2kVAljWyl7HUwI+1ws8t7Kfx+v017cNyDvs2Zn9YXOewOoms BxD43C+/fPd2dv7xYpf6GLqYU9/nfpFKWaWSVrFW9DHFVW0AHMX5UqDLGvIvxu1LVN0DCHzuqdvF djZXp/HsaJfWV6HrauCXcbMIKS9ahZ9DXpVUb6VV9amdZ78MsdyupFcf7/ZrjanuAQQ+99c/hzdv /jMOu1VcLoa0C7GLfepLLot5Bn5cluk2rY+/r+xjX/YT9WKcls7drymuugcQ+Nwzh9X1DuP3uzT0 Y2oV/nTtj1bFp7AIMS5ibufZtwl6UyOgTdTbL50bD6ffOd8eQOBzb/3yrRh+GsJ2/TSe7pZxuV2l FLbdUFIfp1ut9UsL/TLNxi+HSXrxNuxTOYS97nwAgc/9tX76OO42x3F8sIhDN6Zx6FMMQ5fjNBmv zyn3+/H6wwVxPnYKXtSdDyDwud/e3m/H7WUch5uYcxu+z6nkLrVwj23G/nQhnPk2V/af7sovgh5A 4HMv3Qb05ur3MZyfh3FYxEV3ncaxpBRLivtbyHEK/fiiqk8vls59cXkcAAQ+99I7t1F9Xm95WMc8 drH0Ne5Ljfpc0nSroV/acrkl1m1JU9d9OVwcp0zn3Ut9AIHPPXZx8f6U1LvNZd2ehmnV3FwDv4tz 6MeQauLHlug1+ON8b7rtx+wFPYDA57VyfLSuVf2uXQkndCXXqJ/m4+2vad9SPtwZr9935ct7AIHP 6+Efwz987ONShqm6f7GDlbnr/jMn5kl/AIHP/fPk7gff/dSnS63yy5Ti6c/sbnfDX9ADCHxeQ4tP Jn+83dOmSj/+mdAHQODzWuru7GGlBX2cAz7eCf2ivAd4JXpvAa9G/HgTs3hHAFT4AIDABwAEPgAg 8AFA4AMAAh8AEPgAgMAHAAQ+ACDwAQCBDwAIfAAQ+ACAwAcABD4AIPABAIEPAAh8AEDgAwACHwAQ +AAg8AEAgQ8ACHwAQOADAAIfABD4AIDABwAEPgAIfABA4AMAAh8AEPgAgMAHAAQ+ACDwAQCBDwAC HwAQ+ACAwAcABD4AIPABAIEPAAh8AEDgAwACHwAEPgAg8AEAgQ8ACHwAQOADAAIfABD4AIDABwCB DwAIfABA4AMAAh8AEPgAgMAHAAQ+ACDwAUDgAwACHwAQ+ACAwAcABD4AIPABAIEPAAh8AEDgA4DA BwAEPgAg8AEAgQ8ACHwAQOADAAIfABD4ACDwAQCBDwAIfABA4AMAAh8AEPgAgMAHAAQ+AAh8AEDg AwACHwAQ+ACAwAcABD4AIPABAIEPAAh8ABD4AIDABwAEPgAg8AEAgQ8ACHwAQOADAAIfAAQ+ACDw AQCBDwAIfABA4AMAAh8AEPgAgMAHAIEPAAh8AEDgAwACHwAQ+ACAwAcABD4AIPABAIEPAAIfABD4 AIDABwAEPgAg8AEAgQ8ACHwAQOADgMAHAAQ+ACDwAQCBDwAIfABA4AMAAh8AEPgAIPABAIEPAAh8 AEDgAwACHwAQ+ACAwAcABD4ACHxvAQAIfABA4AMAAh8AEPgAgMAHAAQ+ACDwAQCBDwACHwAQ+ACA wAcABD4AIPABAIEPAAh8AEDgA4DABwAEPgAg8AEAgQ8ACHwAQOADAAIfABD4ACDwAQCBDwAIfABA 4AMAAh8AEPgAgMAHAAQ+ACDwAUDgAwACHwAQ+ACAwAcABD4AIPABAIEPAAh8ABD4AIDABwAEPgAg 8AEAgQ8ACHwAQOADAAIfAAQ+ACDwAQCBDwAIfABA4AMAAh8AEPgAgMAHAAQ+AAh8AEDgAwACHwAQ +ACAwAcABD4AIPABAIEPAAIfABD4AIDABwAEPgAg8AEAgQ8ACHwAQOADgMAHAAQ+ACDwAQCBDwAI fABA4AMAAh8AEPgAgMAHAIEPAAh8AEDgAwACHwAQ+ACAwAcABD4AIPABQOADAAIfABD4AIDABwAE PgAg8AEAgQ8ACHwAEPgAgMAHAAQ+ACDwAQCBDwAIfABA4AMAAh8AEPgAIPABAIEPAAh8AEDgAwAC HwAQ+ACAwAcABD4ACHwAQOADAAIfABD4AIDABwAEPgAg8AEAgQ8AAh8AEPgAgMAHAAQ+ACDwAQCB DwAIfABA4AMAAh8ABD4AIPABAIEPAAh8AEDgAwACHwAQ+ACAwAcAgQ8ACHwAQOADAAIfABD4AIDA BwAEPgAg8AFA4AMAAh8AEPgAgMAHAAQ+ACDwAQCBDwAIfABA4AOAwIeXqMybvL8BIPD5dhjDi3CP MZZQ4pT6pd3fNwDibUsAAIHPa2b38Q9bwOc7928zPgp7AIHPvffk7gcffOrTMaYyV/CHtL/bl383 7OU+gMDn3vvX8G+fCPq+9dqXFxFfw32q7D+rohf8AAKfe+9mfVRiWpTWoT/W6j600K+3GFuSl7Lv y69V/z74i4wHEPi8Fs7P35oie7E6q9urem8dYspThR9zC/tY6kf1TpuyV7ct96db/W9uCHgTAQQ+ 99vPb9P6ou1M/VFJ3VjiUCN+LHPo19hvmT9N24tzA2AK+riv7w8fAyDwuZduQ3p1+v0SLi5C1wJ/ uyxdF3Oqtxr79Vb/r2Efp3q/5Frd51bit+eXw0tMdb7MB/g69d4CXoZueVa6fii7nHIZdiX1XU6h tFPxxzLdapUfUi3/23Zefmcey58n9+3H9aN3EkCFzz30br0dPX5aFqvHpXteg3471uBPOZWxVvTd FPZz6MehbeN8f9z3EOR55v7d2fvOzQcQ+Nw/P3m/hF+EsDy6KVeLB2W76PJYlmOt22uwDzXY01Cr +6HmeN3mcQ79kveV/75rP8yhbywfQOBzH8098GdnPy7htyF0i13phy53eZdzC/RYwz7mIZQ4pCn0 2xJ8dVtq+Ldx/Tn4c9yP4s9xL/MBBD73z5N587vVdemvtmWxWudcq/sulLGrVX2Yq/tdLnEXYr2V 1LZDDftD134Ot2fkC3sAgc899fNyfn5R+uPLcnW6zJuhz92inYjf1aBPrbqvIR92McVt27bwr7E+ zKEfDoG/D/3D+L1xfACBz30yBXObuNdOzeuercvyqM+1dB9blV9r+CGkuKvBXsO+zNt2ZZ2y79p/ EfgvxvGV+QACn3vqJ++Xo18/LSePjvLN7joPLezjOMQW9qVscwrbGOKmRnmr8rexVvkt9KdKfwr9 OE6n6u3X35f5AAKfeydO4/ht4t7q4rqsNou8bOPzaTGE3Lrz59AvsWxKrKHfbmHa7qv8drpem7y3 X273Nu116wMIfO6h/xF+ux/HbxX+atsq/LTLraLPaZPrLcWwrnm+KXPX/qZW/dsXXfvx9jS9YAIf gMDn3ilt4t5752+VNo5/tD7Oy+3zPJY2gr8eap2+LSFvUgv6Utb1q9f1sRb807h+DfrWvd9C/7AC X4mqfACBzz21H8dffnBTtuPDMcfdELu4i33Zxpg2JY7rGufrEMNNva1LC/2pe7+G/nR+fphm7deq P5fbyXvyHkDgc48cxvF/Vy7eOM1HDy5z7lZDHNIutUl7tbpPJa5LqmEf5ltKqW1rpR8286z9MBzW 3G/j+ap8AIHP/XOnW/+qrMv3xuPcJu4Nw64st12t8EPqasCXeovP6/Z5KfV+6+JvgX84XW+/1n7r 2i/G8gEEPvfUbbf+v7al9cacFkMcd7sx5k3JsY3ft9B/3kI/tm1s4T9V/PMpe2E6Va9N3sv7q+jt 19dX5QMIfO6Ju936fW6z9Uu3G0I/d+uXbqyBX25iDfkSw3Up8XoK/1bpx3hzO55/59z8KfDLYeK+ 0AcQ+NwHt936j364yg9raG9LHsOu23Wx36Rh3JQu3Iw15GML+xb6IdTtFPw3tZBfl3lxnv35+WW/ 5G7aL7sr7wEEPvenyn/3/XL2q1rlX53mNxYnQ+6GYTNudyWtaoXf3cQxP48x1wo/XNWvvqrb65rl z2uq19CfZvFvSlt/f1qQp1X6d7v2pT6AwOeeOEze+5dyuX6ax24zpPFom8pm209j+Ol5zq26L1c1 1C9jrNt6q2F/O54f4zSef1hrf+raj8WsfQCBz30xh/FP3i/nF/+cnw0/HA9V/hD7TeniOtbAr4F+ nVJq1f0U+vN2uj2v0X5TX2U/c39ehS9+bBU+4/kAX0bvLeDlapP3Snnv7XfLT8L7tcr/Qa3yl0Pa ht14vNzEvrspQ7yOKaxSiEc55KMU06qUsqpPXdYsX+z3y66+Vtqne5xfuG1Kmhfjaw+3LQAqfO5F lb+rVX5c7RfhGXfrMFX543UJ+TKU7qMSymXN8o+mSj+Gq2kmfyjz8rvh7qV020S+mFX6ACp87lmV /9PHT/Py6eMxr7tdd5S7mBb9EMNNHMMyl1Ir+ryq2b2v7sOyhn6t8FuVH/v6eAo1/feV/L7CP/wF U9tCpQ8g8PmGq/w4zdj/WSi/Pd7kB+Mb48Ntt9ushs1yCP0u9Iu+C4sx52Wt5pcppEWN7kV94qLG dx+nLv2Q6udSvO3SL/N8/Th17XdCH0Dgcx+q/FCr/PNa5f/6aT47G8fd0W4Iu+NdXuR12ZV+HFOf YlzkWBa5Bn1KZQr9GuhdDfaubmvY51SzPLaYv1Pb7/fbNsZvTB9A4PMNV/k1qN99Un709lv5/frB w/lUu9QN6xS73XocV12t0/uu9P2Yx1bV92Xqyq+Plti16r5meozxMGR/twPhRUdCaI2CeHg4BsEP 8Gkm7fE1h/7Py7vvtgl85/ni6vd592w9XG673S71m7AsN2E3Ps9ld1XbBh/lUp7VkP9TDf3pVpsL fwptQl+YJvO1BXpu6uc/dsre7US+4rQ9ABU+36C7Xfur/MezcTx5dLTrhpvUbXPKtcAfS0p9Groc uy5OE/XCftx+nqxXDr350ybug/2wLaV+votz43XfgC37el+1D6DC5xVW+fOSu7/40eP8Nz/ejm2d /bjudtu4mKv8MDyvOX8ZxuGjmvZ/qsn+tIT8tJT4tD6z3kqt9EOt/sNlbEvxTlfcC+syLdATt7HU ar+Uw6p8+zX4b9ffd7U9ABU+ry70n9TQfxLarP2L88fjUX8dw1GIy/A4Pt+tUxpjHEJKQxxjm62X p7n4LadTK+FrmV5ybTdMYV4r+jG2UI/77vzYzs2fTuWrlX7pytSQbefzlf2iPSp+ABU+rzD0f17e +1nIbTz/2bAZw/q/7S5317tVH9ZxUW66vr8KY//RWNKzFMPTMt3Kh2G6xQ/rCzxtY/z1lT5qY/u1 TXBb7Ydwe3nd/SV2S20YzJV+VPEDqPB5lV4syPOzi38af3t8Ex5sut3zB2NYjX3s+jGUVGI39mFX 6/Qutxo97Cfl5amSr3V767YfamIPcZ71P9SXHWqMT1367Tz+er/t1y3ku3aVvbm0/3MV//57UvUD Knx42VX+PJ7/3vlFefSH3+S/67475LNutxjLdhziuuvide5DrfTDR7nEP7Uqv0b2h/W5f6zP/KBW +H+sr/Jhre6ftoq/ZvWzkPcz+edL7d7Uv6JW/GEb2lX3ylzxx7kxcBjfz7eX3b2t+sOdyYBRLwBf d9O3HH4l2pDVtFcefkVAhc+3J/SfTOP57fz8Xz/+TfjOr5bjhz8M24cfdjWdY2iVfuhzyGMuKSz2 4/atgo+tq75V97sUyrZMoR5rqMftvO5+PK41/K42Blb18XmJ3hjaEr19PaJOC/m08f24r/jD7Qp+ 02E3xnB3qD/Ev3701SnAF9/155UjDmePHs402d+vO+88caXez3OXlYqMl6nzFvDN+P/C++//P+H/ /NF/D//55nV443+l8Kfvh/Jwt2vT7Us3hJrcMaecyxhDjrH19485pq5u22S9MNaDY2sEjDHF6bFp Mt/c5T+Ww9h9mSb3lXli393x/FDuBHqZV/f5WIl1+zVlXs/XPxlftaV7qOzLfgJq239bA7VdJKr1 Sj0P07yUfF2bvZd1v7tu81RiGG5Kab1fZRvL0bDK3TgM/17+99/X13nvPW8sKnzuu3n5vHd/8k54 +5e10v/x0/B3v/lh+ffxg5AejOFBXwvy3JeyyDnWA1wN/qEGf8v+2g4Iu/rUevBLbaLeuib9uj5W b/Gk5v5Jq/RrTB/XkF/VomlV66Za6ZdljfVa6Yeufm03N3ZLmiv9Mi/fWw/DtUUQ01SD3Y7rxxgP 1+r5ZOprBPAF9vgXw0fj3BCdhpbmHqxpOYm2+01TTkqujdQYUpvC0i4tsR+Naj6otx/Md594TxH4 vE6h/6SGfqih37r3//Cb8Hff++Hw788/CJtHRzXGh9xvFnnb59zXKj7lNOax7FKM7ZK523pQXNd8 rreyrnl9E3O+qQfNm/rCD+r2QT2GHtewblfiW4Wpm78sYlu6N8zd/K2Lf7oIT1uyv5Q0R3tOZT42 74v61hDYh/+0jZ9a4rdIfj4z7O/0589hP9R9doj79SPivIbEeDi7ZGp+5pTHlNq6UrXd2pWuX5Q8 7sK/hn8Lb3pLEfi8tpX+u++EUEP/ZxfH5fnxn8Kj9ar0w0kZj27qAS/lYVdy6pc19OOu/r8rpdum kDe1yl/nMAV/C/rn9dVO62s+qEfLk1oh1Uo/1Eq/1NZDWE1j+20Wf7ulFvplrvhLmYN/qvbjvGJf vL1CXyz7T8ydAZ8M9xKlPZ9vV4+33fn7sN+VtnBUO520NWJLrI2A+cyTNmclpVwjv8ul/p+6Uq6u uvBg4W1E4PPah36YJvK99/ZboZ2yd3F+UR62vvbNZVmOR3nXxbwbtmNfunqg7IZa5W9rwb3JJa9T 6tqqe89rbJ9MK/G1bv0YTurTH9RXbVX+ca32j+qhtgX/sib0MrSr8h2q/al7P06X4w37pX33l+Wd uvrjIfznqj/eDfvb+g3+qrtrQEw99uM+7NvYfbtt2nUi6p5U9+tS9+8W+nFM3ZhzO1u1L9PtT6uz EnbX4fz8rfo673tb+WJHWm8B92t/bJP434k/ey+ki/O30vnFdfpw2XXpwbjoxlV/FONyV3ar1Iej YVzUD2sFH/KDrqRW1T+owX9Sa/YHqbQu/Rb8tcqvod/G9GutftSq/Cn0wzSmP83in6/SN4/rzxV/ 3U7r+U9j+20gdV/ht9Cfp1Pf/Zbn4Vb/ePyVuC+HaznOgR/mLvxduJ2sFz6qn2gXi/pjLPGi7lEX MZeLunf+MQ/haQ7DZdeX6+v+ahPC+fat+vx33307355kAip8Xr8yqGZrW5wnvJPD26H89HJbnn/v h+XR+Jua1t8Z82aTa2SPY47DMsXtbszb1IVNzeab+vSbWvk/L7kGf2sIxDRV+PtK/6hm8lGulX4K aVnaJL5pIl9Y1Ay/rfTjvFjPvJ3Dvtv35afSlv2Zzpy601CuD/pn4zNbsren4ZXJNGY/zUVp14MI z2t74KruZ1e1qn9eG483sVX7XbctwzD0IY15kXK6XpeunJXx0ae7DkDg87qG/rx5953wi/24/sX5 43J28mH+8D+6vFgdjd3QD7v6fx7TLg277VA2m27RrUPuatWfn4+tK7/kozD1AMTjegA9aqE/TeIL uY3lL9utrcwXp9+DthZ/bTocxvXjbfDXNkRb0L/V8CWVw0X7pip/P8k/WqmPz5DCfjrIPBt/qvDb mH273HM7w6SGfavy6850GXJ+XhurNznnTVr02zCkYQibcTyu+/54UxaPb8q7Tx97TxH4fKtqohr6 U7Uf3377rfLr/9mq/U05D9/Pq34Y/7RbjF24GYbl0W61Xm/HdlSM47rru5t+LEc5dKt6bJ2q+nrE XYU8HpUUVrVGX8YW+Hkaz1/UY/AiTFV+7qdx/dvT9uYu/vn0vXpL09n686I9ZT/8kKaaLRod47Pa sXE+23N/6l1p59sN05h9Df2psq9hX0r+qO76tdrPz3Msm1zStk/jsCplHDeLnE5PyvYXT0P4v95v p7eAwOdbVe23YC0vZvGfl4vTi3J+cV26s+/mo3gyxs3VWI+NQ7dcbMtutRiH1u8f1znlZVfGWs0v arCPNehryNdbapV9nu7vw77s19+P+7H8MoX+VOnnucpvpwrME/jqEbsFfNxX+PmwQh/81QbsvhGb p+3+ztAm6MV24acUbubKvlzVdudHOeTrEvJN3Rm3ceh2w2I7Xp8u8+bqNL95VsP+yeE1QeDz7Qr9 cFvtP6nV/i/fKhfh7/P66CKdXVzny7PvjkddHhY5d5fhZpeG1TYsxkXY5cXQxcWy3vKQlzH1U7jn oVb2XeprjbWIJdVwHxYxtu78XAO/9LF088S9MLZz9FOutzSdp1/SlO818D+2OI8Je3webS3IultN i+rMZf7YZuPXh3dx6tpPN1Nl31bai/F60S1uNptxE/s8bEsej9ZPczgN5fzUDH2+fLMTXqP9tfX0 vxNbhVODP15cnMeL84tpNn8N/nQU/9Bdp9TVdO/iuOj7tmrJkBdh2fXbvGth3tdj7iLm1KfWdV/G fqyhH/fj9rGGfq6tgZrhXY5jfaxmfS4p1bBvh+mSpovuzVOj9xP2rE/N5zEeduI2F7TE2o7M8zUi xlrld902j3mTY97Uqv9m0S9uasyvx21cL8Nq89HDsL2+uB7+5nI7/uJHj3OYZ+ibsIfA579u8P/3 q9P4p9Or9FHN4dOrbVqk2N3UW9+uyVPDf9tCvQZ/TfJuV7+mbVu4D7t6yO26NIZh+jinrpX1KdfW wHSvrfCb2lh+96JGgy+z87aT8GPbuep/7Tz7FvpDHuKi3w4lbOtOtt3Vyj6Neds9yDXyu106Xe7q Pj2eX7yf33uvDQf83BUdEfgI/svLX8Vn39ukN2/OYqv6z45u0k0N/+c1+I+XQ9r1x6m/vu6G/igt +zENu2Xqwrobh1r2d4vU1vBtZf+Y+lT6+qSxRn0eY7tfcmqX4QvT0OvE0md8EW1Rvb4MqatNxlzi mNtaumM/nabXD3WvG9qYfU7DkDZ93W6Hob8eng2b8c2bfxrbZaWD8+8R+Aj+MIf/22/Fn128X4P/ B3H9o8dxc/X7OIf/Nu3eOI5nzx6l9aoWULtFPL7ZpfFBH3frIS0XQ8pDH4faCDjKba5Uu2ZPH1eL LuYa9Hnc1b/nKJS883vDV9th06LU6r6klMtmN5Z+UXe9UMY2G79t25j9bnEyPKwNgYur3+dHf1jl uSv//bYyVRH2CHzsz+FQ+MxVf/jlHP4h/HO4/PGv4vppawCcxjf/9jhuri/i9bN1GreX8Y2HR3HY reptGcfT63jatsMijg9upm171dYYaNvjo7XfG76Srj8qV1chpFrUd/2udM935ea4y6vNIl+dLnOb oPfHy2U+OT/J5xfnea7sW9jrykfgw+cK//bIbQPg8ldTD0B7rPUCDDdn8e/b/fOTuF0/rY//t7Db PI3jo8t6/7z+F+rHl3d+Z77rXeZL+OD23rQ2frgI3bOzsljdlOXR43JxdZpXp1fl6NdPy9nZ78p7 bd38F2EfVPcIfPhc4R9eNADCz2sj4N34dr13sW8ENK0h0LaHxsChQXD3Bf8x/IN3lS+tXeL2YHX6 /WnHPHr8tIRfhNBCvl0cZ1pXR9Aj8OFlNgD2jYDmyeHjF42Bu+aGAbwc81XvZlPA/+SwqM60D5Y7 u6uwR+DDy/9d+EvH1nc+/vvyxJvGl/Cp/ebn5S/sikIegQ9+V/iWEe4AAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAr5f/X4ABANWM0KYeeQNdAAAAAElFTkSuQmCC",
    transform: "matrix(0.24 0 0 0.24 264.52 145.68)"
  })), /*#__PURE__*/React.createElement("g", null, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M448.89,274.07H316.95c-6.93,0-12.55-5.62-12.55-12.55v-72.94c0-6.93,5.62-12.55,12.55-12.55h131.94 c6.93,0,12.55,5.62,12.55,12.55v72.94C461.44,268.45,455.82,274.07,448.89,274.07z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.9176,
    y1: 174.6252,
    x2: 382.9176,
    y2: 207.1311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M461.44,201.99v-13.42c0-6.93-5.62-12.55-12.55-12.55H316.95c-6.93,0-12.55,5.62-12.55,12.55v13.42 H461.44z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 318.3428 193.749)",
    className: "st6 st67 st128"
  }, "Select Product")))), /*#__PURE__*/React.createElement("g", null, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M450.14,189.25c0,4.42-3.58,8-8,8c-4.42,0-8-3.58-8-8c0-4.42,3.58-8,8-8 C446.56,181.25,450.14,184.83,450.14,189.25z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 676.7916,
    y1: 337.1515,
    x2: 676.7916,
    y2: 319.2142,
    gradientTransform: "matrix(-1 0 0 -1 1118.8693 520.2927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    style: {
      stopColor: "#25A3FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7941,
    style: {
      stopColor: "#447EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "446.63,191.49 442.08,184.79 437.52,191.49  "
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 319.3633 218.3379)",
    className: "st66 st75 st130"
  }, "Product  1"), /*#__PURE__*/React.createElement("line", {
    className: "st131",
    x1: 310.39,
    y1: 226.23,
    x2: 455.37,
    y2: 226.23
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 319.3633 239.4678)",
    className: "st66 st75 st130"
  }, "Product  2"), /*#__PURE__*/React.createElement("line", {
    className: "st131",
    x1: 310.39,
    y1: 247.36,
    x2: 455.37,
    y2: 247.36
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 319.3633 260.5957)",
    className: "st66 st75 st130"
  }, "Product  3"))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st51"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 505,
    height: 514,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfwAAAIFCAYAAAA3J09fAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAHTZJREFUeNrs3c9uJEd+J/CIyKwq skm2pmdMr2Z3fBFsH2T4NIDPegk9z/Q8Tx/9AtqrgTkZ1mFtzC4wA2hWlNHqZpGsqsyM2IjMIrs1 41nAf6aban0+QnUVySIFFCLjG7/IyMgQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAgP9C0UeAdgfvXfERoOPlA2ljv9+f/fK7be+5D4ofiD9o678of6RbNghA4PN9 aFflu8HeOrl/+jR+/tabrq6+1P74Qbu8/PQh1F+0f/7my/JmQHA/EIjCH4HPYw77GvSfLwHfgv36 +qcx/DyE3ctnc5vbb3/30Pb+KvylT40flH8O//LwenP+8RzmJ89elvCrEC4uviptIDAPAF7UAcAc /EIfgc8jDfrPjiG/++RZ3G/P4+X5Nh12L+OwP43TR9f1vZfhR/vrt9rfn/kE+YH45uHVt5uLetBc he7VRVlt7sr65Fm52p7nzfm2nPz6ZWnh/0WbBRD8CHwejxLfhP1lvLq8SjdXN+knF4e0O3mWzreH tN8M6fRuStOTVZzGVcxjH8/PQ5jGnXbID0rXn5TtNoTUj6Xrh9LdDuXutMub/Spvz9f5ZPcy/+v1 Op9dnuXLq8v8xeXV26Ev8BH4vM929HwO+5//+mV69ef7dHn+cXpd+7XVcNOvY+r6ELt9jPPzOOS0 WXUx5xTz1MWSB+2QH9YBk1YldVNJKZf9MJV+lfIYyrQpZWrPh5KnYXU2Pq3j4avt7/JHX2/yrz55 lpfQf15U+Qh83lMbqn3P5y9Sq+x/e/qP3Uf9puvHsz7ldZ83Y+3K+r70Uy3pa96XsR/rQCDF0JX6 bykp9nmqz2P9OyufJh+4IcTYlzF1JcZc4pRLLmHqa7CHWMv9NI1x7OqQeBzTvq/Ph3Hsb8ZX4376 2d3fTkul/3k2tY/A5z1YpvI/+yykq8tPU61Iurw9rMrJtJpu0zp3ab3adJvaQ637GNZlGNehT31q 75u6lOt/Xck18KO2yA+j062tfYqpLI1/yrmF/ZjHuOoPYwmHemwchv20T1M+dE/yIe66IZ2vh9f1 fZdXX+YvvgjZ1D7/Eb2PgP+0zz+N179+GW/CTQqXZ93TWtkfbvfrbl1OVn13MozDaYzxNJe0SV2/ KeNUBwKxj2lO/JRjSiXkOfA7nyYfqOmhymphH2uzr2Ffq/swlTF2/SEPeR9i3k+l3G02qy6PU6qD 5rCu4+Qa9vnm6qacXP+0hM+fxfBCdY/A5x0XK626/zx8Gr785Fn8ye5lmobQ59pb5bFW9jXs81TO UujOUixntbR5Uvu305LiJoWyyqGFfu5Cre670MUW+iX5UPkwpbyEfQ6l1C9Kq+zrcTDmFIf6cl/H vXddiLd1YNzndnq/X4dhqoOCfsyrYZ9/cnHIu8tnuV3q+uLNxlWCH4HPu9Ous9+f/l0M5yGdjXdd O2e/2uRNq+xb2NdO7qKE8Wks+byFfk32Wu2HTe39+hJKX3uuVGKr8Gva52Jqnw90eBxLK+hjqM+l 5X0c63HQFq/Uyj7ehZJvSyzrGLrUfjyMNeg3qykNaVx3w3hz8iy1S1yv7v4hCnoEPu9YWzD8y3D9 9z+Nl5fblLeH1J3ELvdTq97XbRq/VfYt7EuJH4WYntbi5qL2d09qp7epv107t7kN1qRPrR+sY4EW +DKfD+9YibH+U1Jt9qU18pr1NexjPNRv7muzv63Hx3UN+i6msR4QMdd3jXVUcEj9dOhDHNqlrU/P t+n665/m8Pyr42J9xwoCn3flnz6N4ecvw+Grl3HarFMX+249dX3f53U7Z79U9K2yT09rf/ej+htP a9d3Xkudkxb6S5UfutiCvtTuL+rB+CDL+7a+dQ77Mq90jVMd345z2MfYNqLY1G939Tip49481edD LfN3dRi8jvV42vdjN22G1O1u5h0r5+NOlY/A511q5xO/fPksdvtdPIuHlM9WXbv0rgx5PS/QC9Np C/25sp/DvvyodnZ1ABCe1P5qU7/frsWrHV2ce8R5St95fD40ec785fr5OfPnuf1hns4P4XY5tTVn +BRSrN/Ld6nrNu2qlnpA9G3/ivXdlG7KaZxensTlPD4IfN5ZyfJG2y53Gs/jNOSUQupSn/q2Gr8t 0Gvn7Ns0fqvs57CvwV8fNfDDSQ36VZwX58c0T+cvJb4qnw9KWcJ+Pn9fm3gOy6L9oT52rR+Oy2hg DK3iz/G0vmkT8jRfwjqOocv1uOraDpV924765PePQ5U+Ap8/tbZS+NP5Rjib84/DNI5xsyo1+EM3 X2ffxX5ejV/CZj5nX1rAz0HfHmd1AHBSu7l1WK7GS/E47xms2+ODGx3P59vvd8ibA7+2/0Ns0/iL sf5kF2Nb21I29WBYlfn4abNfoVv1XdwPdajQXy43nqrH2/FOlMIegc+7Md/i9vTH841wbseLmLsp 1o4q5immdp19u/TueJ5+PZ+zb9P4tUQ5hn2rZFaxlNoO5wvyYvjOrXXhwyr02zn8MF+LEsfa7rsS 5tq+Vfv7ZSFrHQDH2NcRwcPmVPVdMdffyGMX23H2f8PDraUdKAh83o92I5z9rott6VFJU2qb6rTr 7I+X3s3BP5+zn6fxy/oY9uvabbWfpTD3fnMtpMTnA6vw27n7Y6k/7zJVUpvbb5vu1e8eluOiTe2X NjhuU/xdaZtS1f9CHUG3ZXzt+Mp7nyUCn/eo3c/+dfhqvutdWbbQi+26+raD3rzyfr7sLrTrkdr0 ZRfvn1tlv4T9/HU4nr6X9nyYqV+WKj+GaRnVtmvxl7b/5tiIad6XYhkNzNtO11+LY85xGqd5/+l2 vN2Ff/B5IvB5h57Xxxf3X7T72b+aX7Ub4ZTjznnzDnrLpjoxLovyWqjPA4B5Gn9Zk98dBwQxmqXk A1XCW+erloae7o+F4+WocT4E6nGTSopTmOJy9f54HDPfH2dvHX/Pfa4IfN6rdqVdPnZyxx304nKd /XIx8vwiHru9OC9dXno6C/T5cAv8h1n9N+3+eHH+fduPy3GSwv29Jd4cT5MPEIHP49XK9nkpXj6G fOvg8nLp3XKXvXB8He9XMd9/Hz7EyC8P7XxZsH9f1S+b76V5z915Cj/MK/asyuO/li1OeGf1zX2L e/tSewv0+CF60+6PW0+k3ztOQOADAAIfABD4ACDwAQCBDwAIfABA4AMAAh8AEPgAgMAHAAQ+ACDw AUDgAwACHwAQ+ACAwAcABD4AIPABAIEPAAh8ABD4AIDABwAEPgAg8AEAgQ8ACHwAQOADAAIfAAQ+ ACDwAQCBDwAIfABA4AMAAh8AEPgAgMAHAIHvIwAAgQ8ACHwAQOADAAIfABD4AIDABwAEPgAg8AFA 4AMAAh8AEPgAgMAHAAQ+ACDwAQCBDwAIfAAQ+ACAwAcABD4AIPABAIEPAAh8AEDgAwACHwAEPgAg 8AEAgQ8ACHwAQOADAAIfABD4AIDABwAEPgAIfABA4AMAAh8AEPgAgMAHAAQ+ACDwAQCBDwACHwAQ +ACAwAcABD4AIPABAIEPAAh8AEDgA4DABwAEPgAg8AEAgQ8ACHwAQOADAAIfABD4AIDABwCBDwAI fABA4AMAAh8AEPgAgMAHAAQ+ACDwAUDgAwACHwAQ+ACAwAcABD4AIPABAIEPAAh8ABD4AIDABwAE PgAg8AEAgQ8ACHwAQOADAAIfABD4ACDwAQCBDwAIfABA4AMAAh8AEPgAgMAHAAQ+AAh8AEDgAwAC HwAQ+ACAwAcABD4AIPABAIEPAAIfABD4AIDABwAEPgAg8AEAgQ8ACHwAQOADAAIfAAQ+ACDwAQCB DwAIfABA4AMAAh8AEPgAgMAHAIEPAAh8AEDgAwACHwAQ+ACAwAcABD4AIPABQOADAAIfgD+RfHzM is8DgQ/woYgPyV5CiXF5XWJ9eXxdBwCTjwmBD/BBxP5D6Ie3gv7h9YPBR4XAB/j+Kf9G6N+n/fLc ZgBiTP/G/P43b14+90ki8AEeedD/kYp/ru5juY/++mUN/v47v/jP4V98lAh8gO9N9h9jPC5Vfinz d1rA1+ca9O0x1Sq/TejHtCp3uxMr+hD4AN+7xG/BPv+3iKWV86Hk4+K9mFv410fK9c27+jvbsNpc zKF/efmp8EfgAzxqcwW/VPXL6/l8fW4Vff1urj/KLe5jqo+pfm/MJXVTSf1JufrOH/qF0EfgAzzO ur4cp/LbnH05lvoht7q+yktdH3IuuSo16GPu6mN/WJeuBn64ugqb84/Ld6cKQOADPLLi/ljZzyvx 0/2WO/WLNMUQpvqD+TkdH1OOeagVfr9KuevH0q0vBDwCH+ARR/13g7pN3ofjKfs59EvbZ6cGfj4+ 10epoV+mGvQpp8NUutuhrDbPysmzl+WFDxSBD/BolWUqfz5vP0/d1xe5Rv/UAr++HkOMYwllrF1z e55Dfyrr6bDq8nb1pKxP7kr4Vf1Lf/OlSp9/t95HAPAOsn4p9Jez9DHNi/PmKfwYWsAP9Wf1EYaQ 41BLsaHkGvolT10ecsyrnA9D2YyXZXNxWX/tqzBv0AsqfIDH4mE6f7kMr63ID/PeOm36flweZYjt UcIhhnSotf0YUhxK7MY6KphWm10+ebLJ/yf8n+UvPfepIvABHl91H5fp/GXR3hL28xR+qNV8iDXk 46E+7+v36+vlUd8xruI0jjXw92Ofv93sS396XS4vr4pL8viPMKUP8CfP/CX023n7sKzMn+pXY5vC L3PY5/pI+/qufSnToaT2vWkoaTWuyzilwyoP+13ZfPTx2wv2hD4qfIBHU94fq/vlIvzwZio/tmn8 Vs2XfYlxV9+6TyXuYoz7+r1DLP2hDLXCz2W6O73JZx+d5JNfvywW7CHwAR6V+/vcz9X9sbJvO+fO 5+3nsK9jgH2oYV/f2fbOvSsx79rXKaZ9W7xX4jQOT8p0ln88fXV1Uy4u/ros5+8t2OPfz5Q+wJ+o uF/+SXmezJ8r+zjWcG/3w5nP2ddKfldKroEf72qG34Va4edYBwElHrpVHRDEs+GkbKfr3at8dnmW L8OV6h4VPsCjqu7j/T3x7sN+3kxnXpFfX7cFejXg6yPE2xjLbazPdVxwl2q1n2LexykNeTeNh5Kn ++n85fz9L9661x4IfID3F/YPe+bPaf9w3j7GY2W/nLM/hn24ySHd1K9vQ9em9afdFLt97IdhrNX9 Wc5vpvNffFlM5/MfZUof4L867Jdr8eZz9nHeNjfO5+1rVtfKPt7lku/DfhtLuanDgps8V/n9bc55 l1I4xDENZ2kz3pWn09nlnel8VPgAjzXsw/G8fS3zh3mBXlucl/NdfedNfWxjiNtS6iPGm5j7mzal 36ewS6UcSjeMQy7TxfU3y3T+vDrfdD4CH+ARhX2bxo/3O+kNtZLf13BvK/FvSww3JaVtCfG6DgLm R63yt/XXbts5/Sn1+y6HQzp0w92Up6vLs/zJJ8+y1fkIfID3649U9u0mOO2c/TyNvyst7FtlX4M+ 5nJdfz4/Ugrb0nW12s+3uRt2fZz2t5tuaNX9jw/TZLEeAh/gvVf19xvrvLnO/q2wn1fjl7YaP5Tb NoVff6eGfHgdY3kV5kd43Sr9OE11INDdrqa424d8GG+H8TvVvcV6CHyA9xX0ZXkuy+1u4zyFH++D vlX2raq/q+OB2/q8nSv6mGvAh1e5hFf1t16XKV+XUrYxTrelVvdj7Pdh6Ian3W58qO7/5nN75yPw +T459ld5vk7p4ZqlaIqS703I/xtBf3/JXW43wyn319i/Ffbhphyr+trYX9VBwbextEd5FVMN/di/ Ti3wQ7rN47JYL5z0w66Mb527/2U4VveOFf5TXJbHn0xbsdRuBBpi7eLatGd52IzkTZVUwnGb8eMN xd7cShTe7+D0D793vLL+fkOdWAv1UubKPpbjAr0W+HFejV8j+rZ+f1tb9Bz2dZjwsj6/rO/5NnXx 25DTqxzy9ZTiTZ/z3RCH/dnUHe5OduPt9i+mn12d5hef/c8SXrTq/rnjAoHPY9SKnO5YwdeaZT6l me53HDveIvS4A9lxN7J4/GFUxPCoor810fjWILXcL5ybz9nHZc5qvqd9me9pv4T9vIlOjPM5+xjj q/qzb1vYxznww8vcKv0a9l3fbXPZ3+a+263Ks30dE4w//k2aVte/yV988qyE579w7h6BzyPwvD4+ u//im/pYLd1i7EsrflrY56UCmjvKeR6/PsWHG4nUR7tdaJwnA1q3FnVuPJrqPrY5qfhWed/a8ltt d95QZ267Q1luhtMW6O1q+76t37upj+t2nj6k8G2r6uvw4GUo+dsSu2/DVF6XmK7TkG9LWt8N67v9 ehuGfH4xXl2G/OnlWf7Vm4V6RsEIfB6Hfw7/Ev5bOAtdf1LGsZY7aanaU445pFwjvsyV0LKoKTw8 avKPtU9ND/P5x2JKScO79gdrScrb6V/m01FvD1Rr1T6Wcl/Zt1vchuM0fmk3wblZVuOX65Diq/qe b+tfeJVSfJlL9yrkUiv+Wt1P+aZLJ7cx7fY5nB/G/nTchbvp8urL/OKLcFyoZyofgc8jtN2GsNlM Nd1r5zjVuE9Tzvc7jbV9xEsca2c4LBVRPMRSutaLxuVSptTivs3uS3veU+y/Cdf4nY105lX4NbRb 0LfzU9MS9vP5+vk6+1bZh5huv3P5XYyvY1uRH0oL/Vcl5ld1CDxX9i3sU+luh/hqvy/9Ib/ajbfd 76afXf1t/uLy0/rnPjfuReDzuFzWzum329+FbzcXpdb3JaXWFcaSupBzCVMt38f6PNaOcr73d1zu EtYqoW4p6Odp0a52bmk5lW9an/fhrUV5999YZp7yvNw0zgvz2sB0PD7msK9v2c/3so/tpjelbZd7 U1txDfw8r8yvI97XMaZXIaXXbYFePT623dTe191N/e3uNPX7u9tu+B/dn41ff32Xv/jk6u0b5Kju Efg8Fm3K8UXcnH9cn69C15+X/VDDPvTLtP1Uwz7F47nNsg9x2Vr0vt0tNxWZL2FqK/xSOYb9XPTD u9LOxsf01qWiD5X+sjgvHi+9a6tP41LZzzNUcZnGXy6/i7WyL23b3G1t13OFv2yZ29XQH7ddStd5 ijf1oLgdQ7nbbMKuVfZ3FzXs9zXs/+I3+ZPzZ8fz9s/tqIfA59GVRA/B3L26KF0teOLZSU5DmPKY x9j1NcynFvR3tUe9rW/e1E6wP+Z5q5Jqh1lW9Q91cc75NgYo4p53br60Pt4H/VLtHy+5a+tP2jX2 Nexbm43zKala8S+VfSm1um+3uW3b5sab+ie2JZebFLrrOozd5jjddKXf1iPitsv5Lqzj3brb7K+H myHfvhX2L5/lFy++dN4egc/j1fb4/vmzl3PXd9etc1c7xnXsx9jnQx7yPqZUwz7fhpjaIqYuLhfe jcsCp7ipX/bHCr/lfZzP5MO71LYfK/HNzlBL/JfjQr5c5sCfK/yh/qjNWB1KyXWwOs9YtUV6x8Cf b35zU9v8zZTzTf2t27ahTkhtU51pN3Zpl4ZyGLuXQzf992HbddPXXy+V/Zuwtw8FAp/Hqt2y8+9/ GtafPCt5e8jdSZ5ymsaxxEMtjvZdiLe1L13XzrCbT9PP0/hlXyukVu2v41LxpznsY33nfOWTzOdd KmHeGCqH+3FnifNlpHE+d9+uMpmvtY9xmBedlnCoj319XYe56a7+eFffd5vico/7OkS462JqN8q5 q0Pc3WE/7Puw2p9swqEeI+O4C+Or8X9PP7v726lda/8rYc87omflP9l+nsfPPgvpt6d/123Ot6uz 8W7TDacn0yqfTeNwnkJ3Uauci5DGp7X7PA8pPqkd62kN+027YD88BH4L+vZUtEneU2tugXus8Muy hW4KqQZ+W3+alitMSqvwy6F+XQetZV+HArvapnc5T7u+6+7KVF93024apn2fTnZdHRzspnAom9Uw rIbxaQjT6/q4vLrMX1zeL9Bzzh4VPt8TbaX+VdiWk93LfOjW0yaN47Av+81m1eWppFYgpXbb0JgO tUO9q2XTJsWwql1rC/uubcWTSortqid3d+C9aDlflutGlkK/tEn+nFM57h9Rjgv2lgo/hXyow4BD bbn7XHIN97yvb9hPfbfvUtivUm3r9TBo++Kva1V/d7ubbtrNcK4P0+XFV+WLz+r/8c0uesIeFT7f B7Ui//xF+vmvX6Z/vVh3Z5dn/dPXYX0I+023LiepX58M43AaYzytob5JXdqUaVqHLtawD13JKdWe NS1789xvyAvv1vRQ5KclfHMbhtZWmWJOx3P48x7R7Tx+ikMdCgypdIeQp2HsS9tT4hCnNNTWXYM+ DaUbxqltpHN1NT29vJyr+nbnu1893OpW2CPw+T4GfvjlPK1/dflpelozO28Pq3IyrabbtM5dWq82 3aZWTeua8OsyjOvQpz61901dyvW/mvqx2G+Hx9Ipts0havC3s/epi21RSm2k07J4b8xjH7uxFv1j aNej1OddDfiTNI45rcaHoK/vbdP3V9vf5Y++3uSLh6q+/R9M4SPw+d62obYx2Iv02dVl/O3pP3Yf 9ZuuH8/6lNd93oyrlPu+9NMq5q4PZezHGvYp1uq+/lu71NjnKbbdeu734of3Y1juA1GNdRjavm7b Q9civ+SwnlIecy38W/JPq/ooNeDHfDPlbjOe5jIN9bG9e5VbRX+1Pc8f/cVv8sX/qkHfds5T1SPw +XDa0fMYPv80tqn9V3++T5fnH6fXNdhXw02/jqkmfez2Mc7P45DTZlVLp9aVTl0sedAOeTyNOa3m QK5VfUkpl/2wqs9THbMe8mFIefOkTPuxzy3k7/arfPLkOu/Kn08X19/k355el4eK/g+DXtgj8PkQ LFP7LfRbpX91eZVurm7STy4OaXfyLJ1vD2m/GdLp3ZSmJ6s4jbXgH/t4fh7CNO60Qx6Vu91JDeZt SP1J6fqhdLenZVuf109Wud8eyvZ8nU92p3n9zV25+tF53pxvSztH/4dB/9DNCnoEPh9SW2p92n3o fxmvr38ad588i/vtebw836bD7mUc9qdx+ui6vvcy/Gh//Vb7+zOfII/ANw+vVpuLchXaLpK7snx9 V9Ynz8rm6qa0Sr5tKf2dkG97Ujxv71TRI/D5AQb/5/XV1TH8w89D2L18Nre5/fZ3D23vr8Jf+tR4 NNrtnt+23CsihBbu7fni4q/L5eVVabtMfjfkVfMIfH6woR+W4G9ap/hPywDgXhsI+Kh4rC7n29Qu lnBvt6z95dKWg5BH4MMfaWO/3x/+8rtt77kPikfgD9rhL8r/p8sU8gh80O74gAh2AAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgO+l/yfAALvFiBhRTaas AAAAAElFTkSuQmCC",
    transform: "matrix(0.24 0 0 0.24 119.56 324)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M192.39,406.77H51.35c-4.42,0-8-3.58-8-8v-66.62c0-4.42,3.58-8,8-8h141.04c4.42,0,8,3.58,8,8v66.62 C200.39,403.19,196.81,406.77,192.39,406.77z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.6542,
    y1: 331.8989,
    x2: 187.6542,
    y2: 345.8836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M191.32,334.84h-0.17c-0.5,0-0.75-0.61-0.4-0.96l0.12-0.12c0.22-0.22,0.22-0.58,0-0.8l-0.45-0.45 c-0.22-0.22-0.58-0.22-0.8,0l-0.12,0.12c-0.36,0.36-0.96,0.1-0.96-0.4v-0.17c0-0.31-0.25-0.56-0.56-0.56h-0.64 c-0.31,0-0.56,0.25-0.56,0.56v0.17c0,0.5-0.61,0.75-0.96,0.4l-0.12-0.12c-0.22-0.22-0.58-0.22-0.8,0l-0.45,0.45 c-0.22,0.22-0.22,0.58,0,0.8l0.12,0.12c0.36,0.36,0.1,0.96-0.4,0.96h-0.17c-0.31,0-0.56,0.25-0.56,0.56v0.64 c0,0.31,0.25,0.56,0.56,0.56h0.17c0.5,0,0.75,0.61,0.4,0.96l-0.12,0.12c-0.22,0.22-0.22,0.58,0,0.8l0.45,0.45 c0.22,0.22,0.58,0.22,0.8,0l0.12-0.12c0.36-0.36,0.96-0.1,0.96,0.4v0.17c0,0.31,0.25,0.56,0.56,0.56h0.64 c0.31,0,0.56-0.25,0.56-0.56v-0.17c0-0.5,0.61-0.75,0.96-0.4l0.12,0.12c0.22,0.22,0.58,0.22,0.8,0l0.45-0.45 c0.22-0.22,0.22-0.58,0-0.8l-0.12-0.12c-0.36-0.36-0.1-0.96,0.4-0.96h0.17c0.31,0,0.56-0.25,0.56-0.56v-0.64 C191.89,335.1,191.63,334.84,191.32,334.84z M187.65,337.24c-0.83,0-1.51-0.68-1.51-1.51c0-0.83,0.68-1.51,1.51-1.51 c0.83,0,1.51,0.68,1.51,1.51C189.16,336.56,188.49,337.24,187.65,337.24z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 57.32,
    y1: 347.74,
    x2: 190.39,
    y2: 347.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 57.32,
    y1: 352.18,
    x2: 190.39,
    y2: 352.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 57.32,
    y1: 356.61,
    x2: 190.39,
    y2: 356.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 57.32,
    y1: 361.04,
    x2: 190.39,
    y2: 361.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 57.32,
    y1: 365.47,
    x2: 190.39,
    y2: 365.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 57.32,
    y1: 369.9,
    x2: 190.39,
    y2: 369.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 57.32,
    y1: 374.34,
    x2: 190.39,
    y2: 374.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 57.32,
    y1: 378.77,
    x2: 190.39,
    y2: 378.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 57.32,
    y1: 383.2,
    x2: 190.39,
    y2: 383.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st133",
    x1: 57.32,
    y1: 387.63,
    x2: 190.39,
    y2: 387.63
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st66",
    cx: 61.07,
    cy: 397.85,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st66",
    cx: 75.45,
    cy: 397.85,
    r: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M91.58,397.85c0,0.97-0.78,1.75-1.75,1.75c-0.97,0-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75 C90.79,396.1,91.58,396.89,91.58,397.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M105.96,397.85c0,0.97-0.78,1.75-1.75,1.75c-0.97,0-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75 C105.17,396.1,105.96,396.89,105.96,397.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M120.33,397.85c0,0.97-0.78,1.75-1.75,1.75c-0.97,0-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75 C119.55,396.1,120.33,396.89,120.33,397.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M134.71,397.85c0,0.97-0.78,1.75-1.75,1.75s-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75 S134.71,396.89,134.71,397.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M149.09,397.85c0,0.97-0.78,1.75-1.75,1.75c-0.97,0-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75 C148.3,396.1,149.09,396.89,149.09,397.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M163.47,397.85c0,0.97-0.78,1.75-1.75,1.75c-0.97,0-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75 C162.68,396.1,163.47,396.89,163.47,397.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M177.84,397.85c0,0.97-0.78,1.75-1.75,1.75c-0.97,0-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75 C177.06,396.1,177.84,396.89,177.84,397.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M192.22,397.85c0,0.97-0.78,1.75-1.75,1.75c-0.97,0-1.75-0.78-1.75-1.75s0.78-1.75,1.75-1.75 C191.44,396.1,192.22,396.89,192.22,397.85z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2947,
    y1: 332.3154,
    x2: 75.2947,
    y2: 349.2677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M54.82,339.78l0.53-1.18c0.57,0.42,1.42,0.71,2.23,0.71c0.93,0,1.3-0.31,1.3-0.72 c0-1.27-3.93-0.4-3.93-2.91c0-1.15,0.93-2.11,2.85-2.11c0.85,0,1.72,0.2,2.35,0.6l-0.48,1.19 c-0.63-0.36-1.27-0.53-1.87-0.53c-0.93,0-1.28,0.35-1.28,0.77c0,1.25,3.93,0.39,3.93,2.87c0,1.13-0.94,2.1-2.87,2.1 C56.5,340.56,55.42,340.24,54.82,339.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2947,
    y1: 332.3154,
    x2: 75.2947,
    y2: 349.2677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M64.76,340.19c-0.31,0.22-0.76,0.33-1.23,0.33c-1.23,0-1.94-0.63-1.94-1.86v-2.13h-0.8v-1.16h0.8 v-1.27h1.51v1.27h1.29v1.16H63.1v2.12c0,0.44,0.24,0.69,0.65,0.69c0.22,0,0.44-0.07,0.61-0.19L64.76,340.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2947,
    y1: 332.3154,
    x2: 75.2947,
    y2: 349.2677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M70.21,337.48v2.96H68.8v-0.65c-0.28,0.47-0.82,0.72-1.58,0.72c-1.22,0-1.94-0.68-1.94-1.57 c0-0.92,0.65-1.55,2.23-1.55h1.2c0-0.65-0.39-1.02-1.2-1.02c-0.55,0-1.12,0.18-1.5,0.48l-0.54-1.05 c0.57-0.41,1.41-0.63,2.24-0.63C69.29,335.17,70.21,335.9,70.21,337.48z M68.7,338.8v-0.53h-1.03 c-0.71,0-0.93,0.26-0.93,0.61c0,0.38,0.32,0.63,0.85,0.63C68.1,339.5,68.53,339.27,68.7,338.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2947,
    y1: 332.3154,
    x2: 75.2947,
    y2: 349.2677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M74.93,340.19c-0.31,0.22-0.76,0.33-1.23,0.33c-1.23,0-1.94-0.63-1.94-1.86v-2.13h-0.8v-1.16h0.8 v-1.27h1.51v1.27h1.29v1.16h-1.29v2.12c0,0.44,0.24,0.69,0.65,0.69c0.22,0,0.44-0.07,0.61-0.19L74.93,340.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2947,
    y1: 332.3154,
    x2: 75.2947,
    y2: 349.2677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M75.59,333.68c0-0.47,0.38-0.84,0.94-0.84s0.94,0.35,0.94,0.81c0,0.5-0.38,0.87-0.94,0.87 S75.59,334.15,75.59,333.68z M75.78,335.25h1.51v5.2h-1.51V335.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2947,
    y1: 332.3154,
    x2: 75.2947,
    y2: 349.2677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M78.19,339.96l0.5-1.08c0.46,0.3,1.17,0.5,1.81,0.5c0.7,0,0.96-0.18,0.96-0.47 c0-0.85-3.14,0.02-3.14-2.06c0-0.99,0.89-1.68,2.4-1.68c0.71,0,1.51,0.16,2,0.45l-0.5,1.07c-0.51-0.29-1.02-0.39-1.5-0.39 c-0.68,0-0.97,0.21-0.97,0.48c0,0.89,3.14,0.03,3.14,2.08c0,0.97-0.9,1.65-2.45,1.65 C79.56,340.52,78.67,340.28,78.19,339.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2947,
    y1: 332.3154,
    x2: 75.2947,
    y2: 349.2677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M87.17,340.19c-0.31,0.22-0.76,0.33-1.23,0.33c-1.23,0-1.94-0.63-1.94-1.86v-2.13h-0.8v-1.16H84 v-1.27h1.51v1.27h1.29v1.16h-1.29v2.12c0,0.44,0.24,0.69,0.65,0.69c0.22,0,0.44-0.07,0.61-0.19L87.17,340.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2947,
    y1: 332.3154,
    x2: 75.2947,
    y2: 349.2677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M87.84,333.68c0-0.47,0.38-0.84,0.94-0.84c0.56,0,0.94,0.35,0.94,0.81c0,0.5-0.38,0.87-0.94,0.87 C88.21,334.52,87.84,334.15,87.84,333.68z M88.02,335.25h1.51v5.2h-1.51V335.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2947,
    y1: 332.3154,
    x2: 75.2947,
    y2: 349.2677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M90.54,337.84c0-1.56,1.21-2.67,2.9-2.67c1.09,0,1.95,0.47,2.33,1.32l-1.17,0.63 c-0.28-0.49-0.7-0.71-1.17-0.71c-0.76,0-1.36,0.53-1.36,1.44c0,0.91,0.6,1.44,1.36,1.44c0.47,0,0.89-0.21,1.17-0.71 l1.17,0.64c-0.38,0.83-1.24,1.31-2.33,1.31C91.75,340.52,90.54,339.41,90.54,337.84z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.6339,
    y1: 353.7965,
    x2: 123.6339,
    y2: 391.423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5070FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    style: {
      stopColor: "#3348A3"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M190.27,354.17c-4.78,0.07-9.29,2.72-13.16,5.42c-4.41,3.07-9.08,6.49-14.65,6.7 c-5.91,0.23-11.11-3.22-15.82-6.43c-4.71-3.22-10.07-6.54-15.96-6.01c-6.1,0.54-10.71,5.02-14.78,9.13 c-4.07,4.12-8.92,8.47-15.05,8.64c-9.63,0.26-16.33-9.83-25.94-10.45c-3.75-0.24-7.49,1.06-10.5,3.09 c-3.01,2.03-5.36,4.74-7.41,7.57v18.72h133.27V354.17z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.1155,
    y1: 360.9875,
    x2: 125.1155,
    y2: 398.6283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M190.27,377.36c-7.55-3.38-14.17-18.5-14.17-18.5c-2.12-4.05-7.77-4.63-10.7-1.1l-10.89,13.18 c-1.65,2-4.66,2.27-6.66,0.6l-5.82-4.87c-2.08-1.74-5.2-1.47-6.94,0.59l-5.82,6.89c-1.72,2.04-4.86,2.15-6.73,0.24l-8.66-8.85 c-5-5.11-13.59-4.08-17.19,2.06l-4.96,8.44c-1.26,2.15-4.28,2.5-6.01,0.69l-0.15-0.15c-5.55-4.63-13.97-3.43-17.95,2.55 l-7.63,11.45h130.3V377.36z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1777 -0.9841 0.9841 0.1777 255.5316 439.5839)",
    className: "st6",
    cx: 390.8,
    cy: 66.89,
    rx: 22.59,
    ry: 22.59
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.0883,
    y1: 41.8735,
    x2: 391.0883,
    y2: 76.4156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M401.02,72.19l-2.31-3.47v-4.47c0-3.69-2.7-6.75-6.23-7.33v-1.89c0-0.77-0.62-1.39-1.39-1.39 c-0.77,0-1.39,0.62-1.39,1.39v1.95c-3.35,0.72-5.86,3.7-5.86,7.26v3.92l-2.68,4.02c-0.47,0.7,0.04,1.64,0.88,1.64h18.1 C400.99,73.84,401.49,72.9,401.02,72.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.1319,
    y1: 69.2763,
    x2: 391.1319,
    y2: 78.4549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M388.47,75.28c0.1,1.39,1.25,2.49,2.66,2.49c1.42,0,2.56-1.1,2.66-2.49H388.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.4485,
    y1: 35.6944,
    x2: 409.4485,
    y2: 55.4189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st132",
    cx: 409.45,
    cy: 45.56,
    r: 9.86
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 405.8115 49.7988)",
    className: "st6 st104 st148"
  }, "3")))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 436.09,
    cy: 126.68,
    r: 22.79
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.0867,
    y1: 116.8672,
    x2: 436.0867,
    y2: 135.8047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.009437382,
    style: {
      stopColor: "#02CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1967,
    style: {
      stopColor: "#1EACFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    style: {
      stopColor: "#3492FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    style: {
      stopColor: "#447FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#4D74FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M436.65,119.05l-0.56,0.56l-0.56-0.56c-2.35-2.35-6.16-2.35-8.52,0l0,0c-2.35,2.35-2.35,6.16,0,8.52 l9.08,8.51l9.08-8.51c2.35-2.35,2.35-6.16,0-8.52h0C442.81,116.69,439,116.69,436.65,119.05z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.358,
    y1: 96.4885,
    x2: 454.358,
    y2: 116.3855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2202,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5070FF"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st135",
    cx: 454.36,
    cy: 106.44,
    r: 9.95
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 450.6875 110.7158)",
    className: "st6 st104 st151"
  }, "3")))), /*#__PURE__*/React.createElement("g", null, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 461.5,
    cy: 56.49,
    r: 24.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.5855,
    y1: 69.5191,
    x2: 461.5855,
    y2: 34.8305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5070FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#3097FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7798,
    style: {
      stopColor: "#0DC0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D0FF"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M473.9,65.43l-5.79-5.79c1.08-1.66,1.71-3.63,1.71-5.75c0-5.84-4.75-10.59-10.59-10.59 c-5.84,0-10.59,4.75-10.59,10.59c0,5.84,4.75,10.59,10.59,10.59c2.18,0,4.21-0.66,5.9-1.8l5.76,5.76 c0.42,0.42,0.96,0.62,1.51,0.62s1.09-0.21,1.51-0.62C474.73,67.61,474.73,66.27,473.9,65.43z M452.91,53.9 c0-3.49,2.84-6.33,6.33-6.33c3.49,0,6.33,2.84,6.33,6.33c0,3.49-2.84,6.33-6.33,6.33C455.74,60.22,452.91,57.38,452.91,53.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileApPdevelopment);
export default __webpack_public_path__ + "static/media/mobileAPPdevelopment​.e4e1beb210680bfc2b3ca9818c54b42b.svg";
export { ForwardRef as ReactComponent };